const translations = {

    en: {
        locale: 'en',
        messages: {
            Errorcode_400: "Bad Request: The server could not understand the request.",
            Errorcode_401: "Unauthorized: Please check your credentials.",
            Errorcode_403: "Forbidden: You do not have permission to access this resource.",
            Errorcode_404: "Not Found: The requested resource could not be found.",
            Errorcode_422: "Unprocessable Entity: The request was well-formed but could not be processed.",
            Errorcode_500: "Internal Server Error: The server encountered an error.",
            Errorcode_502: "Bad Gateway: Received an invalid response from the upstream server.",
            Errorcode_503: "Service Unavailable: The server is currently unavailable. Please try again later.",
            Errorcode_504: "Gateway Timeout: The server did not receive a timely response from the upstream server.",
            Errorcode_ECONNABORTED: "The request took too long - please try again later.",
            Errorcode_NO_RESPONSE: "No response from the server, please check your connection.",
            Errorcode_unexpected: "The server returned an unexpected response format. Please try again later.",
            Errorcode_default: "An error occurred. Please try again later.",
            Errorcode_1111: "Error while processing data.",
            tooltip_email: "Please fill out your email address",
            tooltip_otp: "Please enter the OTP",
            tooltip_name: "Please fill out your name",
            tooltip_password: "Please fill out your password",
            tooltip_confirmpassword: "Please fill out your confirm password",
            tooltip_country: "Please select the country",
            tooltip_state: "Please select the state",
            tooltip_companyname: "Please fill out your company name",
            tooltip_uniquecompanyid: "Please fill out your unique company id",
            tooltip_uniqueuserid: "Please fill out your unique user id",
            tooltip_domainname: "Please fill out your domain name",
            selectlanguage: 'Select a language for sign up',
            signupOtpValidation: "OTP must be at least 6 characters.",
            selectsocialacc: 'Select a social account',
            zipcodeErrorMessage: 'Invalid Zipcode',
            completeSubscriptionProcess: "Complete Subscription Process",
            English: 'English',
            Hindi: 'Hindi',
            Spanish: 'Spanish',
            Arabic: 'Arabic',
            uploadprofilepic: 'Upload Profile Picture',
            uploadcompanylogo: 'Upload Company Logo',
            // setuplinkmsgOne: 'You are almost done, below is your JodoLink',
            setuplinkmsgOne: 'You are almost done',
            setupurl1: 'You are almost done.',
            setupurl2: ' Below is your customizable JodoLink',
            setupurlmesgthree: 'Please note that once this step is done, you can`t change your JodoLink.If you wish to change it, do so now before clicking on Finish.',
            setuplinkmsgTwo: '*Please note that Unique Company ID and Your Unique User ID once registered cannot be changed once this step is completed. If you wish to modify any of these names at this point please use the back key',
            or: 'or',
            language: 'Language',
            emailAddress: 'Email Address',
            enterEmail: 'Enter your email address',
            emailexist: 'You are already registered with us.',
            emailexist1: 'There is an existing subscription associated with this email ID.',
            signInTojodoToobar: 'Sign In To Jodo Toolbar',
            emailRegexValidation: 'Enter a valid email address',
            emailRequiredValidation: 'Email is required',
            emailMaxValidation: 'Maximum 100 characters allowed',
            emailMinValidation: 'A minimum of 5 characters are required.',
            enterotp: 'Please Enter OTP',
            resendotp: 'Resend OTP',
            otpRequiredValidation: 'Please enter the OTP',
            otpMaxLengthValidation: 'Maximum 16 characters allowed',
            otpMaxLength: 'Maximum 6 characters allowed',
            otpMinLength: 'Minimum 6 characters allowed',
            otpMessage: 'Please enter six digits OTP that has been sent to your mail',
            next: 'Next',
            signUpGoogle: 'Sign Up With Google',
            signUpLinkeIn: 'Sign Up With LinkedIn',
            jodoteam: 'Jodo Team',
            jodoindi: 'JodoLink Individual',
            jodolink: 'JodoLink',
            wordpress: 'Wordpress',
            yourInformation: 'Your information',
            otpverify: 'OTP Verify',

            signup: 'Signup',

            resendotp: 'Resend OTP',
            billingDetails: 'Billing details',
            setupJodoLink: 'Setup JodoLink',
            setupJodoTeam: 'Setup Jodo Team',
            setupDomainName: 'Finish Process',
            username: 'Name',
            lastName: 'Last name',
            setPassword: 'Password',
            confirmPassword: 'Confirm Password',
            //  designation: 'Designation',
            designation: 'Title/Designation',
            country: 'Country',
            state: 'State',
            city: 'City',
            zipcode: 'Zip Code',
            address1: 'Address 1',
            address2: 'Address 2',
            back: 'Back',
            finish: 'Finish',
            passwordRule1: '1) Your password must contain 8 Characters, One Uppercase, One Lowercase, One Number and One Special Case Character',
            passwordRule2: 'The password and confirmation password must be the same.',
            passwordmatchAlert: 'Password and confirm Passwords do not match ',
            passwordmatchSuccess: 'Password and Confirm password matched !',
            typeCityName: 'Type your city name',
            companyName: 'Company Name',
            taxNo: 'Tax No.',
            billingDetailsLocationMsg: 'Is your billing address same as provided in your information section ?',
            domainName: 'Domain Name',
            verifyBtn: 'Verify',
            uniqueCompanyName: 'Unique Company Id',
            uniqueURL: 'Unique URL',
            uniqueUserName: 'Unique User Id',
            firstNameRequired: 'First Name is required',
            firstNameSpaceValidation: 'You cannot use space at the beginning or end of a name.',
            lastNameRequired: 'Last name is required',
            twentyFiveCharValidation: 'Must be 25 characters or less',
            firstName_lastName_RegexValidation: 'Only alphabets can be used in a name.',
            passwordRegexValidation: 'Must Contain 8 Characters, One Uppercase, One Lowercase, One Number and One Special Case Character',
            confirmPasswordMatchValidation: 'The password and confirmation password must be the same.',
            passwordRequired: 'Password is required',
            confirmPasswordRequired: 'Confirm password is required',
            zipcodeCharLengthValidation: 'Must be 10 numbers or less',
            zipCodeValidation: "Invalid Zipcode",
            zipNumberVAlidation: "Only number can be used.",
            zipcodeRegexValidation: 'Minimum 4 numbers and Maximum 10 numbers allowed',
            addressCharLengthValidation: 'Must be 100 characters or less',
            companyNameRequired: 'Company Name is required',
            companyName_RegexValidation: 'Only alphanumeric characters and special characters [-, @, #, &,!] can be used.',
            orgAliasRequired: 'Organisation Alias is required',
            userAliasRequired: 'User Alias is required',
            aliasRegexValidation: 'Must contain alphanumeric characters. No special characters and space allowed.',
            domainNameRequired: 'Please specify the  domain name.',
            domainNameRegexValidation: 'Domain name must be of type https://www.example.com',
            loadingMsgOne: 'Please wait, your account is being created,',
            // loadingMsgTwo: 'till then you can read the docs/ watch the videos related to Jodo products' , 
            loadingMsgTwo: 'While your account is being created, read the docs and view the Jodo product videos',
            transformsales: 'Transform Sales',
            transformsupport: 'Transform Support',
            transformecommerce: 'Transform E-Commerce',
            emailAuthFailed: 'Failed to authenticate Email Address. Please try again later.',
            companyNameExistMsg: 'This company name is already registered.',
            companyAliasVerifiedMsg: 'Unique company name verified',
            internalServerErrorMsg: 'Internal server error. Please try again later',
            invalidOTPMsg: 'Invalid OTP',
            userAlreadyExist: 'User already exist',
            uniqueCompanyNameExist: 'Unique company name already exist !',
            uniqueCompanyNameVerified: 'Company name verified successfully !',
            uniqueCompanyAliasVerified: 'Unique company name verified successfully ! ',
            otpSendMessage: `Email Verification`,
            secondotpSendMessage: "OTP has been sent to your mail. Please verify your email box & junk mail / Spam mailbox",
            firstNameValidation: 'First Name should only consist of alphabets only',
            lastNameValidation: 'Last Name should only consist of alphabets only',
            serviceKeyNotFound: 'Service key not found',
            apiKeyNotFound: 'API key not found',
            apiKeyandServiceKeyNotFound: 'Service key and API key not found',
            otpValidationRegex: 'Only number is allowed',
            taxNo_RegexValidation: 'Only alphanumeric characters allowed',
            needhelp: 'Need Help',
            companyName_RegexValidation_2: "Only special  characters cannot be used for  company name.",
            companyNameLengthValidation: 'Must be 150 characters or less',
            designationLengthValidation: 'Must be 25 characters or less',
            designationFieldValidation: 'Note:Only "." and "-" are allowed  as separators.',
            addressValidation: "Please enter a valid address.",
            imageUploadMsg: 'Click here or drag an image',
            imageUploadMsgRemoveBtn: ' Remove',
            imageUploadMsgDoneBtn: 'Done',
            transformSales: 'Transform Sales',
            transformSupport: 'Transform Support',
            transformCommerce: 'Transform E-Commerce',
            uniqueCompanyID: "Unique Company ID already exist!",
            countryFieldValidation: "Country is required",
            stateFieldValidation: "State is required",
            alreadyacccreated: "Already have an Account?"
        }
    },
    hi: {
        locale: 'hi',
        messages: {
            tooltip_email: "कृपया अपना ईमेल पता भरें",
            tooltip_otp: "कृपया OTP दर्ज करें",
            tooltip_name: "कृपया अपना नाम भरें",
            tooltip_password: "कृपया अपना पासवर्ड भरें",
            tooltip_confirmpassword: "कृपया अपने पासवर्ड की पुष्टि करें",
            tooltip_country: "कृपया देश का चयन करें",
            tooltip_state: "कृपया राज्य का चयन करें",
            tooltip_companyname: "कृपया अपने कंपनी का नाम भरें",
            tooltip_uniquecompanyid: "कृपया अपनी अद्वितीय कंपनी आईडी भरें",
            tooltip_uniqueuserid: "कृपया अपनी अद्वितीय उपयोगकर्ता आईडी भरें",
            tooltip_domainname: "कृपया अपना डोमेन नाम भरें",
            selectlanguage: 'साइन अप के लिए भाषा चुनें',
            signupOtpValidation: "ओटीपी कम से कम 6 अक्षरों का होना चाहिए।",
            selectsocialacc: 'एक सामाजिक खाता चुनें',
            zipcodeErrorMessage: 'अमान्य ज़िप कोड',
            completeSubscriptionProcess: "पूर्ण सदस्यता प्रक्रिया",
            English: 'अंग्रेज़ी',
            Hindi: 'हिन्दी',
            otpverify: 'ओटीपी सत्यापित करें',

            Spanish: 'स्पैनिश',
            Arabic: 'अरबी',
            uploadprofilepic: 'प्रोफ़ाइल चित्र अपलोड करें',
            uploadcompanylogo: 'कंपनी का लोगो अपलोड करें',
            //  setuplinkmsgOne: 'आपका काम लगभग पूरा हो चुका है, नीचे आपका JodoLink है',
            setuplinkmsgOne: 'आपका काम लगभग पूरा हो चुका है',
            setuplinkmsgTwo: '*कृपया ध्यान दें कि एक बार पंजीकृत होने के बाद यूनिक कंपनी आईडी और आपकी यूनिक यूजर आईडी को इस चरण के पूरा होने के बाद बदला नहीं जा सकता है। यदि आप इस समय इनमें से किसी भी नाम को संशोधित करना चाहते हैं तो कृपया बैक की का उपयोग करें',
            or: 'या',
            language: 'भाषा',
            emailAddress: 'ईमेल पता',
            enterEmail: 'अपना ईमेल पता दर्ज करें',
            emailexist: 'पहले से ही एक पंजीकृत ग्राहक है.',
            emailexist1: 'एक ही ईमेल आईडी का उपयोग एकाधिक सदस्यता के लिए नहीं किया जा सकता है।',
            signInTojodoToobar: 'जोडो टूलबार में साइन इन करें',
            emailRegexValidation: 'एक मान्य ईमेल पता दर्ज करें',
            emailRequiredValidation: 'ईमेल की जरूरत है',
            emailMaxValidation: 'अधिकतम 100 वर्णों की अनुमति है',
            emailMinValidation: 'न्यूनतम 5 वर्णों की अनुमति है',
            enterotp: 'कृपया ओटीपी दर्ज करें',
            resendotp: 'ओटीपी पुनः भेजें',
            otpRequiredValidation: 'कृपया ओटीपी दर्ज करें',
            otpMaxLengthValidation: 'अधिकतम 10 वर्णों की अनुमति है',
            otpMaxLength: 'अधिकतम 6 अक्षर अनुमत है',
            otpMinLength: 'न्यूनतम 6 अक्षर अनुमत है',
            otpMessage: 'कृपया छह अंकों का ओटीपी दर्ज करें जो आपके मेल पर भेजा गया है',
            next: 'अगला',
            signUpGoogle: 'गूगल के साथ साइन अप करें',
            signUpLinkeIn: 'लिंक्डइन के साथ साइन अप करें',
            signup: 'साइन अप करें',
            jodoteam: 'जोडो टीम',
            jodolink: 'जोडो लिंक',
            wordpress: 'Wordpress',
            jodomeeting: 'जोड़ो मीटिंग',
            yourInformation: 'आपकी जानकारी',
            billingDetails: 'बिलिंग विवरण',
            setupJodoLink: 'सेटअप जोडो लिंक',
            setupJodoTeam: 'सेटअप जोडो टीम',
            setupDomainName: 'प्रक्रिया समाप्त करें',
            username: 'उपयोगकर्ता नाम',
            setupurl1: 'आप लगभग कर चुके हैं',
            setupurl2: 'नीचे आपका अनुकूलन योग्य जोडोलिंक है',
            setupurlmesgthree: 'कृपया ध्यान दें कि एक बार यह कदम पूरा हो जाने के बाद, आप अपना जोडोलिंक नहीं बदल सकते। यदि आप इसे बदलना चाहते हैं, तो समाप्त पर क्लिक करने से पहले अभी ऐसा करें।',
            lastName: 'प्रथम नाम',
            setPassword: 'पासवर्ड',
            confirmPassword: 'पासवर्ड की पुष्टि कीजिये',
            designation: 'शीर्षक/पद',
            country: 'देश',
            state: 'राज्य',
            city: 'शहर',
            zipcode: 'पिन कोड',
            address1: 'पता 1',
            address2: 'पता 2',
            back: 'पीछे',
            finish: 'खत्म करना',
            passwordRule1: '1) आपके पासवर्ड में 8 अक्षर, एक अपरकेस, एक लोअरकेस, एक नंबर और एक विशेष केस कैरेक्टर होना चाहिए',
            passwordRule2: '2) पासवर्ड और कन्फर्म पासवर्ड एक ही होना चाहिए',
            passwordmatchAlert: 'पासवर्ड और पुष्टि पासवर्ड मेल नहीं खाते',
            passwordmatchSuccess: 'पासवर्ड और कन्फर्म पासवर्ड का मिलान हुआ!',
            typeCityName: 'अपने शहर का नाम टाइप करें',
            companyName: 'कंपनी का नाम',
            taxNo: 'टैक्स संख्या।',
            billingDetailsLocationMsg: 'क्या आपका बिलिंग पता वही है जो आपके सूचना अनुभाग में दिया गया है?',
            domainName: 'डोमेन नाम',
            verifyBtn: 'सत्यापित करना',
            UniqueURL: 'अद्वितीय यूआरएल',
            uniqueCompanyName: 'अद्वितीय कंपनी का नाम',
            uniqueUserName: 'अद्वितीय उपयोगकर्ता नाम',
            firstNameRequired: 'पहला नाम आवश्यक है',
            firstNameSpaceValidation: 'अंतरिक्ष को शुरू और समाप्त करने की अनुमति नहीं देनी चाहिए',
            lastNameRequired: 'उपनाम आवश्यक है',
            twentyFiveCharValidation: '25 वर्ण या उससे कम का होना चाहिए',
            firstName_lastName_RegexValidation: 'केवल अक्षर होने चाहिए',
            passwordRegexValidation: 'इसमें 8 अक्षर होने चाहिए, एक अपरकेस, एक लोअरकेस, एक नंबर और एक विशेष केस कैरेक्टर',
            confirmPasswordMatchValidation: 'पासवर्ड और कन्फर्म पासवर्ड एक ही होना चाहिए',
            passwordRequired: 'पासवर्ड की आवश्यकता है',
            confirmPasswordRequired: 'पासवर्ड की पुष्टि करना आवश्यक है',
            zipcodeCharLengthValidation: '10 अंक या उससे कम होना चाहिए',
            zipCodeValidation: "अमान्य ज़िप कोड",
            zipNumberVAlidation: "केवल संख्या स्वीकार करें",
            jodoindi: 'जोडोलिंक व्यक्तिगत',
            zipcodeRegexValidation: 'न्यूनतम 4 नंबर और अधिकतम 10 नंबर की अनुमति है',
            addressCharLengthValidation: '100 वर्ण या उससे कम का होना चाहिए',
            companyNameRequired: 'कंपनी का नाम आवश्यक है',
            companyName_RegexValidation: 'पहला अक्षर अपरकेस होना चाहिए। अक्षरांकीय वर्ण और विशेष वर्ण [-, @, #, &, !] की अनुमति है',
            orgAliasRequired: 'संगठन उपनाम आवश्यक है',
            userAliasRequired: 'उपयोगकर्ता उपनाम आवश्यक है',
            aliasRegexValidation: 'अक्षरांकीय वर्ण होने चाहिए। कोई विशेष वर्ण और स्थान की अनुमति नहीं है।',
            domainNameRequired: 'डोमेन नाम आवश्यक है',
            domainNameRegexValidation: 'डोमेन नाम प्रकार का होना चाहिए https://www.example.com',
            loadingMsgOne: 'कृपया प्रतीक्षा करें, आपका खाता बनाया जा रहा है।',
            loadingMsgTwo: 'जबकि आपका खाता बनाया जा रहा है, डॉक्स पढ़ें और जोडो उत्पाद वीडियो देखें',
            transformsales: 'बिक्री को रूपांतरित करें',
            transformsupport: 'ट्रांसफॉर्म सपोर्ट',
            transformecommerce: 'ई-कॉमर्स को रूपांतरित करें',
            emailAuthFailed: 'ईमेल पता प्रमाणित करने में विफल। बाद में पुन: प्रयास करें।',
            companyNameExistMsg: 'कंपनी का नाम पहले से मौजूद है। कृपया कोई दूसरा नाम आज़माएं',
            companyAliasVerifiedMsg: 'अद्वितीय कंपनी का नाम सत्यापित',
            internalServerErrorMsg: 'आंतरिक सर्वर त्रुटि। बाद में पुन: प्रयास करें',
            invalidOTPMsg: 'अमान्य ओटीपी',
            userAlreadyExist: 'उपयोगकर्ता पहले से ही मौजूद है',
            uniqueCompanyNameExist: 'अद्वितीय कंपनी का नाम पहले से मौजूद है!',
            uniqueCompanyNameVerified: 'कंपनी का नाम सफलतापूर्वक सत्यापित किया गया!',
            uniqueCompanyAliasVerified: 'अद्वितीय कंपनी का नाम सफलतापूर्वक सत्यापित किया गया!',
            otpSendMessage: 'ईमेल सत्यापन',
            secondotpSendMessage: "आपके मेल पर ओटीपी भेज दिया गया है। कृपया अपना ईमेल बॉक्स और जंक मेल/स्पैम मेलबॉक्स सत्यापित करें",
            firstNameValidation: 'प्रथम नाम में केवल अक्षर ही होने चाहिए',
            lastNameValidation: 'अंतिम नाम में केवल अक्षर ही होने चाहिए',
            serviceKeyNotFound: 'सेवा कुंजी नहीं मिली',
            apiKeyNotFound: 'एपीआई कुंजी नहीं मिली',
            apiKeyandServiceKeyNotFound: 'सेवा कुंजी और एपीआई कुंजी नहीं मिली',
            otpValidationRegex: 'कोई विशेष वर्ण और स्थान की अनुमति नहीं है',
            taxNo_RegexValidation: 'केवल अल्फ़ान्यूमेरिक वर्णों की अनुमति है',
            needhelp: 'मदद की ज़रूरत है',
            companyName_RegexValidation_2: "कंपनी के नाम में केवल विशेष वर्ण नहीं होने चाहिए",
            companyNameLengthValidation: '150 वर्ण या उससे कम का होना चाहिए',
            designationLengthValidation: '25 वर्ण या उससे कम का होना चाहिए',
            designationFieldValidation: 'नोट: केवल "." और "-" की अनुमति है',
            addressValidation: "कृपया वैध पता दर्ज करें",
            imageUploadMsg: 'यहां क्लिक करें या छवि खींचें',
            imageUploadMsgRemoveBtn: 'निकालना',
            imageUploadMsgDoneBtn: 'पूर्ण',
            transformSales: 'बिक्री बदलें',
            transformSupport: 'रूपांतरण समर्थन',
            transformCommerce: 'ई-कॉमर्स बदलें',
            uniqueCompanyID: "अद्वितीय कंपनी आईडी पहले से मौजूद है!",
            countryFieldValidation: "देश आवश्यक है",
            stateFieldValidation: "राज्य आवश्यक है",
            alreadyacccreated: "क्या आपके पास पहले से एक खाता है?"

        }
    },
    es: {
        locale: 'es',
        messages: {
            tooltip_email: "Por favor, ingrese su dirección de correo electrónico",
            tooltip_otp: "Por favor, ingrese el OTP",
            tooltip_name: "Por favor, ingrese su nombre",
            tooltip_password: "Por favor, ingrese su contraseña",
            tooltip_confirmpassword: "Por favor, confirme su contraseña",
            tooltip_country: "Por favor, seleccione el país",
            tooltip_state: "Por favor, seleccione el estado",
            tooltip_companyname: "Por favor, ingrese el nombre de su empresa",
            tooltip_uniquecompanyid: "Por favor, ingrese su identificación única de empresa",
            tooltip_uniqueuserid: "Por favor, ingrese su identificación única de usuario",
            tooltip_domainname: "Por favor, ingrese su nombre de dominio",
            selectlanguage: 'Seleccione un idioma para registrarse',
            signupOtpValidation: "El OTP debe tener al menos 6 caracteres.",
            selectsocialacc: 'Seleccione una cuenta social',
            zipcodeErrorMessage: 'Código postal no válido',
            completeSubscriptionProcess: "Proceso de suscripción completo",
            English: 'Inglés',
            Hindi: 'hindi',
            uniqueURL: 'URL única',
            Spanish: 'Español',
            otpverify: 'Verificación OTP',

            Arabic: 'Arábica',
            uploadprofilepic: 'Subir foto de perfil',
            uploadcompanylogo: 'Subir logotipo de la empresa',
            // setuplinkmsgOne: 'Ya casi terminaste, abajo está tu JodoLink',
            setuplinkmsgOne: 'Estas casi listo',
            setuplinkmsgTwo: '*Tenga en cuenta que la identificación única de la empresa y su identificación de usuario única una vez registrados no se pueden cambiar una vez que se completa este paso. Si desea modificar alguno de estos nombres en este momento, utilice la tecla Atrás',
            or: 'o',
            language: 'Language',
            emailAddress: 'Dirección de correo electrónico',
            enterEmail: 'Ingrese su dirección de correo electrónico',
            emailexist: 'ya es un suscriptor registrado.',
            emailexist1: 'La misma identificación de correo electrónico no se puede usar para suscripciones múltiples.',
            signInTojodoToobar: 'Iniciar sesión en la barra de herramientas de Jodo',
            emailRegexValidation: 'Introduzca una dirección de correo electrónico válida',
            emailRequiredValidation: 'Se requiere Dirección de correo electrónico',
            emailMaxValidation: 'Máximo de 100 caracteres permitidos',
            emailMinValidation: 'Mínimo 5 caracteres permitidos',
            enterotp: 'Por favor ingrese OTP',
            resendotp: 'Reenviar OTP',
            otpRequiredValidation: 'Por favor ingrese la OTP',
            otpMaxLengthValidation: 'Máximo de 10 caracteres permitidos',
            otpMaxLength: 'Máximo permitido de 6 caracteres',
            otpMinLength: 'Mínimo permitido de 6 caracteres',
            otpMessage: 'Ingrese seis dígitos OTP que se ha enviado a su correo',
            next: 'Próximo',
            signUpGoogle: 'Regístrese con Google',
            signUpLinkeIn: 'Regístrate con LinkedIn',
            jodoteam: 'Equipo Jodó',
            signup: 'Inscribirse',

            jodolink: 'Enlace Jodó',
            wordpress: 'Wordpress',
            jodomeeting: 'Reunión Jodó',
            yourInformation: 'Tu información',
            billingDetails: 'Detalles de facturación',
            setupJodoLink: 'Configurar enlace Jodo',
            setupJodoTeam: 'Configurar el equipo de Jodo',
            setupurl1: 'Estas casi listo',
            setupurl2: 'A continuación se muestra su JodoLink personalizable',
            setupurlmesgthree: 'Tenga en cuenta que una vez realizado este paso, no podrá cambiar su JodoLink.Si desea cambiarlo, hágalo ahora antes de hacer clic en Finalizar.',
            setupDomainName: 'terminar el proceso',
            username: 'Nombre de usuario',
            lastName: 'Apellido',
            setPassword: 'Clave',
            confirmPassword: 'Confirmar contraseña',
            jodoindi: 'JodoLink Individuo',
            designation: 'Título/Designacion',
            country: 'País',
            state: 'Estado',
            city: 'Ciudad',
            zipcode: 'Código postal',
            address1: 'Dirección 1',
            address2: 'Dirección 2',
            back: 'atrás',
            finish: 'Finalizar',
            passwordRule1: '1) Su contraseña debe contener 8 caracteres, uno en mayúsculas, uno en minúsculas, un número y un carácter en mayúsculas y minúsculas',
            passwordRule2: '2) La contraseña y la contraseña de confirmación deben ser las mismas',
            passwordmatchAlert: 'Contraseña y confirmar Las contraseñas no coinciden ',
            passwordmatchSuccess: '¡Contraseña y Confirmar contraseña coinciden!',
            typeCityName: 'Escribe el nombre de tu ciudad',
            companyName: 'Nombre de empresa',
            taxNo: 'Sin impuesto.',
            billingDetailsLocationMsg: '¿Su dirección de facturación es la misma que se proporciona en la sección su información?',
            domainName: 'Nombre de dominio',
            verifyBtn: 'Verificar',
            uniqueCompanyName: 'Nombre único de la empresa',
            uniqueUserName: 'Nombre de usuario único',
            firstNameRequired: 'Se requiere el primer nombre',
            firstNameSpaceValidation: 'el espacio no debe permitir el comienzo y el final',
            lastNameRequired: 'Se requiere apellido',
            twentyFiveCharValidation: 'Debe tener 25 caracteres o menos',
            firstName_lastName_RegexValidation: 'Debe contener solo letras',
            passwordRegexValidation: 'Debe contener 8 caracteres, uno en mayúscula, uno en minúscula, un número y un carácter de caso especial',
            confirmPasswordMatchValidation: 'La contraseña y la contraseña de confirmación deben ser las mismas',
            passwordRequired: 'se requiere contraseña',
            confirmPasswordRequired: 'Se requiere confirmar contraseña',
            zipcodeCharLengthValidation: 'Debe tener 10 números o menos',
            zipCodeValidation: "Código postal no válido",
            zipNumberVAlidation: "Solo número Aceptar",
            zipcodeRegexValidation: 'Se permiten un mínimo de 4 números y un máximo de 10 números',
            addressCharLengthValidation: 'Debe tener 100 caracteres o menos',
            companyNameRequired: 'El nombre de la empresa es obligatorio',
            companyName_RegexValidation: 'La primera letra debe ser mayúscula. Caracteres alfanuméricos y caracteres especiales [-, @, #, &, !] permitidos',
            orgAliasRequired: 'Se requiere el alias de la organización',
            userAliasRequired: 'Se requiere alias de usuario',
            aliasRegexValidation: 'Debe contener caracteres alfanuméricos. No se permiten caracteres especiales ni espacios.',
            domainNameRequired: 'Se requiere nombre de dominio',
            domainNameRegexValidation: 'El nombre de dominio debe ser del tipo https://www.example.com',
            loadingMsgOne: 'Por favor espere, su cuenta está siendo creada.',
            loadingMsgTwo: 'Mientras se crea su cuenta, lea los documentos y vea los videos de productos de Jodo',
            transformsales: 'Transforme las ventas',
            transformsupport: 'Transformar el apoyo',
            transformecommerce: 'Transforme el comercio electrónico',
            emailAuthFailed: 'No se pudo autenticar la dirección de correo electrónico. Por favor, inténtelo de nuevo más tarde.',
            companyNameExistMsg: 'El nombre de la empresa ya existe. Intente con otro nombre',
            companyAliasVerifiedMsg: 'Nombre único de la empresa verificado',
            internalServerErrorMsg: 'Error de servidor interno. Por favor, inténtelo de nuevo más tarde',
            invalidOTPMsg: 'OTP no válido',
            userAlreadyExist: 'El usuario ya existe',
            uniqueCompanyNameExist: '¡El nombre único de la empresa ya existe!',
            uniqueCompanyNameVerified: '¡Nombre de la empresa verificado con éxito!',
            uniqueCompanyAliasVerified: '¡Nombre único de la empresa verificado con éxito! ',
            otpSendMessage: 'verificacion de email',
            secondotpSendMessage: "La OTP ha sido enviada a su correo. Verifique su casilla de correo electrónico y correo no deseado / buzón de correo no deseado",
            firstNameValidation: 'El primer nombre solo debe consistir en letras',
            lastNameValidation: 'El apellido solo debe consistir en letras del alfabeto',
            serviceKeyNotFound: 'Clave de servicio no encontrada',
            apiKeyNotFound: 'Clave API no encontrada',
            apiKeyandServiceKeyNotFound: 'Clave de servicio y clave de API no encontradas',
            otpValidationRegex: 'No se permiten caracteres especiales ni espacios',
            taxNo_RegexValidation: 'Solo se permiten caracteres alfanuméricos',
            needhelp: 'Necesitas ayuda',
            companyName_RegexValidation_2: "El nombre de la empresa no debe consistir solo en caracteres especiales",
            companyNameLengthValidation: 'Debe tener 150 caracteres o menos',
            designationLengthValidation: 'Debe tener 25 caracteres o menos',
            designationFieldValidation: 'Nota: Solo "." y "-" permitido',
            addressValidation: "caracteres alfanuméricos",
            imageUploadMsg: 'Haga clic aquí o arrastre una imagen',
            imageUploadMsgRemoveBtn: 'Eliminar',
            imageUploadMsgDoneBtn: ' Hecho',
            transformSales: 'Transforme las ventas',
            transformSupport: 'Transformar el apoyo',
            transformCommerce: 'Transforme el comercio electrónico',
            uniqueCompanyID: "¡El ID de empresa único ya existe!",
            countryFieldValidation: "Se requiere país",
            stateFieldValidation: "Se requiere estado",
            alreadyacccreated: "¿Ya tienes una cuenta?"

        }
    },
    ar: {
        locale: 'ar',
        messages: {
            tooltip_email: "يرجى إدخال عنوان بريدك الإلكتروني",
            tooltip_otp: "الرجاء إدخال رمز OTP",
            tooltip_name: "الرجاء إدخال اسمك",
            tooltip_password: "الرجاء إدخال كلمة المرور الخاصة بك",
            tooltip_confirmpassword: "يرجى تأكيد كلمة المرور الخاصة بك",
            tooltip_country: "يرجى تحديد البلد",
            tooltip_state: "يرجى تحديد الولاية",
            tooltip_companyname: "الرجاء إدخال اسم شركتك",
            tooltip_uniquecompanyid: "الرجاء إدخال معرف شركتك الفريد",
            tooltip_uniqueuserid: "الرجاء إدخال معرف مستخدمك الفريد",
            tooltip_domainname: "الرجاء إدخال اسم النطاق الخاص بك",
            selectlanguage: 'حدد لغة للتسجيل',
            signupOtpValidation: "يجب أن تحتوي رمز OTP على ما لا يقل عن 6 أحرف.",
            selectsocialacc: 'حدد حسابًا اجتماعيًا',
            zipcodeErrorMessage: 'الرمز البريدي غير صالح',
            completeSubscriptionProcess: "إتمام عملية الاشتراك",
            English: 'إنجليزي',
            Hindi: 'هندي',
            Spanish: 'الأسبانية',
            otpverify: 'التحقق من OTP',
            UniqueURL: 'URL فريد',
            setupurl1: 'لقد شارفت على الانتها',
            setupurl2: 'يوجد أدناه JodoLink القابل للتخصيص الخاص بك',
            setupurlmesgthree: 'إذا كنت ترغب في تغييره ، فقم بذلك الآن قبل النقر فوق "إنهاء". يرجى ملاحظة أنه بمجرد الانتهاء من هذه الخطوة ، لا يمكنك تغيير جودولينك الخاص بك.',
            Arabic: 'عربي',
            uploadprofilepic: 'تحميل صورة الملف الشخصي',
            uploadcompanylogo: 'تحميل شعار الشركة',
            // setuplinkmsgOne: 'لقد أوشكت على الانتهاء ، فيما يلي JodoLink الخاص بك',
            setuplinkmsgOne: 'لقد شارفت على الانتهاء',
            setuplinkmsgTwo: '* يرجى ملاحظة أنه لا يمكن تغيير معرف الشركة الفريد ومعرف المستخدم الفريد بمجرد التسجيل بمجرد اكتمال هذه الخطوة. إذا كنت ترغب في تعديل أي من هذه الأسماء في هذه المرحلة ، يرجى استخدام مفتاح الرجوع',
            or: 'أو',
            language: 'لغة',
            emailAddress: 'عنوان البريد الالكترونى',
            enterEmail: 'أدخل عنوان بريدك الالكتروني',
            emailexist: 'أنت غير مؤهل للاشتراك اليد',
            emailexist1: 'لا يمكن استخدام معرف البريد الإلكتروني نفسه لاشتراكات متعددة.',
            signInTojodoToobar: 'سجّل الدخول إلى شريط أدوات جودو',
            emailRegexValidation: 'أدخل عنوان بريد إلكتروني صالح',
            emailRequiredValidation: 'البريد الالكتروني مطلوب',
            emailMaxValidation: 'الحد الأقصى المسموح به هو 100 حرف',
            emailMinValidation: 'الحد الأدنى مسموح به 5 أحرف',
            enterotp: 'الرجاء إدخال OTP',
            resendotp: 'إعادة إرسال OTP',
            otpRequiredValidation: 'الرجاء إدخال كلمة المرور لمرة واحدة',
            otpMaxLengthValidation: 'الحد الأقصى المسموح به 10 أحرف',
            otpMaxLength: 'الحد الأقصى المسموح به 6 أحرف',
            otpMinLength: 'الحد الأدنى المسموح به 6 أحرف',
            otpMessage: 'الرجاء إدخال ستة أرقام OTP التي تم إرسالها إلى بريدك',
            next: 'التالي',
            signUpGoogle: 'اشترك مع جوجل',
            signUpLinkeIn: 'اشترك مع ينكدين',
            jodoteam: 'فريق جودو',
            jodolink: 'جودو لينك',

            signup: 'اشتراك',
            wordpress: 'وورد',
            jodomeeting: 'اجتماع جودو',
            yourInformation: 'معلوماتك',
            billingDetails: 'تفاصيل الفاتورة',
            setupJodoLink: 'قم بإعداد جودولينك',
            setupJodoTeam: 'قم بإعداد فريق Jodo',
            setupDomainName: "عملية الإنهاء",
            username: 'اسم المستخدم',
            lastName: 'اللقب',
            setPassword: 'كلمة المرور',
            confirmPassword: 'تأكيد كلمة المرور',
            designation: 'تعيين/عنوان',
            jodoindi: 'جودولينك فردي',
            country: 'دولة',
            state: 'حالة',
            city: 'مدينة',
            zipcode: 'الرمز البريدي',
            address1: 'العنوان 1',
            address2: 'العنوان 2',
            back: 'خلف',
            finish: 'إنهاء',
            passwordRule1: '1) يجب أن تحتوي كلمة مرورك على 8 أحرف ، وحرف كبير واحد ، وحرف صغير واحد ، ورقم واحد ، وحرف خاص واحد',
            passwordRule2: '2) يجب أن تكون كلمة المرور وتأكيد كلمة المرور متطابقتين',
            passwordmatchAlert: 'كلمة المرور وتأكيد كلمات المرور غير متطابقة',
            passwordmatchSuccess: 'كلمة المرور وتأكيد كلمة المرور متطابقتان!',
            typeCityName: 'اكتب اسم مدينتك',
            companyName: 'اسم الشركة',
            taxNo: 'لا تفرض ضرائب.',
            billingDetailsLocationMsg: 'هل عنوان الفواتير الخاص بك هو نفسه كما هو مذكور في قسم المعلومات الخاصة بك؟',
            domainName: 'اسم النطاق',
            verifyBtn: 'يؤكد',
            uniqueCompanyName: 'اسم شركة فريد',
            uniqueUserName: 'اسم مستخدم فريد',
            firstNameRequired: 'الإسم الأول مطلوب',
            firstNameSpaceValidation: 'لا ينبغي أن يسمح الفضاء في البداية والنهاية',
            lastNameRequired: 'إسم العائلة مطلوب',
            twentyFiveCharValidation: 'يجب ألا يزيد عدد الأحرف عن 25 حرفًا',
            firstName_lastName_RegexValidation: 'يجب أن يحتوي على أبجديات فقط',
            passwordRegexValidation: 'يجب أن يحتوي على 8 أحرف ، وحرف كبير واحد ، وحرف صغير واحد ، ورقم واحد ، وحرف خاص واحد',
            confirmPasswordMatchValidation: 'يجب أن تكون كلمة المرور وتأكيد كلمة المرور متطابقتين',
            passwordRequired: 'كلمة المرور مطلوبة',
            confirmPasswordRequired: 'تأكيد كلمة المرور مطلوب',
            zipcodeCharLengthValidation: 'يجب أن تكون 10 أرقام أو أقل',
            zipCodeValidation: "الرمز البريدي غير صالح",
            zipNumberVAlidation: "فقط رقم مقبول",
            zipcodeRegexValidation: 'الحد الأدنى 4 أرقام والحد الأقصى 10 أرقام مسموح بها',
            addressCharLengthValidation: 'يجب أن يكون عدد الأحرف 100 حرفًا أو أقل',
            companyNameRequired: 'اسم الشركة مطلوب',
            companyName_RegexValidation: 'يجب أن يكون الحرف الأول كبيرًا. الأحرف الأبجدية الرقمية والأحرف الخاصة [- ، @ ، # ، & ،!] مسموح بها',
            orgAliasRequired: 'الاسم المستعار للمؤسسة مطلوب',
            userAliasRequired: 'الاسم المستعار للمستخدم مطلوب',
            aliasRegexValidation: 'يجب أن يحتوي على أحرف أبجدية رقمية. لا يسمح بأحرف خاصة ومسافات.',
            domainNameRequired: 'اسم المجال مطلوب',
            domainNameRegexValidation: 'يجب أن يكون اسم المجال من النوع https://www.example.com',
            loadingMsgOne: 'يرجى الانتظار ، يتم إنشاء حسابك.',
            loadingMsgTwo: 'أثناء إنشاء حسابك ، اقرأ المستندات واعرض مقاطع فيديو منتج جودولينك',
            transformsales: 'تحويل المبيعات',
            transformsupport: 'تحويل الدعم',
            transformecommerce: 'تحويل التجارة الإلكترونية',
            emailAuthFailed: 'فشلت مصادقة عنوان البريد الإلكتروني. الرجاء معاودة المحاولة في وقت لاحق.',
            companyNameExistMsg: 'اسم الشركة موجود بالفعل. الرجاء محاولة اسم مختلف',
            companyAliasVerifiedMsg: 'تم التحقق من اسم الشركة الفريد',
            internalServerErrorMsg: 'خطأ في الخادم الداخلي. الرجاء معاودة المحاولة في وقت لاحق',
            invalidOTPMsg: 'OTP غير صحيح',
            userAlreadyExist: 'المستخدم موجود بالفعل',
            uniqueCompanyNameExist: 'اسم الشركة الفريد موجود بالفعل!',
            uniqueCompanyNameVerified: 'تم التحقق من اسم الشركة بنجاح!',
            uniqueCompanyAliasVerified: 'تم التحقق من اسم الشركة الفريد بنجاح!',
            otpSendMessage: 'تأكيد بواسطة البريد الالكتروني',
            secondotpSendMessage: "تم إرسال OTP إلى بريدك الإلكتروني. يرجى التحقق من صندوق البريد الإلكتروني الخاص بك وصندوق البريد غير الهام / البريد العشوائي",
            firstNameValidation: 'يجب أن يتكون الاسم الأول من أبجديات فقط',
            lastNameValidation: 'يجب أن يتكون اسم العائلة من أبجديات فقط',
            serviceKeyNotFound: 'مفتاح الخدمة غير موجود',
            apiKeyNotFound: 'مفتاح API غير موجود',
            apiKeyandServiceKeyNotFound: 'لم يتم العثور على مفتاح الخدمة ومفتاح واجهة برمجة التطبيقات',
            otpValidationRegex: 'لا يسمح بأحرف خاصة ومسافات',
            taxNo_RegexValidation: 'يسمح فقط باستخدام الأحرف الأبجدية الرقمية',
            needhelp: 'تحتاج مساعدة',
            companyName_RegexValidation_2: "يجب ألا يتكون اسم الشركة من أحرف خاصة فقط",
            companyNameLengthValidation: 'يجب أن يكون عدد الأحرف 150 حرف أو أقل',
            designationLengthValidation: 'يجب أن يكون عدد الأحرف 25 حرف أو أقل',
            designationFieldValidation: 'ملاحظة: فقط "." و "-" مسموح به',
            addressValidation: 'فقط "." و "-" مسموح',
            imageUploadMsg: 'انقر هنا أو اسحب صورة',
            imageUploadMsgRemoveBtn: 'يزيل',
            imageUploadMsgDoneBtn: ' منتهي',
            transformSales: 'تحويل المبيعات',
            transformSupport: 'تحويل الدعم',
            transformCommerce: 'تحويل التجارة الإلكترونية',
            uniqueCompanyID: "المعرّف الفريد للشركة موجود بالفعل!",
            countryFieldValidation: "الدولة مطلوبة",
            stateFieldValidation: "الولاية مطلوبة",
            alreadyacccreated: "هل لديك حساب بالفعل؟"
        }
    },
    mr: {
        locale: 'mr',
        messages: {
            tooltip_email: "कृपया आपला ईमेल पत्ता पुर्ण करा",
            tooltip_otp: "कृपया OTP प्रविष्ट करा",
            tooltip_name: "कृपया आपलं नाव पुर्ण करा",
            tooltip_password: "कृपया आपला पासवर्ड पुर्ण करा",
            tooltip_confirmpassword: "कृपया आपला पासवर्ड पुष्टी करा",
            tooltip_country: "कृपया देश निवडा",
            tooltip_state: "कृपया राज्य निवडा",
            tooltip_companyname: "कृपया आपलं कंपनीचं नाव पुर्ण करा",
            tooltip_uniquecompanyid: "कृपया आपलं अद्वितीय कंपनीचं आयडी पुर्ण करा",
            tooltip_uniqueuserid: "कृपया आपलं अद्वितीय वापरकर्ता आयडी पुर्ण करा",
            tooltip_domainname: "कृपया आपलं डोमेन नाम पुर्ण करा",
            selectlanguage: "साइन अप करण्यासाठी भाषा निवडा",
            signupOtpValidation: "OTP किमान 6 वर्णांचा असावा.",
            selectsocialacc: "सामाजिक खाते निवडा",
            zipcodeErrorMessage: "अवैध पिनकोड",
            completeSubscriptionProcess: "संपूर्ण सदस्यता प्रक्रिया",
            English: "इंग्रजी",
            Hindi: "हिंदी",
            Spanish: "स्पॅनिश",
            Arabic: "अरबी",
            uploadprofilepic: "प्रोफाइल पिक्चर अपलोड करा",
            uploadcompanylogo: "कंपनी लोगो अपलोड करा",
            setuplinkmsgOne: "आपण जवळजवळ पूर्ण केले आहे",
            setupurl1: "आपण जवळजवळ पूर्ण केले आहे.",
            setupurl2: "खाली तुमची सानुकूल करण्यायोग् जोडोलिंक आहे",
            setupurlmesgthree: "कृपया लक्षात घ्या की एकदा ही पायरी पूर्ण झाली की",
            setuplinkmsgTwo: "*कृपया लक्षात घ्या की युनिक कंपनी आयडी आणि तुमचा युनिक युजर आयडी एकदा नोंदणीकृत झाल्यानंतर ही पायरी पूर्ण झाल्यावर बदलता येणार नाही. या बिंदूवर तुम्हाला यापैकी कोणतेही नाव बदलायचे असल्यास कृपया बॅक की वापरा",
            or: "किंवा",
            language: "इंग्रजी",
            emailAddress: "ईमेल पत्ता",
            enterEmail: "तुमचा इमेल पत्ता लिहा",
            emailexist: "तुम्ही आमच्याकडे आधीच नोंदणीकृत आहात.",
            emailexist1: "या ईमेल आयडीशी संबंधित विद्यमान सदस्यत्व आहे.",
            signInTojodoToobar: "जोडो टूलबारमध्ये साइन इन करा",
            emailRegexValidation: "वैध ईमेल पत्ता प्रविष्ट करा",
            emailRequiredValidation: "ईमेल आवश्यक आहे",
            emailMaxValidation: "जास्तीत जास्त 100 वर्णांना परवानगी आहे'",
            emailMinValidation: "किमान 5 वर्ण आवश्यक आहेत.'",
            enterotp: "कृपया OTP प्रविष्ट करा'",
            resendotp: "ओटीपी पुन्हा पाठवा'",
            otpRequiredValidation: "कृपया OTP प्रविष्ट करा'",
            otpMaxLengthValidation: "जास्तीत जास्त 16 वर्णांना परवानगी आहे",
            otpMaxLength: "जास्तीत जास्त 6 वर्णांना परवानगी आहे",
            otpMinLength: "किमान 6 वर्णांना परवानगी आहे",
            otpMessage: "कृपया तुमच्या मेलवर पाठवलेला सहा अंकी OTP प्रविष्ट करा",
            next: "पुढे",
            signUpGoogle: "गूगल सह साइन अप करा",
            signUpLinkeIn: "लिंक्डइनसह साइन अप करा",
            jodoteam: "जोडो टीम",
            jodoindi: "जोडोलिंक वैयक्तिक",
            jodolink: "जोडोलिंक",
            wordpress: "'वर्डप्रेस",
            yourInformation: "तुमची माहिती",
            otpverify: "OTP पडताळणी",
            signup: "साइनअप",
            resendotp: "ओटीपी पुन्हा पाठवा",
            billingDetails: "पावतीचा तपशील",
            setupJodoLink: "जोडोलिंक सेटअप करा",
            setupJodoTeam: "जोडो टीम सेटअप करा",
            setupDomainName: "'प्रक्रिया पूर्ण करा",
            username: "नाव",
            lastName: "आडनाव'",
            setPassword: "पासवर्ड",
            confirmPassword: "पासवर्डची पुष्टी करा",
            designation: "शीर्षक/पदनाम",
            country: "देश",
            state: "राज्य",
            city: "शहर",
            zipcode: "पिनकोड",
            address1: "पत्ता 1",
            address2: "पत्ता 2",
            back: "मागे",
            finish: "समाप्त",
            passwordRule1: "1) तुमच्या पासवर्डमध्ये 8 वर्ण  एक अपरकेस  एक लोअरकेस  एक नंबर आणि एक स्पेशल केस कॅरेक्टर असणे आवश्यक आहे'",
            passwordRule2: "पासवर्ड आणि पुष्टीकरण पासवर्ड सारखाच असला पाहिजे.",
            passwordmatchAlert: "पासवर्ड आणि कन्फर्म पासवर्ड जुळत नाहीत",
            passwordmatchSuccess: "पासवर्ड आणि पासवर्ड जुळल्याची पुष्टी करा!",
            typeCityName: "तुमच्या शहराचे नाव टाइप करा",
            companyName: "कंपनीचे नाव",
            taxNo: "कर क्रमांक",
            billingDetailsLocationMsg: "तुमचा बिलिंग पत्ता तुमच्या माहिती विभागात दिल्याप्रमाणे आहे का?",
            domainName: "डोमेनचे नाव",
            verifyBtn: "पडताळणी करा",
            uniqueCompanyName: "युनिक कंपनी आयडी",
            uniqueURL: "युनिक URL",
            uniqueUserName: "युनिक यूजर आयडी",
            firstNameRequired: "प्रथम नाव आवश्यक आहे",
            firstNameSpaceValidation: "तुम्ही नावाच्या सुरुवातीला किंवा शेवटी जागा वापरू शकत नाही.",
            lastNameRequired: "आडनाव आवश्यक आहे'",
            twentyFiveCharValidation: "25 वर्ण किंवा त्यापेक्षा कमी असणे आवश्यक आहे",
            firstName_lastName_RegexValidation: "'नावात फक्त अक्षरे वापरली जाऊ शकतात.",
            passwordRegexValidation: "8 वर्ण, एक अपरकेस, एक लोअरकेस, एक नंबर आणि एक स्पेशल केस कॅरेक्टर असणे आवश्यक आहे,",
            confirmPasswordMatchValidation: "पासवर्ड आणि पुष्टीकरण पासवर्ड एकच असावा.",
            passwordRequired: "पासवर्ड आवश्यक आहे'",
            confirmPasswordRequired: "संकेतशब्द आवश्यक असल्याची पुष्टी करा",
            zipcodeCharLengthValidation: "10 किंवा त्याहून कमी संख्या असणे आवश्यक आहे",
            zipCodeValidation: "अवैध पिनकोड",
            zipNumberVAlidation: "फक्त नंबर वापरता येईल.",
            zipcodeRegexValidation: "किमान 4 संख्या आणि जास्तीत जास्त 10 संख्यांना परवानगी",
            addressCharLengthValidation: "100 वर्ण किंवा कमी असणे आवश्यक आहे",
            companyNameRequired: "कंपनीचे नाव आवश्यक आहे",
            companyName_RegexValidation: "केवळ अल्फान्यूमेरिक वर्ण आणि विशेष वर्ण [- @  #  & !] वापरले जाऊ शकतात.",
            orgAliasRequired: "संस्थेचे उपनाव आवश्यक आहे",
            userAliasRequired: "वापरकर्ता उपनाम आवश्यक आहे'",
            aliasRegexValidation: "अल्फान्यूमेरिक वर्ण असणे आवश्यक आहे. विशेष वर्ण आणि जागा परवानगी नाही.",
            domainNameRequired: "कृपया डोमेन नाव निर्दिष्ट करा.",
            domainNameRegexValidation: "डोमेन नाव https://www.example.com' या प्रकारचे असले पाहिजे",
            loadingMsgOne: "कृपया प्रतीक्षा करा  तुमचे खाते तयार केले जात आहे",
            loadingMsgTwo: "तुमचे खाते तयार केले जात असताना  डॉक्स वाचा आणि Jodo उत्पादनाचे व्हिडिओ पहा",
            transformsales: "ट्रान्सफॉर्म सेल्स",
            transformsupport: "ट्रान्सफॉर्म सपोर्ट",
            transformecommerce: "ट्रान्सफॉर्म ई-कॉमर्स",
            emailAuthFailed: "ईमेल अॅड्रेस ऑथेंटिकेट करण्यात अयशस्वी. कृपया पुन्हा प्रयत्न करा.",
            companyNameExistMsg: "या कंपनीचे नाव आधीच नोंदणीकृत आहे.",
            companyAliasVerifiedMsg: "युनिक कंपनीचे नाव सत्यापित",
            internalServerErrorMsg: "अंतर्गत सर्व्हर त्रुटी. कृपया पुन्हा प्रयत्न करा",
            invalidOTPMsg: "अवैध OTP",
            userAlreadyExist: "वापरकर्ता आधीच अस्तित्वात आहे",
            uniqueCompanyNameExist: "युनिक कंपनीचे नाव आधीपासूनच अस्तित्वात आहे!",
            uniqueCompanyNameVerified: "कंपनीचे नाव यशस्वीरित्या सत्यापित झाले!",
            uniqueCompanyAliasVerified: "युनिक कंपनीच्या नावाची यशस्वीपणे पडताळणी! ",
            otpSendMessage: "ई - मेल पडताळणी",
            secondotpSendMessage: "तुमच्या मेलवर ओटीपी पाठवला आहे. कृपया तुमचा ईमेल बॉक्स आणि जंक मेल / स्पॅम मेलबॉक्स सत्यापित करा",
            firstNameValidation: "प्रथम नावात फक्त अक्षरेच असावीत",
            lastNameValidation: "आडनावात फक्त अक्षरांचा समावेश असावा",
            serviceKeyNotFound: "सेवा की सापडली नाही",
            apiKeyNotFound: "API की सापडली नाही",
            apiKeyandServiceKeyNotFound: "सेवा की आणि API की सापडली नाही",
            otpValidationRegex: "फक्त नंबरला परवानगी आहे",
            taxNo_RegexValidation: "फक्त अल्फान्यूमेरिक वर्णांना परवानगी आहे",
            needhelp: "मदत पाहिजे'",
            companyName_RegexValidation_2: "कंपनीच्या नावासाठी फक्त विशेष अक्षरे वापरली जाऊ शकत नाहीत.",
            companyNameLengthValidation: "150 वर्ण किंवा त्यापेक्षा कमी असणे आवश्यक आहे",
            designationLengthValidation: "25 वर्ण किंवा त्यापेक्षा कमी असणे आवश्यक आहे",
            designationFieldValidation: "टीप:फक्त .आणि - ला विभाजक म्हणून परवानगी आहे.",
            addressValidation: "कृपया वैध पत्ता प्रविष्ट करा.",
            imageUploadMsg: "येथे क्लिक करा किंवा प्रतिमा ड्रॅग करा",
            imageUploadMsgRemoveBtn: "काढा",
            imageUploadMsgDoneBtn: "पूर्ण",
            transformSales: "ट्रान्सफॉर्म सेल्स",
            transformSupport: "ट्रान्सफॉर्म सपोर्ट",
            transformCommerce: "ट्रान्सफॉर्म ई-कॉमर्स",
            uniqueCompanyID: "अद्वितीय कंपनीची आयडी आधीच अस्तित्वात आहे!",
            countryFieldValidation: "देश आवश्यक आहे",
            stateFieldValidation: "राज्य आवश्यक आहे",
            alreadyacccreated: "आधीच खाते आहे का?"

        }
    },
    gu: {
        locale: 'gu',
        messages: {
            tooltip_email: "કૃપા કરીને તમારું ઇમેઇલ સરનામું ભરો",
            tooltip_otp: "કૃપા કરીને OTP દાખલ કરો",
            tooltip_name: "કૃપા કરીને તમારું નામ ભરો",
            tooltip_password: "કૃપા કરીને તમારું પાસવર્ડ ભરો",
            tooltip_confirmpassword: "કૃપા કરીને તમારું પાસવર્ડખાતરી કરો",
            tooltip_country: "કૃપા કરીને દેશ પસંદ કરો",
            tooltip_state: "કૃપા કરીને રાજ્ય પસંદ કરો",
            tooltip_companyname: "કૃપા કરીને તમારું કંપનીનુંનામ ભરો",
            tooltip_uniquecompanyid: "કૃપા કરીને તમારું અનન્ય કંપની આઈડી ભરો",
            tooltip_uniqueuserid: "કૃપા કરીને તમારું અનન્ય વપરાશકર્તા આઈડી ભરો",
            tooltip_domainname: "કૃપા કરીને તમારું ડોમેન નામ ભરો",
            selectlanguage: "સાઇન અપ માટે ભાષા પસંદકરો",
            signupOtpValidation: "OTP ઓછામાં ઓછા 6 અક્ષરોનો હોવો જોઈએ.",
            selectsocialacc: "સોશિયલ એકાઉન્ટ પસંદ કરો",
            zipcodeErrorMessage: "અમાન્ય પિનકોડ",
            completeSubscriptionProcess: "સંપૂર્ણ સબ્સ્ક્રિપ્શન પ્રક્રિયા",
            English: "અંગ્રેજી",
            Hindi: "હિન્દી",
            Spanish: "સ્પૅનિશ",
            Arabic: "અરબી",
            uploadprofilepic: "પ્રોફાઇલ પિક્ચર અપલોડ કરો",
            uploadcompanylogo: "કંપનીનો લોગો અપલોડ કરો",
            setuplinkmsgOne: "તમે લગભગ પૂર્ણ કરી લીધું છે",
            setupurl1: "તમે લગભગ પૂર્ણ કરી લીધું છે",
            setupurl2: "નીચે તમારી કસ્ટમાઇઝ કરી શકાય તેવી જોડોલિંક છે",
            setupurlmesgthree: "કૃપા કરીને નોંધ લો કે એકવાર આ પગલું પૂર્ણ થઈ જાય",
            setuplinkmsgTwo: "કૃપા કરીને નોંધ કરો કે એકવાર નોંધાયેલ અનન્ય કંપની ID અને તમારું અનન્ય વપરાશકર્તા ID એકવાર આ પગલું પૂર્ણ થયા પછી બદલી શકાશે નહીં. જો તમે આ સમયે આમાંના કોઈપણ નામમાં ફેરફાર કરવા માંગતા હો",
            or: "અથવા",
            language: "ભાષા",
            emailAddress: "ઈ - મેઈલ સરનામું",
            enterEmail: "તમારુ ઇમેઇલ એડ્રેસ દાખલ કરો",
            emailexist: "તમે અમારી સાથે પહેલેથી જ નોંધાયેલા છો",
            emailexist1: "આ ઈમેલ આઈડી સાથે હાલનું સબસ્ક્રિપ્શન સંકળાયેલું છે",
            signInTojodoToobar: "જોડો ટૂલબાર પર સાઇન ઇન કરો",
            emailRegexValidation: "યોગ્ય ઇ - મેલ એડ્રેસ આપો",
            emailRequiredValidation: "ઇમેઇલ જરૂરી છે",
            emailMaxValidation: "મહત્તમ 100 અક્ષરોની મંજૂરી",
            emailMinValidation: "ઓછામાં ઓછા 5 અક્ષરો જરૂરી છે",
            enterotp: "કૃપા કરીને OTP દાખલ કરો",
            resendotp: "ઓટીપી ફરીથી મોકલો",
            otpRequiredValidation: "કૃપા કરીને OTP દાખલ કરો",
            otpMaxLengthValidation: "મહત્તમ 16 અક્ષરોની મંજૂરી છે",
            otpMaxLength: "મહત્તમ 6 અક્ષરોની મંજૂરી",
            otpMinLength: "ઓછામાં ઓછા 6 અક્ષરોની મંજૂરી",
            otpMessage: "કૃપા કરીને છ અંકનો OTP દાખલ કરો જે તમારા મેઇલ પર મોકલવામાં આવ્યો છે",
            next: "આગલું",
            signUpGoogle: "ગૂગલ સાથે સાઇન અપ કરો",
            signUpLinkeIn: "લિંક્ડઇન સાથે સાઇન અપ કરો",
            jodoteam: "જોડો ટીમ",
            jodoindi: "જોડોલિંક વ્યક્તિગત",
            jodolink: "જોડોલિંક",
            wordpress: "વર્ડપ્રેસ",
            yourInformation: "તમારી માહિતી",
            otpverify: "OTP ચકાસો",
            signup: "સાઇનઅપ",
            resendotp: "ઓટીપી ફરીથી મોકલો",
            billingDetails: "બિલિંગ વિગતો",
            setupJodoLink: "જોડોલિંક સેટઅપ કરો",
            setupJodoTeam: "જોડો ટીમ સેટઅપ",
            setupDomainName: "પ્રક્રિયા સમાપ્ત કરો",
            username: "નામ",
            lastName: "છેલ્લું નામ",
            setPassword: "પાસવર્ડ",
            confirmPassword: "પાસવર્ડ કન્ફર્મ કરો",
            designation: "શીર્ષક/હોદ્દો",
            country: "દેશ",
            state: "રાજ્ય",
            city: "શહેર",
            zipcode: "પિન કોડ",
            address1: "સરનામું 1",
            address2: "સરનામું 2",
            back: "પાછળ",
            finish: "સમાપ્ત",
            passwordRule1: "1) તમારા પાસવર્ડમાં 8 અક્ષરો  એક અપરકેસ  એક લોઅરકેસ  એક નંબર અને એક સ્પેશિયલ કેસ કેરેક્ટર હોવા જોઈએ ",
            passwordRule2: "પાસવર્ડ અને કન્ફર્મેશન પાસવર્ડ એક જ હોવા જોઈએ",
            passwordmatchAlert: "પાસવર્ડ અને કન્ફર્મ પાસવર્ડ્સ મેળ ખાતા નથી",
            passwordmatchSuccess: "પાસવર્ડ અને કન્ફર્મ પાસવર્ડ મેચ થયો!",
            typeCityName: "તમારા શહેરનું નામ લખો",
            companyName: "કંપની નું નામ",
            taxNo: "ટેક્સ નંબર",
            billingDetailsLocationMsg: "શું તમારું બિલિંગ સરનામું તમારા માહિતી વિભાગમાં આપેલું સરનામું છે?",
            domainName: "ડોમેન નામ",
            verifyBtn: "ચકાસણી કરો",
            uniqueCompanyName: "યુનિક કંપની આઈડી",
            uniqueURL: "યુનિક URL",
            uniqueUserName: "યુનિક યુઝર આઈડી",
            firstNameRequired: "પ્રથમ નામ જરૂરી છે",
            firstNameSpaceValidation: "તમે નામની શરૂઆતમાં કે અંતે જગ્યાનો ઉપયોગ કરી શકતા નથી.",
            lastNameRequired: "છેલ્લું નામ જરૂરી છે",
            twentyFiveCharValidation: "25 કે તેથી ઓછા અક્ષરો હોવા જોઈએ",
            firstName_lastName_RegexValidation: "નામમાં માત્ર મૂળાક્ષરોનો ઉપયોગ કરી શકાય છે.",
            passwordRegexValidation: "8 અક્ષરો  એક અપરકેસ  એક લોઅરકેસ  એક નંબર અને એક સ્પેશિયલ કેસ કેરેક્ટર હોવા જોઈએ ",
            confirmPasswordMatchValidation: "પાસવર્ડ અને કન્ફર્મેશન પાસવર્ડ એક જ હોવા જોઈએ.",
            passwordRequired: "પાસવર્ડ અનિવાર્ય છે",
            confirmPasswordRequired: "પાસવર્ડ જરૂરી છે તેની પુષ્ટિ કરો",
            zipcodeCharLengthValidation: "10 કે તેથી ઓછી સંખ્યા હોવી જોઈએ",
            zipCodeValidation: "અમાન્ય પિનકોડ",
            zipNumberVAlidation: "માત્ર નંબરનો ઉપયોગ કરી શકાય છે.",
            zipcodeRegexValidation: "લઘુત્તમ 4 નંબર અને મહત્તમ 10 નંબરની મંજૂરી",
            addressCharLengthValidation: "100 કે તેથી ઓછા અક્ષરો હોવા જોઈએ",
            companyNameRequired: "કંપનીનું નામ જરૂરી છે",
            companyName_RegexValidation: "માત્ર આલ્ફાન્યૂમેરિક અક્ષરો અને વિશિષ્ટ અક્ષરો [- @  #  & !] વાપરી શકાય છે",
            orgAliasRequired: "સંસ્થા ઉપનામ જરૂરી છે",
            userAliasRequired: "વપરાશકર્તા ઉપનામ જરૂરી છે",
            aliasRegexValidation: "આલ્ફાન્યૂમેરિક અક્ષરો હોવા જોઈએ. કોઈ વિશિષ્ટ અક્ષરો અને જગ્યાની મંજૂરી નથી.",
            domainNameRequired: "કૃપા કરીને ડોમેન નામ સ્પષ્ટ કરો.",
            domainNameRegexValidation: "ડોમેન નામ https://www.example.com પ્રકારનું હોવું જોઈએ",
            loadingMsgOne: "કૃપા કરીને રાહ જુઓ",
            loadingMsgTwo: "જ્યારે તમારું એકાઉન્ટ બનાવવામાં આવી રહ્યું હોય",
            transformsales: "ટ્રાન્સફોર્મ સેલ્સ",
            transformsupport: "ટ્રાન્સફોર્મ સપોર્ટ",
            transformecommerce: "ટ્રાન્સફોર્મ ઇ-કોમર્સ",
            emailAuthFailed: "ઇમેઇલ સરનામું પ્રમાણિત કરવામાં નિષ્ફળ. પછીથી ફરી પ્રયત્ન કરો.",
            companyNameExistMsg: "આ કંપનીનું નામ પહેલેથી જ નોંધાયેલું છે.",
            companyAliasVerifiedMsg: "યુનિક કંપનીનું નામ ચકાસાયેલ",
            internalServerErrorMsg: "આંતરિક સર્વર ભૂલ. પછીથી ફરી પ્રયત્ન કરો",
            invalidOTPMsg: "અમાન્ય OTP",
            userAlreadyExist: "વપરાશકર્તા પહેલેથી અસ્તિત્વમાં છે",
            uniqueCompanyNameExist: "અનન્ય કંપનીનું નામ પહેલેથી અસ્તિત્વમાં છે!",
            uniqueCompanyNameVerified: "કંપનીનું નામ સફળતાપૂર્વક ચકાસાયું!",
            uniqueCompanyAliasVerified: "અનન્ય કંપનીનું નામ સફળતાપૂર્વક ચકાસાયું! ",
            otpSendMessage: "ઇમેઇલ વેરિફિકેશન",
            secondotpSendMessage: "તમારા મેઇલ પર OTP મોકલવામાં આવ્યો છે. કૃપા કરીને તમારા ઈમેલ બોક્સ અને જંક મેઈલ / સ્પામ મેઈલબોક્સની ચકાસણી કરો",
            firstNameValidation: "પ્રથમ નામમાં માત્ર મૂળાક્ષરો જ હોવા જોઈએ",
            lastNameValidation: "છેલ્લું નામ ફક્ત મૂળાક્ષરોનું જ હોવું જોઈએ",
            serviceKeyNotFound: "સેવા કી મળી નથી",
            apiKeyNotFound: "API કી મળી નથી",
            apiKeyandServiceKeyNotFound: "સર્વિસ કી અને API કી મળી નથી",
            otpValidationRegex: "ફક્ત નંબરની મંજૂરી છે",
            taxNo_RegexValidation: "માત્ર આલ્ફાન્યૂમેરિક અક્ષરોને મંજૂરી છે",
            needhelp: "મદદ જોઈતી",
            companyName_RegexValidation_2: "કંપનીના નામ માટે માત્ર વિશિષ્ટ અક્ષરોનો ઉપયોગ કરી શકાતો નથી.",
            companyNameLengthValidation: "150 કે તેથી ઓછા અક્ષરો હોવા જોઈએ",
            designationLengthValidation: "25 કે તેથી ઓછા અક્ષરો હોવા જોઈએ",
            designationFieldValidation: "નોંધ: માત્ર . અને - ને વિભાજક તરીકે માન્ય છે.",
            addressValidation: "કૃપા કરીને માન્ય સરનામું દાખલ કરો.",
            imageUploadMsg: "અહીં ક્લિક કરો અથવા છબી ખેંચો",
            imageUploadMsgRemoveBtn: "દૂર કરો",
            imageUploadMsgDoneBtn: "થઈ ગયું",
            transformSales: "ટ્રાન્સફોર્મ સેલ્સ",
            transformSupport: "ટ્રાન્સફોર્મ સપોર્ટ",
            transformCommerce: "ટ્રાન્સફોર્મ ઇ-કોમર્સ",
            uniqueCompanyID: "અદ્વિતીય કંપની આઈડી પહેલાંથી હાજર છે!",
            countryFieldValidation: "દેશ જરૂરી છે",
            stateFieldValidation: "રાજ્ય જરૂરી છે",
            alreadyacccreated: "પહેલેથી જ એક ખાતું છે?"
        }
    },
    bn: {
        locale: 'bn',
        messages: {
            tooltip_email: "আপনার ইমেইল ঠিকানা পূরণ করুন",
            tooltip_otp: "অনুগ্রহ করে ওটিপি ইনপুট করুন",
            tooltip_name: "আপনার নাম পূরণ করুন",
            tooltip_password: "আপনার পাসওয়ার্ড পূরণ করুন",
            tooltip_confirmpassword: "আপনার পাসওয়ার্ড নিশ্চিত করুন",
            tooltip_country: "দেশ নির্বাচন করুন",
            tooltip_state: "রাজ্য নির্বাচন করুন",
            tooltip_companyname: "আপনার কোম্পানির নাম পূরণ করুন",
            tooltip_uniquecompanyid: "আপনার অদ্বিতীয় কোম্পানি আইডি পূরণ করুন",
            tooltip_uniqueuserid: "আপনার অদ্বিতীয় ব্যবহারকারী আইডি পূরণ করুন",
            tooltip_domainname: "আপনার ডোমেইন নাম পূরণ করুন",
            selectlanguage: 'সাইন আপ করার জন্য একটি ভাষা নির্বাচন করুন',
            signupOtpValidation: 'OTP কমপক্ষে 6 অক্ষরের হতে হবে।',
            selectsocialacc: 'একটি সামাজিক অ্যাকাউন্ট নির্বাচন করুন',
            zipcodeErrorMessage: 'অবৈধ জিপকোড',
            completeSubscriptionProcess: 'সম্পূর্ণ সাবস্ক্রিপশন প্রক্রিয়া',
            English: 'ইংরেজি',
            Hindi: 'হিন্দি',
            Spanish: 'স্পেনীয়',
            Arabic: 'আরবি',
            uploadprofilepic: 'প্রোফাইল ছবি আপলোড করুন',
            uploadcompanylogo: 'আপলোড কোম্পানির লোগো',
            setuplinkmsgOne: 'আপনি প্রায় শেষ',
            setupurl1: 'আপনি প্রায় শেষ।',
            setupurl2: 'নিচে আপনার কাস্টমাইজযোগ্য জোডোলিংক',
            setupurlmesgthree: 'দয়া করে মনে রাখবেন এই ধাপটি হয়ে গেলে',
            setuplinkmsgTwo: '*দয়া করে মনে রাখবেন যে ইউনিক কোম্পানি আইডি এবং আপনার ইউনিক ইউজার আইডি একবার নিবন্ধিত হয়ে গেলে এই ধাপটি শেষ হয়ে গেলে পরিবর্তন করা যাবে না। আপনি যদি এই সময়ে এই নামগুলির মধ্যে কোনো পরিবর্তন করতে চান তাহলে অনুগ্রহ করে ব্যাক কী ব্যবহার করুন',
            or: 'বা',
            language: 'ভাষা',
            emailAddress: 'ইমেল ঠিকানা',
            enterEmail: 'তোমার ই - মেইল ​​ঠিকানা লেখো',
            emailexist: 'আপনি ইতিমধ্যে আমাদের সাথে নিবন্ধিত।',
            emailexist1: 'এই ইমেল আইডির সাথে যুক্ত একটি বিদ্যমান সাবস্ক্রিপশন আছে।',
            signInTojodoToobar: 'জোডো টুলবারে সাইন ইন করুন',
            emailRegexValidation: 'একটি বৈধ ইমেইল ঠিকানা লিখুন',
            emailRequiredValidation: 'ইমেল প্রয়োজন',
            emailMaxValidation: 'সর্বোচ্চ 100 অক্ষর অনুমোদিত',
            emailMinValidation: 'ন্যূনতম 5টি অক্ষর প্রয়োজন৷',
            enterotp: 'অনুগ্রহ করে ওটিপি লিখুন',
            resendotp: 'ওটিপি আবার পাঠান',
            otpRequiredValidation: 'অনুগ্রহ করে ওটিপি লিখুন',
            otpMaxLengthValidation: 'সর্বোচ্চ 16টি অক্ষর অনুমোদিত',
            otpMaxLength: 'সর্বোচ্চ 6 অক্ষর অনুমোদিত',
            otpMinLength: 'ন্যূনতম 6 অক্ষর অনুমোদিত',
            otpMessage: 'আপনার মেইলে পাঠানো ছয় সংখ্যার OTP লিখুন',
            next: 'পরবর্তী',
            signUpGoogle: 'গুগল দিয়ে সাইন আপ করুন',
            signUpLinkeIn: 'লিঙ্কডইন দিয়ে সাইন আপ করুন',
            jodoteam: 'জোডো দল',
            jodoindi: 'জোডোলিংক ইন্ডিভিজুয়াল',
            jodolink: 'জোডোলিংক',
            wordpress: 'ওয়ার্ডপ্রেস',
            yourInformation: 'আপনার তথ্য',
            otpverify: 'OTP যাচাই করুন',
            signup: 'নিবন্ধন করুন',
            resendotp: 'ওটিপি আবার পাঠান',
            billingDetails: 'পূর্ণ রূপ প্রকাশ',
            setupJodoLink: 'জোডোলিংক সেটআপ করুন',
            setupJodoTeam: 'জোডো টিম সেটআপ করুন',
            setupDomainName: 'প্রক্রিয়া শেষ করুন',
            username: 'নাম',
            lastName: 'নামের শেষাংশ',
            setPassword: 'পাসওয়ার্ড',
            confirmPassword: 'পাসওয়ার্ড নিশ্চিত করুন',
            designation: 'শিরোনাম/পদবী',
            country: 'দেশ',
            state: 'অবস্থা',
            city: 'শহর',
            zipcode: 'জিপ কোড',
            address1: 'ঠিকানা 1',
            address2: 'ঠিকানা ২',
            back: 'পেছনে',
            finish: 'শেষ',
            passwordRule1: '1) আপনার পাসওয়ার্ডে 8টি অক্ষর  একটি বড় হাতের  একটি ছোট হাতের  একটি সংখ্যা এবং একটি বিশেষ কেস অক্ষর থাকতে হবে',
            passwordRule2: 'পাসওয়ার্ড এবং নিশ্চিতকরণ পাসওয়ার্ড একই হতে হবে।',
            passwordmatchAlert: 'পাসওয়ার্ড এবং নিশ্চিত পাসওয়ার্ড মেলে না',
            passwordmatchSuccess: 'পাসওয়ার্ড এবং পাসওয়ার্ড মিলেছে নিশ্চিত করুন!',
            typeCityName: 'আপনার শহরের নাম টাইপ করুন',
            companyName: 'কোমপানির নাম',
            taxNo: 'ট্যাক্স নম্বর',
            billingDetailsLocationMsg: 'আপনার বিলিং ঠিকানা কি আপনার তথ্য বিভাগে দেওয়া একই?',
            domainName: 'ডোমেন নাম',
            verifyBtn: 'যাচাই করুন',
            uniqueCompanyName: 'ইউনিক কোম্পানি আইডি',
            uniqueURL: 'অনন্য URL',
            uniqueUserName: 'ইউনিক ইউজার আইডি',
            firstNameRequired: 'প্রথম নাম প্রয়োজন',
            firstNameSpaceValidation: 'আপনি নামের শুরুতে বা শেষে স্পেস ব্যবহার করতে পারবেন না।',
            lastNameRequired: 'শেষ নাম প্রয়োজন',
            twentyFiveCharValidation: '25 অক্ষর বা তার কম হতে হবে',
            firstName_lastName_RegexValidation: 'একটি নামে শুধুমাত্র বর্ণমালা ব্যবহার করা যেতে পারে।',
            passwordRegexValidation: '8টি অক্ষর  একটি বড় হাতের  একটি ছোট হাতের  একটি সংখ্যা এবং একটি বিশেষ কেস অক্ষর থাকতে হবে',
            confirmPasswordMatchValidation: 'পাসওয়ার্ড এবং নিশ্চিতকরণ পাসওয়ার্ড একই হতে হবে।',
            passwordRequired: 'পাসওয়ার্ড প্রয়োজন',
            confirmPasswordRequired: 'পাসওয়ার্ড নিশ্চিত করুন প্রয়োজন বোধ করা হয়',
            zipcodeCharLengthValidation: '10 নম্বর বা তার কম হতে হবে',
            zipCodeValidation: 'অবৈধ জিপকোড',
            zipNumberVAlidation: 'শুধুমাত্র সংখ্যা ব্যবহার করা যাবে।',
            zipcodeRegexValidation: 'সর্বনিম্ন 4টি সংখ্যা এবং সর্বোচ্চ 10টি সংখ্যা অনুমোদিত',
            addressCharLengthValidation: '100 অক্ষর বা তার কম হতে হবে',
            companyNameRequired: 'কোম্পানির নাম প্রয়োজন',
            companyName_RegexValidation: 'শুধুমাত্র আলফানিউমেরিক অক্ষর এবং বিশেষ অক্ষর [- @  #  & !] ব্যবহার করা যেতে পারে।',
            orgAliasRequired: 'সংগঠনের উপনাম প্রয়োজন',
            userAliasRequired: 'ব্যবহারকারীর উপনাম প্রয়োজন',
            aliasRegexValidation: 'আলফানিউমেরিক অক্ষর থাকতে হবে। কোন বিশেষ অক্ষর এবং স্থান অনুমোদিত নয়৷',
            domainNameRequired: 'অনুগ্রহ করে ডোমেইন নাম উল্লেখ করুন।',
            domainNameRegexValidation: 'ডোমেন নাম অবশ্যই https://www.example.com টাইপের হতে হবে',
            loadingMsgOne: 'অনুগ্রহ করে অপেক্ষা করুন',
            loadingMsgTwo: 'যখন আপনার অ্যাকাউন্ট তৈরি করা হচ্ছে  ডক্স পড়ুন এবং Jodo পণ্য ভিডিও দেখুন',
            transformsales: 'ট্রান্সফর্ম সেলস',
            transformsupport: 'ট্রান্সফর্ম সাপোর্ট',
            transformecommerce: 'ট্রান্সফর্ম ই-কমার্স',
            emailAuthFailed: 'ইমেল ঠিকানা প্রমাণীকরণে ব্যর্থ। অনুগ্রহ করে একটু পরে আবার চেষ্টা করুন.',
            companyNameExistMsg: 'এই কোম্পানির নাম ইতিমধ্যেই নিবন্ধিত।',
            companyAliasVerifiedMsg: 'অনন্য কোম্পানির নাম যাচাই করা হয়েছে',
            internalServerErrorMsg: 'অভ্যন্তরীণ সার্ভার ত্রুটি. অনুগ্রহ করে একটু পরে আবার চেষ্টা করুন',
            invalidOTPMsg: 'অবৈধ OTP',
            userAlreadyExist: 'ব্যবহারকারী ইতিমধ্যে উপস্থিত',
            uniqueCompanyNameExist: 'অনন্য কোম্পানির নাম ইতিমধ্যেই বিদ্যমান!',
            uniqueCompanyNameVerified: 'কোম্পানির নাম সফলভাবে যাচাই করা হয়েছে!',
            uniqueCompanyAliasVerified: 'অনন্য কোম্পানির নাম সফলভাবে যাচাই করা হয়েছে! ',
            otpSendMessage: 'ইমেইলের সত্যতা যাচাই',
            secondotpSendMessage: 'আপনার মেইলে ওটিপি পাঠানো হয়েছে। অনুগ্রহ করে আপনার ইমেল বক্স এবং জাঙ্ক মেইল ​​/ স্প্যাম মেলবক্স যাচাই করুন',
            firstNameValidation: 'প্রথম নাম শুধুমাত্র বর্ণমালা দ্বারা গঠিত হওয়া উচিত',
            lastNameValidation: 'শেষ নাম শুধুমাত্র বর্ণমালা নিয়ে গঠিত হওয়া উচিত',
            serviceKeyNotFound: 'পরিষেবা কী পাওয়া যায়নি',
            apiKeyNotFound: 'এপিআই কী পাওয়া যায়নি',
            apiKeyandServiceKeyNotFound: 'পরিষেবা কী এবং API কী পাওয়া যায়নি',
            otpValidationRegex: 'শুধুমাত্র সংখ্যা অনুমোদিত',
            taxNo_RegexValidation: 'শুধুমাত্র আলফানিউমেরিক অক্ষর অনুমোদিত',
            needhelp: 'সাহায্য দরকার',
            companyName_RegexValidation_2: 'কোম্পানীর নামের জন্য শুধুমাত্র বিশেষ অক্ষর ব্যবহার করা যাবে না।',
            companyNameLengthValidation: '150 অক্ষর বা তার কম হতে হবে',
            designationLengthValidation: '25 অক্ষর বা তার কম হতে হবে',
            designationFieldValidation: 'দ্রষ্টব্য: শুধুমাত্র "।" এবং "-" বিভাজক হিসাবে অনুমোদিত৷',
            addressValidation: 'অনুগ্রহ করে একটি বৈধ ঠিকানা লিখুন।',
            imageUploadMsg: 'এখানে ক্লিক করুন বা একটি ছবি টেনে আনুন',
            imageUploadMsgRemoveBtn: ' অপসারণ',
            imageUploadMsgDoneBtn: 'সম্পন্ন',
            transformSales: 'ট্রান্সফর্ম সেলস',
            transformSupport: 'ট্রান্সফর্ম সাপোর্ট',
            transformCommerce: 'ট্রান্সফর্ম ই-কমার্স',
            uniqueCompanyID: "অদ্বিতীয় কোম্পানি আইডি ইতিমধ্যে বিদ্যমান!",
            countryFieldValidation: "দেশ প্রয়োজন",
            stateFieldValidation: "রাজ্য প্রয়োজন",
            alreadyacccreated: "আপনার কি ইতিমধ্যেই একটি অ্যাকাউন্ট আছে?"
        }
    },
    fr: {
        locale: 'fr',
        messages: {
            tooltip_email: "Veuillez saisir votre adresse e-mail",
            tooltip_otp: "Veuillez saisir le OTP",
            tooltip_name: "Veuillez saisir votre nom",
            tooltip_password: "Veuillez saisir votre mot de passe",
            tooltip_confirmpassword: "Veuillez confirmer votre mot de passe",
            tooltip_country: "Veuillez sélectionner le pays",
            tooltip_state: "Veuillez sélectionner l'état",
            tooltip_companyname: "Veuillez saisir le nom de votre entreprise",
            tooltip_uniquecompanyid: "Veuillez saisir votre identifiant unique d'entreprise",
            tooltip_uniqueuserid: "Veuillez saisir votre identifiant unique d'utilisateur",
            tooltip_domainname: "Veuillez saisir votre nom de domaine",
            selectlanguage: 'Sélectionnez une langue pour vous inscrire',
            signupOtpValidation: 'OTP doit comporter au moins 6 caractères.',
            selectsocialacc: 'Sélectionnez un compte social',
            zipcodeErrorMessage: 'Code postal invalide',
            completeSubscriptionProcess: 'Processus dabonnement complet',
            English: 'Anglais',
            Hindi: 'Hindi',
            Spanish: 'Espagnol',
            Arabic: 'Arabe',
            uploadprofilepic: 'Télécharger la photo de profil',
            uploadcompanylogo: "Télécharger le logo de l'entreprise",
            setuplinkmsgOne: 'Tu as presque fini',
            setupurl1: 'Tu as presque fini.',
            setupurl2: ' Ci-dessous votre JodoLink personnalisable',
            setupurlmesgthree: 'Veuillez noter quune fois cette étape effectuée vous ne pourrez plus modifier votre JodoLink.Si vous souhaitez le modifier, faites- le maintenant avant de cliquer sur Terminer.',
            setuplinkmsgTwo: '*Veuillez noter que lidentifiant unique de l`entreprise et votre identifiant unique d`utilisateur une fois enregistrés ne peuvent pas être modifiés une fois cette étape terminée.Si vous souhaitez modifier l`un de ces noms à ce stade',
            or: 'ou',
            language: 'Langue',
            emailAddress: 'Adresse e-mail',
            enterEmail: 'Entrez votre adresse email',
            emailexist: 'Vous êtes déjà inscrit chez nous.',
            emailexist1: 'Il existe un abonnement existant associé à cet identifiant de messagerie.',
            signInTojodoToobar: "Connectez-vous à la barre d'outils Jodo",
            emailRegexValidation: 'Entrez une adresse e-mail valide',
            emailRequiredValidation: 'Un e-mail est requis',
            emailMaxValidation: '100 caractères maximum autorisés',
            emailMinValidation: 'Un minimum de 5 caractères est requis.',
            enterotp: 'Veuillez entrer OTP',
            resendotp: 'Renvoyer OTP',
            otpRequiredValidation: 'Veuillez saisir l`OTP`',
            otpMaxLengthValidation: '16 caractères maximum autorisés',
            otpMaxLength: 'Maximum 6 caractères autorisés',
            otpMinLength: 'Minimum de 6 caractères autorisés',
            otpMessage: 'Veuillez saisir les six chiffres OTP qui ont été envoyés à votre courrier',
            next: 'Suivant',
            signUpGoogle: "Inscrivez - vous avec Google",
            signUpLinkeIn: "Inscrivez - vous avec LinkedIn",
            jodoteam: "L'équipe Jodo",
            jodoindi: 'JodoLink Individuel',
            jodolink: 'JodoLink',
            wordpress: "Wordpress",
            yourInformation: 'Vos informations',
            otpverify: 'Vérification OTP',
            signup: "S'inscrire",
            resendotp: 'Renvoyer OTP',
            billingDetails: 'Détails de la facturation',
            setupJodoLink: 'Configurer JodoLink',
            setupJodoTeam: "Configurer l'équipe Jodo",
            setupDomainName: 'Terminer le processus',
            username: 'Nom',
            lastName: 'Nom de famille',
            setPassword: 'Mot de passe',
            confirmPassword: 'Confirmez le mot de passe',
            designation: 'Titre/Désignation',
            country: 'Pays',
            state: 'État',
            city: 'Ville',
            zipcode: 'Code postal',
            address1: 'Adresse 1',
            address2: 'Adresse 2',
            back: 'Dos',
            finish: 'Finition',
            passwordRule1: '1) Votre mot de passe doit contenir 8 caractères  une majuscule  une minuscule  un chiffre et une casse spéciale',
            passwordRule2: 'Le mot de passe et le mot de passe de confirmation doivent être identiques.',
            passwordmatchAlert: 'Mot de passe et confirmation Les mots de passe ne correspondent pas',
            passwordmatchSuccess: 'Mot de passe et Confirmer le mot de passe correspondent !',
            typeCityName: 'Tapez le nom de votre ville',
            companyName: "Nom de l'entreprise",
            taxNo: 'Impôt non.',
            billingDetailsLocationMsg: "Votre adresse de facturation est-elle la même que celle fournie dans votre section d'informations?",
            domainName: 'Nom de domaine',
            verifyBtn: 'Vérifier',
            uniqueCompanyName: "Identifiant unique de l'entreprise",
            uniqueURL: 'URL unique',
            uniqueUserName: "Identifiant d'utilisateur unique",
            firstNameRequired: 'Le prénom est requis',
            firstNameSpaceValidation: "Vous ne pouvez pas utiliser d'espace au début ou à la fin d'un nom.",
            lastNameRequired: 'Le nom de famille est requis',
            twentyFiveCharValidation: 'Doit contenir 25 caractères ou moins',
            firstName_lastName_RegexValidation: 'Seuls les alphabets peuvent être utilisés dans un nom.',
            passwordRegexValidation: "Doit contenir 8 caractères, une majuscule, une minuscule, un chiffre et une casse spéciale",
            confirmPasswordMatchValidation: 'Le mot de passe et le mot de passe de confirmation doivent être identiques.',
            passwordRequired: 'Mot de passe requis',
            confirmPasswordRequired: 'Confirmer le mot de passe est requis',
            zipcodeCharLengthValidation: "Doit contenir 10 chiffres ou moins",
            zipCodeValidation: 'Code postal invalide',
            zipNumberVAlidation: 'Seul un numéro peut être utilisé.',
            zipcodeRegexValidation: 'Minimum 4 numéros et Maximum 10 numéros autorisés',
            addressCharLengthValidation: "Doit contenir 100 caractères ou moins",
            companyNameRequired: "Le nom de l'entreprise est requis",
            companyName_RegexValidation: 'Seuls les caractères alphanumériques et les caractères spéciaux [-  @  #  & !] peuvent être utilisés.',
            orgAliasRequired: "L'alias de l'organisation est requis",
            userAliasRequired: "L'alias de l'utilisateur est requis",
            aliasRegexValidation: "Doit contenir des caractères alphanumériques. Aucun caractère spécial ni espace autorisé.",
            domainNameRequired: 'Veuillez préciser le nom de domaine.',
            domainNameRegexValidation: "Le nom de domaine doit être de type https://www.example.com",
            loadingMsgOne: "Veuillez patienter  votre compte est en cours de création",
            loadingMsgTwo: "Pendant la création de votre compte, lisez la documentation et visionnez les vidéos des produits Jodo",
            transformsales: "Transformer les ventes ",
            transformsupport: 'Support de transformation',
            transformecommerce: "Transformer le commerce électronique ",
            emailAuthFailed: "Échec de l'authentification de l'adresse e-mail. Veuillez réessayer plus tard.",
            companyNameExistMsg: "Ce nom de société est déjà enregistré.",
            companyAliasVerifiedMsg: "Nom unique de l'entreprise vérifié",
            internalServerErrorMsg: "Erreur interne du serveur. Veuillez réessayer plus tard",
            invalidOTPMsg: 'OTP invalide',
            userAlreadyExist: "L'utilisateur existe déjà",
            uniqueCompanyNameExist: "Un nom d'entreprise unique existe déjà !",
            uniqueCompanyNameVerified: "Nom de l'entreprise vérifié avec succès !",
            uniqueCompanyAliasVerified: " Nom unique de l'entreprise vérifié avec succès ! ",
            otpSendMessage: "Vérification de l'E - mail",
            secondotpSendMessage: 'OTP a été envoyé à votre courrier. Veuillez vérifier votre boîte e-mail et votre courrier indésirable/boîte aux lettres spam',
            firstNameValidation: "Le prénom ne doit être composé que d'alphabets",
            lastNameValidation: "Le nom de famille ne doit être composé que d'alphabets",
            serviceKeyNotFound: "Clé de service introuvable",
            apiKeyNotFound: "Clé API introuvable",
            apiKeyandServiceKeyNotFound: "Clé de service et clé API introuvables",
            otpValidationRegex: "Seul le nombre est autorisé",
            taxNo_RegexValidation: "Seuls les caractères alphanumériques autorisés",
            needhelp: "Besoin d'aide",
            companyName_RegexValidation_2: "Seuls les caractères spéciaux ne peuvent pas être utilisés pour le nom de l'entreprise.",
            companyNameLengthValidation: "Doit contenir 150 caractères ou moins",
            designationLengthValidation: "Doit contenir 25 caractères ou moins",
            designationFieldValidation: "Remarque : seulement . et `-` sont autorisés comme séparateurs.",
            addressValidation: "S'il- vous - plaît entrez une adresse valide.",
            imageUploadMsg: 'Cliquez ici ou faites glisser une image',
            imageUploadMsgRemoveBtn: ' Retirer',
            imageUploadMsgDoneBtn: 'Fait',
            transformSales: "Transformer les ventes ",
            transformSupport: "Support de transformation",
            transformCommerce: "Transformer le commerce électronique ",
            uniqueCompanyID: "L'identifiant d'entreprise unique existe déjà!",
            countryFieldValidation: "Le pays est requis",
            stateFieldValidation: "L'état est requis",
            alreadyacccreated: "Vous avez déjà un compte?"

        }
    },
    de: {
        locale: 'de',
        messages: {
            tooltip_email: "Bitte geben Sie Ihre E-Mail-Adresse ein",
            tooltip_otp: "Bitte geben Sie den OTP ein",
            tooltip_name: "Bitte geben Sie Ihren Namen ein",
            tooltip_password: "Bitte geben Sie Ihr Passwort ein",
            tooltip_confirmpassword: "Bitte bestätigen Sie Ihr Passwort",
            tooltip_country: "Bitte wählen Sie das Land aus",
            tooltip_state: "Bitte wählen Sie den Staat aus",
            tooltip_companyname: "Bitte geben Sie den Namen Ihres Unternehmens ein",
            tooltip_uniquecompanyid: "Bitte geben Sie Ihre eindeutige Unternehmens-ID ein",
            tooltip_uniqueuserid: "Bitte geben Sie Ihre eindeutige Benutzer-ID ein",
            tooltip_domainname: "Bitte geben Sie Ihren Domainnamen ein",
            selectlanguage: 'Wählen Sie eine Sprache für die Anmeldung aus',
            signupOtpValidation: 'OTP muss mindestens 6 Zeichen lang sein.',
            selectsocialacc: 'Wählen Sie ein soziales Konto aus',
            zipcodeErrorMessage: 'Ungültige Postleitzahl',
            completeSubscriptionProcess: 'Abonnementvorgang abschließen',
            English: 'Englisch',
            Hindi: 'Hindi',
            Spanish: 'Spanisch',
            Arabic: 'Arabisch',
            uploadprofilepic: 'Profilbild hochladen',
            uploadcompanylogo: 'Firmenlogo hochladen',
            setuplinkmsgOne: 'Du bist fast fertig',
            setupurl1: 'Du bist fast fertig.',
            setupurl2: ' Unten finden Sie Ihren anpassbaren JodoLink',
            setupurlmesgthree: 'Bitte beachten Sie  dass Sie Ihren JodoLink nach Abschluss dieses Schritts nicht mehr ändern können. Wenn Sie ihn ändern möchten  tun Sie dies jetzt  bevor Sie auf Fertig stellen klicken.',
            setuplinkmsgTwo: '*Bitte beachten Sie',
            or: 'oder',
            language: 'Sprache',
            emailAddress: 'E-Mail-Adresse',
            enterEmail: 'Geben sie ihre E-Mailadresse ein',
            emailexist: 'Sie sind bereits bei uns registriert.',
            emailexist1: 'Mit dieser E-Mail-ID ist ein bestehendes Abonnement verknüpft.',
            signInTojodoToobar: 'Bei der Jodo-Symbolleiste anmelden',
            emailRegexValidation: 'Geben sie eine gültige E-Mail-Adresse an',
            emailRequiredValidation: 'E-Mail ist erforderlich',
            emailMaxValidation: 'Maximal 100 Zeichen erlaubt',
            emailMinValidation: 'Es sind mindestens 5 Zeichen erforderlich.',
            enterotp: 'Bitte geben Sie OTP ein',
            resendotp: 'OTP erneut senden',
            otpRequiredValidation: 'Bitte geben Sie das OTP ein',
            otpMaxLengthValidation: 'Maximal 16 Zeichen erlaubt',
            otpMaxLength: 'Maximal 6 Zeichen erlaubt',
            otpMinLength: 'Mindestens 6 Zeichen erlaubt',
            otpMessage: 'Bitte geben Sie das sechsstellige OTP ein  das an Ihre E-Mail-Adresse gesendet wurde',
            next: 'Nächste',
            signUpGoogle: 'Melden Sie sich bei Google an',
            signUpLinkeIn: 'Mit LinkedIn anmelden',
            jodoteam: 'Jodo-Team',
            jodoindi: 'JodoLink Individual',
            jodolink: 'JodoLink',
            wordpress: 'Wordpress',
            yourInformation: 'Ihre Informationen',
            otpverify: 'OTP-Verifizierung',
            signup: 'Melden Sie sich an',
            resendotp: 'OTP erneut senden',
            billingDetails: 'Rechnungsdetails',
            setupJodoLink: 'JodoLink einrichten',
            setupJodoTeam: 'Jodo-Team einrichten',
            setupDomainName: 'Prozess abschließen',
            username: 'Name',
            lastName: 'Familienname  Nachname',
            setPassword: 'Passwort',
            confirmPassword: 'Bestätige das Passwort',
            designation: 'Titel/Bezeichnung',
            country: 'Land',
            state: 'Zustand',
            city: 'Stadt',
            zipcode: 'PLZ',
            address1: 'Adresse 1',
            address2: 'Adresse 2',
            back: 'Zurück',
            finish: 'Beenden',
            passwordRule1: '1) Ihr Passwort muss 8 Zeichen enthalten  einen Großbuchstaben  einen Kleinbuchstaben  eine Zahl und ein Sonderzeichen',
            passwordRule2: 'Das Passwort und das Bestätigungspasswort müssen identisch sein.',
            passwordmatchAlert: 'Mot de passe et confirmation Les mots de passe ne correspondent pas',
            passwordmatchSuccess: 'Passwort und Passwort bestätigen stimmen überein!',
            typeCityName: 'Geben Sie den Namen Ihrer Stadt ein',
            companyName: 'Name der Firma',
            taxNo: 'Steuer-Nr.',
            billingDetailsLocationMsg: 'Ist Ihre Rechnungsadresse dieselbe wie in Ihrem Informationsbereich?',
            domainName: 'Domainname',
            verifyBtn: 'Verifizieren',
            uniqueCompanyName: 'Eindeutige Firmen-ID',
            uniqueURL: 'Eindeutige URL',
            uniqueUserName: 'Eindeutige Benutzer-ID',
            firstNameRequired: 'Vorname ist erforderlich',
            firstNameSpaceValidation: 'Sie dürfen weder am Anfang noch am Ende eines Namens Leerzeichen verwenden.',
            lastNameRequired: 'Nachname ist erforderlich',
            twentyFiveCharValidation: 'Muss maximal 25 Zeichen lang sein',
            firstName_lastName_RegexValidation: 'In einem Namen können nur Buchstaben verwendet werden.',
            passwordRegexValidation: 'Muss 8 Zeichen enthalten',
            confirmPasswordMatchValidation: 'Das Passwort und das Bestätigungspasswort müssen identisch sein.',
            passwordRequired: 'Passwort wird benötigt',
            confirmPasswordRequired: 'Passwort bestätigen ist erforderlich',
            zipcodeCharLengthValidation: 'Muss 10 oder weniger Zahlen sein',
            zipCodeValidation: 'Ungültige Postleitzahl',
            zipNumberVAlidation: 'Es können nur Zahlen verwendet werden.',
            zipcodeRegexValidation: 'Mindestens 4 Nummern und maximal 10 Nummern erlaubt',
            addressCharLengthValidation: 'Muss maximal 100 Zeichen lang sein',
            companyNameRequired: 'Firmenname ist erforderlich',
            companyName_RegexValidation: 'Es können nur alphanumerische Zeichen und Sonderzeiche',
            orgAliasRequired: 'Organisationsalias ist erforderlich',
            userAliasRequired: 'Benutzeralias ist erforderlich',
            aliasRegexValidation: 'Muss alphanumerische Zeichen enthalten. Keine Sonderzeichen und Leerzeichen erlaubt.',
            domainNameRequired: 'Bitte geben Sie den Domainnamen an.',
            domainNameRegexValidation: 'Der Domänenname muss vom Typ https://www.example.com sein',
            loadingMsgOne: 'Bitte warten',
            loadingMsgTwo: 'Lesen Sie während der Erstellung Ihres Kontos die Dokumente und sehen Sie sich die Jodo-Produktvideos an',
            transformsales: 'Vertrieb transformieren',
            transformsupport: 'Transformationsunterstützung',
            transformecommerce: 'E-Commerce transformieren',
            emailAuthFailed: 'Authentifizierung der E-Mail-Adresse fehlgeschlagen. Bitte versuchen Sie es später noch einmal.',
            companyNameExistMsg: 'Dieser Firmenname ist bereits registriert.',
            companyAliasVerifiedMsg: 'Eindeutiger Firmenname verifiziert',
            internalServerErrorMsg: 'Interner Serverfehler. Bitte versuchen Sie es später noch einmal',
            invalidOTPMsg: 'Ungültiges OTP',
            userAlreadyExist: 'Benutzer existiert bereits',
            uniqueCompanyNameExist: 'Eindeutiger Firmenname existiert bereits!',
            uniqueCompanyNameVerified: 'Firmenname erfolgreich verifiziert!',
            uniqueCompanyAliasVerified: 'Eindeutiger Firmenname erfolgreich verifiziert!',
            otpSendMessage: 'E-Mail-Verifizierung',
            secondotpSendMessage: 'OTP wurde an Ihre E-Mail-Adresse gesendet. Bitte überprüfen Sie Ihr E-Mail-Postfach und Ihr Junk-Mail-/Spam-Postfach.',
            firstNameValidation: 'Der Vorname sollte nur aus Buchstaben bestehen',
            lastNameValidation: 'Nachname sollte nur aus Buchstaben bestehen',
            serviceKeyNotFound: 'Dienstschlüssel nicht gefunden',
            apiKeyNotFound: 'API-Schlüssel nicht gefunden',
            apiKeyandServiceKeyNotFound: 'Dienstschlüssel und API-Schlüssel nicht gefunden',
            otpValidationRegex: 'Nur Zahl ist erlaubt',
            taxNo_RegexValidation: 'Nur alphanumerische Zeichen erlaubt',
            needhelp: 'Brauchen Sie Hilfe',
            companyName_RegexValidation_2: 'Für den Firmennamen dürfen nur Sonderzeichen verwendet werden.',
            companyNameLengthValidation: 'Muss maximal 150 Zeichen lang sein',
            designationLengthValidation: 'Muss maximal 25 Zeichen lang sein',
            designationFieldValidation: 'Hinweis:Nur `. und ' - ' sind als Trennzeichen zulässig.',
            addressValidation: 'Bitte geben Sie eine gültige Adresse ein.',
            imageUploadMsg: 'Klicken Sie hier oder ziehen Sie ein Bild',
            imageUploadMsgRemoveBtn: ' Entfernen',
            imageUploadMsgDoneBtn: 'Erledigt',
            transformSales: 'Vertrieb transformieren',
            transformSupport: 'Transformationsunterstützung',
            transformCommerce: 'E-Commerce transformieren',
            uniqueCompanyID: "Einzigartige Unternehmens-ID existiert bereits!",
            countryFieldValidation: "Land ist erforderlich",
            stateFieldValidation: "Bundesland ist erforderlich",
            alreadyacccreated: "Haben Sie bereits ein Konto?"
        }
    },
    or: {
        locale: 'or',
        messages: {
            selectlanguage: 'ସାଇନ୍ ଅପ୍ ପାଇଁ ଏକ ଭାଷା ବାଛ',
            signupOtpValidation: 'OTP ଅତିକମରେ 6 ଅକ୍ଷର ହେବା ଜରୁରୀ |',
            selectsocialacc: 'ଏକ ସାମାଜିକ ଖାତା ବାଛ',
            zipcodeErrorMessage: 'ଅବ val ଧ ଜିପକୋଡ୍',
            completeSubscriptionProcess: 'ସମ୍ପୂର୍ଣ୍ଣ ସଦସ୍ୟତା ପ୍ରକ୍ରିୟା',
            English: 'ଇଂରାଜୀ',
            Hindi: 'ହିନ୍ଦୀ',
            Spanish: 'ସ୍ପାନିସ୍',
            Arabic: 'ଆରବୀ',
            uploadprofilepic: 'ପ୍ରୋଫାଇଲ୍ ଛବି ଅପଲୋଡ୍ କରନ୍ତୁ',
            uploadcompanylogo: 'କମ୍ପାନୀ ଲୋଗୋ ଅପଲୋଡ୍ କରନ୍ତୁ',
            setuplinkmsgOne: 'ତୁମେ ପ୍ରାୟ ସମାପ୍ତ',
            setupurl1: 'ତୁମେ ପ୍ରାୟ କରିସାରିଛ।',
            setupurl2: 'ନିମ୍ନରେ ତୁମର କଷ୍ଟମାଇଜେବଲ୍ ଜୋଡୋ ଲିଙ୍କ୍',
            setupurlmesgthree: 'ଦୟାକରି ଧ୍ୟାନ ଦିଅନ୍ତୁ ଯେ ଏହି ପଦକ୍ଷେପଟି ଥରେ ହୋଇଗଲେ, ଆପଣ ଆପଣଙ୍କର JodoLink ପରିବର୍ତ୍ତନ କରିପାରିବେ ନାହିଁ | ଯଦି ଆପଣ ଏହାକୁ ପରିବର୍ତ୍ତନ କରିବାକୁ ଚାହାଁନ୍ତି, ତେବେ ଫିନିଶ୍ କ୍ଲିକ୍ କରିବା ପୂର୍ବରୁ ତାହା କରନ୍ତୁ |',
            setuplinkmsgTwo: '* ଦୟାକରି ଧ୍ୟାନ ଦିଅନ୍ତୁ ଯେ ଥରେ ପଞ୍ଜୀକୃତ ହୋଇଥିବା ୟୁନିକ୍ କମ୍ପାନୀ ID ଏବଂ ଆପଣଙ୍କର ୟୁନିକ୍ ୟୁଜର୍ ID ଏହି ପଦକ୍ଷେପ ସମାପ୍ତ ହେବା ପରେ ପରିବର୍ତ୍ତନ କରାଯାଇପାରିବ ନାହିଁ | ଯଦି ଆପଣ ଏହି ସମୟରେ ଏହି ନାମଗୁଡିକ ମଧ୍ୟରୁ କ ify ଣସି ପରିବର୍ତ୍ତନ କରିବାକୁ ଚାହୁଁଛନ୍ତି ଦୟାକରି ପଛ ଚାବି ବ୍ୟବହାର କରନ୍ତୁ ',
            or: 'କିମ୍ବା',
            language: 'ଭାଷା',
            emailAddress: 'ଈମୈଲ ଠିକଣା',
            enterEmail: 'ଆପଣଙ୍କର ଇମେଲ୍ ଠିକଣା ପ୍ରବେଶ କରନ୍ତୁ',
            emailexist: 'ତୁମେ ଆମ ସହିତ ପଞ୍ଜୀକୃତ ହୋଇସାରିଛ।',
            emailexist1: 'ଏହି ଇମେଲ ID ସହିତ ଜଡିତ ଏକ ବିଦ୍ୟମାନ ସଦସ୍ୟତା ଅଛି।',
            signInTojodoToobar: 'ଯୋଡୋ ଟୁଲ୍ ବାର୍ କୁ ସାଇନ୍ ଇନ୍',
            emailRegexValidation: 'ଏକ ବ email ଧ ଇମେଲ୍ ଠିକଣା ପ୍ରବେଶ କରନ୍ତୁ',
            emailRequiredValidation: 'ଇମେଲ୍ ଆବଶ୍ୟକ',
            emailMaxValidation: 'ସର୍ବାଧିକ 100 ଅକ୍ଷର ଅନୁମୋଦିତ',
            emailMinValidation: 'ସର୍ବନିମ୍ନ 5 ଅକ୍ଷର ଆବଶ୍ୟକ |',
            enterotp: 'ଦୟାକରି OTP ପ୍ରବେଶ କରନ୍ତୁ',
            resendotp: 'OTP ପଠାନ୍ତୁ',
            otpRequiredValidation: 'ଦୟାକରି OTP ପ୍ରବେଶ କରନ୍ତୁ',
            otpMaxLengthValidation: 'ସର୍ବାଧିକ 16 ଅକ୍ଷର ଅନୁମୋଦିତ',
            otpMaxLength: 'ସର୍ବାଧିକ 6 ଅକ୍ଷର ଅନୁମୋଦିତ',
            otpMinLength: 'ସର୍ବନିମ୍ନ 6 ଅକ୍ଷର ଅନୁମୋଦିତ',
            otpMessage: 'ଦୟାକରି ଛଅ ଅଙ୍କ ବିଶିଷ୍ଟ OTP ପ୍ରବେଶ କରନ୍ତୁ ଯାହା ଆପଣଙ୍କ ମେଲକୁ ପଠାଯାଇଛି',
            next: 'ପରବର୍ତ୍ତୀ',
            signUpGoogle: 'ଗୁଗୁଲ୍ ସହିତ ସାଇନ୍ ଅପ୍',
            signUpLinkeIn: 'ଲିଙ୍କଡଇନ୍ ସହିତ ସାଇନ୍ ଅପ୍',
            jodoteam: 'ଯୋଡୋ ଟିମ୍',
            jodoindi: 'ଜୋଡୋ ଲିଙ୍କ୍ ବ୍ୟକ୍ତିଗତ',
            jodolink: 'ଜୋଡୋ ଲିଙ୍କ୍',
            wordpress: 'ୱାର୍ଡପ୍ରେସ୍',
            yourInformation: 'ତୁମର ସୂଚନା',
            otpverify: 'OTP ଯାଞ୍ଚ',
            signup: 'ସାଇନ୍ ଅପ୍ କରନ୍ତୁ',
            resendotp: 'OTP ପଠାନ୍ତୁ',
            billingDetails: 'ବିଲିଂ ବିବରଣୀ',
            setupJodoLink: 'ସେଟଅପ୍ ଜୋଡୋ ଲିଙ୍କ୍',
            setupJodoTeam: 'ସେଟଅପ୍ ଯୋଡୋ ଟିମ୍',
            setupDomainName: 'ପ୍ରକ୍ରିୟା ସମାପ୍ତ',
            username: 'ନାମ',
            lastName: 'ଶେଷ ନାମ',
            setPassword: 'ପାସୱାର୍ଡ',
            confirmPassword: 'ପାସ୍ବାଡ଼ ନିସ୍ଚିତ କର',
            designation: 'ଆଖ୍ୟା / ପଦବୀ',
            country: 'ଦେଶ',
            state: 'ରାଜ୍ୟ',
            city: 'ସହର',
            zipcode: 'ଜିପ୍ କୋଡ୍',
            address1: 'ଠିକଣା 1',
            address2: 'ଠିକଣା 2',
            back: 'ପଛକୁ',
            finish: 'ସମାପ୍ତ',
            passwordRule1: '1) ଆପଣଙ୍କର ପାସୱାର୍ଡରେ 8 ଟି ଅକ୍ଷର, ଗୋଟିଏ ଅପର୍ କେସ୍, ଗୋଟିଏ ଲୋୟର କେସ୍, ଗୋଟିଏ ନମ୍ବର ଏବଂ ଗୋଟିଏ ସ୍ୱତନ୍ତ୍ର କେସ୍ ଅକ୍ଷର ଥିବା ଆବଶ୍ୟକ',
            passwordRule2: 'ପାସୱାର୍ଡ ଏବଂ ନିଶ୍ଚିତକରଣ ପାସୱାର୍ଡ ସମାନ ହେବା ଜରୁରୀ |',
            passwordmatchAlert: 'ପାସୱାର୍ଡ ଏବଂ ନିଶ୍ଚିତ କରନ୍ତୁ ପାସୱାର୍ଡ ମେଳ ଖାଉ ନାହିଁ',
            passwordmatchSuccess: 'ପାସୱାର୍ଡ ଏବଂ ପାସୱାର୍ଡ ମେଳ ହୋଇଛି ନିଶ୍ଚିତ କର!',
            typeCityName: 'ତୁମର ସହର ନାମ ଟାଇପ୍ କର',
            companyName: 'କମ୍ପାନି ନାଁ',
            taxNo: 'ଟ୍ୟାକ୍ସ ନମ୍ବର',
            billingDetailsLocationMsg: 'ତୁମର ସୂଚନା ବିଭାଗରେ ପ୍ରଦାନ କରାଯାଇଥିବା ପରି ତୁମର ବିଲିଂ ଠିକଣା ସମାନ କି?',
            domainName: 'ଡୋମେନ୍ ନାମ',
            verifyBtn: 'ଯାଞ୍ଚ',
            uniqueCompanyName: 'ଅନନ୍ୟ କମ୍ପାନୀ ଆଇଡି',
            uniqueURL: 'ଅନନ୍ୟ URL',
            uniqueUserName: 'ଅନନ୍ୟ ବ୍ୟବହାରକାରୀ Id',
            firstNameRequired: 'ପ୍ରଥମ ନାମ ଆବଶ୍ୟକ',
            firstNameSpaceValidation: 'ଆପଣ ନାମର ଆରମ୍ଭ କିମ୍ବା ଶେଷରେ ସ୍ଥାନ ବ୍ୟବହାର କରିପାରିବେ ନାହିଁ।',
            lastNameRequired: 'ଶେଷ ନାମ ଆବଶ୍ୟକ',
            twentyFiveCharValidation: 'ନିଶ୍ଚିତ ଭାବରେ 25 ଅକ୍ଷର କିମ୍ବା ତା’ଠାରୁ କମ୍',
            firstName_lastName_RegexValidation: 'କେବଳ ବର୍ଣ୍ଣମାଳା ଏକ ନାମରେ ବ୍ୟବହାର କରାଯାଇପାରିବ।',
            passwordRegexValidation: 'ନିଶ୍ଚିତ ଭାବରେ 8 ଟି ଅକ୍ଷର, ଗୋଟିଏ ବଡ ଅକ୍ଷର, ଗୋଟିଏ ଲୋୟର କେସ୍, ଗୋଟିଏ ନମ୍ବର ଏବଂ ଗୋଟିଏ ବିଶେଷ କେସ୍ ଅକ୍ଷର',
            confirmPasswordMatchValidation: 'ପାସୱାର୍ଡ ଏବଂ ନିଶ୍ଚିତକରଣ ପାସୱାର୍ଡ ସମାନ ହେବା ଜରୁରୀ |',
            passwordRequired: 'ପାସୱାର୍ଡ ଆବଶ୍ୟକ',
            confirmPasswordRequired: 'ପାସୱାର୍ଡ ନିଶ୍ଚିତ କରନ୍ତୁ',
            zipcodeCharLengthValidation: 'ନିଶ୍ଚିତ ଭାବରେ 10 ସଂଖ୍ୟା କିମ୍ବା ତା’ଠାରୁ କମ୍',
            zipCodeValidation: 'ଅବ val ଧ ଜିପକୋଡ୍',
            zipNumberVAlidation: 'କେବଳ ସଂଖ୍ୟା ବ୍ୟବହାର କରାଯାଇପାରିବ।',
            zipcodeRegexValidation: 'ସର୍ବନିମ୍ନ 4 ସଂଖ୍ୟା ଏବଂ ସର୍ବାଧିକ 10 ସଂଖ୍ୟା ଅନୁମୋଦିତ',
            addressCharLengthValidation: '100 ଅକ୍ଷର କିମ୍ବା କମ୍ ହେବା ଜରୁରୀ',
            companyNameRequired: 'କମ୍ପାନୀ ନାମ ଆବଶ୍ୟକ',
            companyName_RegexValidation: 'କେବଳ ବର୍ଣ୍ଣମାଳା ବର୍ଣ୍ଣ ଏବଂ ବିଶେଷ ବର୍ଣ୍ଣଗୁଡିକ [-, @, #, & ,!] ବ୍ୟବହାର କରାଯାଇପାରିବ |',
            orgAliasRequired: 'ସଂଗଠନ ଆଲିଆସ୍ ଆବଶ୍ୟକ',
            userAliasRequired: 'ୟୁଜର୍ ଆଲିଆସ୍ ଆବଶ୍ୟକ',
            aliasRegexValidation: 'ନିଶ୍ଚିତ ଭାବରେ ବର୍ଣ୍ଣମାଳା ବର୍ଣ୍ଣ ଧାରଣ କରିବ | କ special ଣସି ବିଶେଷ ବର୍ଣ୍ଣ ଏବଂ ସ୍ଥାନ ଅନୁମତି ନାହିଁ। ',
            domainNameRequired: 'ଦୟାକରି ଡୋମେନ୍ ନାମ ନିର୍ଦ୍ଦିଷ୍ଟ କରନ୍ତୁ।',
            domainNameRegexValidation: 'ଡୋମେନ୍ ନାମ ନିଶ୍ଚିତ ଭାବରେ ପ୍ରକାରର ହେବ https://www.example.com',
            loadingMsgOne: 'ଦୟାକରି ଅପେକ୍ଷା କର, ତୁମର ଖାତା ସୃଷ୍ଟି ହେଉଛି,',
            loadingMsgTwo: 'ଯେତେବେଳେ ତୁମର ଆକାଉଣ୍ଟ୍ ସୃଷ୍ଟି ହେଉଛି, ଡକସ୍ ପ read ଏବଂ ଜୋଡୋ ପ୍ରଡକ୍ଟ ଭିଡିଓ ଦେଖନ୍ତୁ',
            transformsales: 'ବିକ୍ରୟ ବିକ୍ରୟ',
            transformsupport: 'ଟ୍ରାନ୍ସଫର୍ମ ସପୋର୍ଟ',
            transformecommerce: 'ଟ୍ରାନ୍ସଫର୍ମ ଇ-ବାଣିଜ୍ୟ',
            emailAuthFailed: 'ଇମେଲ ଠିକଣା ପ୍ରାମାଣିକରଣ କରିବାରେ ବିଫଳ | ଦୟାକରି ପରେ ପୁନର୍ବାର ଚେଷ୍ଟା କରନ୍ତୁ | ',
            companyNameExistMsg: 'ଏହି କମ୍ପାନୀର ନାମ ପୂର୍ବରୁ ପଞ୍ଜିକୃତ ହୋଇଛି।',
            companyAliasVerifiedMsg: 'ଅନନ୍ୟ କମ୍ପାନୀ ନାମ ଯାଞ୍ଚ ହୋଇଛି',
            internalServerErrorMsg: 'ଆନ୍ତରିକ ସର୍ଭର ତୃଟି। ଦୟାକରି ପରେ ପୁନର୍ବାର ଚେଷ୍ଟା କରନ୍ତୁ ',
            invalidOTPMsg: 'ଅବ val ଧ OTP',
            userAlreadyExist: 'ଉପଭୋକ୍ତା ପୂର୍ବରୁ ବିଦ୍ୟମାନ',
            uniqueCompanyNameExist: 'ଅନନ୍ୟ କମ୍ପାନୀ ନାମ ପୂର୍ବରୁ ବିଦ୍ୟମାନ ଅଛି!',
            uniqueCompanyNameVerified: 'କମ୍ପାନୀ ନାମ ସଫଳତାର ସହିତ ଯାଞ୍ଚ ହୋଇଛି!',
            uniqueCompanyAliasVerified: 'ଅନନ୍ୟ କମ୍ପାନୀ ନାମ ସଫଳତାର ସହିତ ଯାଞ୍ଚ ହେଲା! ',
            otpSendMessage: 'ଇମେଲ୍ ଯାଞ୍ଚ',
            secondotpSendMessage: 'OTP ଆପଣଙ୍କ ମେଲକୁ ପଠାଯାଇଛି | ଦୟାକରି ଆପଣଙ୍କର ଇମେଲ୍ ବାକ୍ସ ଏବଂ ଜଙ୍କ୍ ମେଲ୍ / ସ୍ପାମ୍ ମେଲବାକ୍ସ ଯାଞ୍ଚ କରନ୍ତୁ',
            firstNameValidation: 'ପ୍ରଥମ ନାମ କେବଳ ବର୍ଣ୍ଣମାଳା ଧାରଣ କରିବା ଉଚିତ',
            lastNameValidation: 'ଶେଷ ନାମ କେବଳ ବର୍ଣ୍ଣମାଳା ଧାରଣ କରିବା ଉଚିତ',
            serviceKeyNotFound: 'ସେବା ଚାବି ମିଳିଲା ନାହିଁ',
            apiKeyNotFound: 'API ଚାବି ମିଳିଲା ନାହିଁ',
            apiKeyandServiceKeyNotFound: 'ସେବା ଚାବି ଏବଂ API ଚାବି ମିଳିଲା ନାହିଁ',
            otpValidationRegex: 'କେବଳ ସଂଖ୍ୟା ଅନୁମୋଦିତ',
            taxNo_RegexValidation: 'କେବଳ ବର୍ଣ୍ଣମାଳା ଅକ୍ଷର ଅନୁମତିପ୍ରାପ୍ତ',
            needhelp: 'ସାହାଯ୍ୟ ଦରକାର',
            companyName_RegexValidation_2: 'କମ୍ପାନୀ ନାମ ପାଇଁ କେବଳ ସ୍ୱତନ୍ତ୍ର ଅକ୍ଷର ବ୍ୟବହାର କରାଯାଇପାରିବ ନାହିଁ।',
            companyNameLengthValidation: 'ନିଶ୍ଚିତ ଭାବରେ 150 ଅକ୍ଷର କିମ୍ବା ତା’ଠାରୁ କମ୍',
            designationLengthValidation: 'ନିଶ୍ଚିତ ଭାବରେ 25 ଅକ୍ଷର କିମ୍ବା ତା’ଠାରୁ କମ୍',
            designationFieldValidation: 'ଟିପ୍ପଣୀ: କେବଳ "।" ଏବଂ "-" ପୃଥକ ଭାବରେ ଅନୁମତିପ୍ରାପ୍ତ | ',
            addressValidation: 'ଦୟାକରି ଏକ ବ address ଧ ଠିକଣା ପ୍ରବେଶ କରନ୍ତୁ।',
            imageUploadMsg: 'ଏଠାରେ କ୍ଲିକ୍ କରନ୍ତୁ କିମ୍ବା ଏକ ପ୍ରତିଛବି ଡ୍ରାଗ୍ କରନ୍ତୁ',
            imageUploadMsgRemoveBtn: 'ଅପସାରଣ',
            imageUploadMsgDoneBtn: 'ସମାପ୍ତ',
            transformSales: 'ବିକ୍ରୟ ବିକ୍ରୟ',
            transformSupport: 'ଟ୍ରାନ୍ସଫର୍ମ ସପୋର୍ଟ',
            transformCommerce: 'ଟ୍ରାନ୍ସଫର୍ମ ଇ-ବାଣିଜ୍ୟ',
            countryFieldValidation: "ଦେଶ ଆବଶ୍ୟକ",
            stateFieldValidation: "ରାଜ୍ୟ ଆବଶ୍ୟକ",
            alreadyacccreated: "ପୂର୍ବରୁ ଏକ ଖାତା ଅଛି କି?"
        }

    },
    as: {

        locale: 'as',
        messages: {
            selectlanguage: 'চাইন আপৰ বাবে এটা ভাষা নিৰ্বাচন কৰক',
            signupOtpValidation: 'OTP অন্ততঃ ৬টা আখৰ হ`ব লাগিব।',
            selectsocialacc: 'এটা সামাজিক একাউণ্ট বাছনি কৰক',
            zipcodeErrorMessage: 'অবৈধ জিপকোড',
            completeSubscriptionProcess: 'সম্পূৰ্ণ চাবস্ক্ৰিপচন প্ৰক্ৰিয়া',
            English: 'ইংৰাজী',
            Hindi: 'হিন্দী',
            Spanish: 'স্পেনিছ',
            Arabic: 'আৰবী',
            uploadprofilepic: 'প্ৰফাইল ছবি আপলোড কৰক',
            uploadcompanylogo: 'কোম্পানী ল`গ` আপলোড',
            setuplinkmsgOne: 'আপুনি প্ৰায় শেষ হৈ গ`ল',
            setupurl1: 'আপুনি প্ৰায় শেষ হৈ গ`ল।',
            setupurl2: ' তলত আপোনাৰ কাষ্টমাইজেবল জোডোলিংক',
            setupurlmesgthree: 'অনুগ্ৰহ কৰি মন কৰক যে এই পদক্ষেপটো এবাৰ সম্পূৰ্ণ হ`লে আপুনি আপোনাৰ জোডোলিংক সলনি কৰিব নোৱাৰে। যদি আপুনি ইয়াক সলনি কৰিব বিচাৰে, Finish ত ক্লিক কৰাৰ আগতে এতিয়াই কৰক।',
            setuplinkmsgTwo: '*অনুগ্ৰহ কৰি মন কৰক যে একক কোম্পানী আইডি আৰু আপোনাৰ একক ব্যৱহাৰকাৰী আইডি এবাৰ পঞ্জীয়ন কৰাৰ পিছত এই পদক্ষেপ সম্পূৰ্ণ হোৱাৰ পিছত সলনি কৰিব নোৱাৰিব। যদি আপুনি এই সময়ত এই নামসমূহৰ কোনো এটা পৰিবৰ্তন কৰিব বিচাৰে অনুগ্ৰহ কৰি পিছফালৰ কি` ব্যৱহাৰ কৰক',
            or: 'অথবা',
            language: 'ভাষা',
            emailAddress: 'ইমেইল ঠিকনা',
            enterEmail: 'আপোনাৰ ইমেইল ঠিকনা দিয়ক',
            emailexist: 'আপুনি ইতিমধ্যে আমাৰ ওচৰত পঞ্জীয়ন কৰিছে।',
            emailexist1: 'এই ইমেইল আইডিৰ সৈতে জড়িত এটা বৰ্ত্তমানৰ স্বাক্ষৰণ আছে।',
            signInTojodoToobar: 'জোডো টুলবাৰলৈ চাইন ইন',
            emailRegexValidation: 'এটা বৈধ ইমেইল ঠিকনা দিয়ক',
            emailRequiredValidation: 'ইমেইলৰ প্ৰয়োজন',
            emailMaxValidation: 'সৰ্বাধিক ১০০টা আখৰৰ অনুমতি',
            emailMinValidation: 'নূন্যতম ৫টা আখৰৰ প্ৰয়োজন।',
            enterotp: 'অনুগ্ৰহ কৰি অ`টিপি প্ৰৱেশ কৰক',
            resendotp: 'অ`টিপি পুনৰ প্ৰেৰণ কৰক',
            otpRequiredValidation: 'অনুগ্ৰহ কৰি অ`টিপিত প্ৰৱেশ কৰক',
            otpMaxLengthValidation: 'সৰ্বাধিক ১৬টা আখৰৰ অনুমতি',
            otpMaxLength: 'সৰ্বাধিক ৬টা আখৰৰ অনুমতি',
            otpMinLength: 'নূন্যতম ৬টা আখৰৰ অনুমতি',
            otpMessage: 'অনুগ্ৰহ কৰি আপোনাৰ মেইললৈ পঠোৱা ছটা সংখ্যাৰ অ`টিপি দিয়ক',
            next: 'পৰৱৰ্তী',
            signUpGoogle: 'গুগলৰ সৈতে চাইন আপ কৰক',
            signUpLinkeIn: 'লিংকডইনৰ সৈতে চাইন আপ কৰক',
            jodoteam: 'জোডো টিম',
            jodoindi: 'জোডোলিংক ব্যক্তিগত',
            jodolink: 'জোডোলিংক',
            wordpress: 'ৱৰ্ডপ্ৰেছ',
            yourInformation: 'আপোনাৰ তথ্য',
            otpverify: 'অ`টিপি ভেৰিফাই',
            signup: 'চাইনআপ',
            resendotp: 'অ`টিপি পুনৰ প্ৰেৰণ কৰক',
            billingDetails: 'বিলিঙৰ বিৱৰণ',
            setupJodoLink: 'জোডোলিংক ছেটআপ কৰক',
            setupJodoTeam: 'জোডো টিম ছেটআপ',
            setupDomainName: 'সমাপ্ত প্ৰক্ৰিয়া',
            username: 'নাম',
            lastName: 'উপাধি',
            setPassword: 'পাছৱৰ্ড',
            confirmPassword: 'পাছৱৰ্ড নিশ্চিত কৰক',
            designation: 'শিৰোনাম/নিৰ্দেশনা',
            country: 'দেশ',
            state: 'ৰাজ্য',
            city: 'চহৰ',
            zipcode: 'জিপ কোড',
            address1: 'ঠিকনা ১',
            address2: 'ঠিকনা ২',
            back: 'পিছলৈ',
            finish: 'সমাপ্ত',
            passwordRule1: '১) আপোনাৰ পাছৱৰ্ডত ৮টা আখৰ, এটা ডাঙৰ, এটা সৰু আখৰ, এটা সংখ্যা আৰু এটা বিশেষ আখৰ থাকিব লাগিব',
            passwordRule2: 'পাছৱৰ্ড আৰু নিশ্চিতকৰণ পাছৱৰ্ড একে হ`ব লাগিব।',
            passwordmatchAlert: 'পাছৱৰ্ড আৰু নিশ্চিত কৰক পাছৱৰ্ড মিল নাই ',
            passwordmatchSuccess: 'পাছৱৰ্ড আৰু নিশ্চিত কৰক পাছৱৰ্ড মিল আছে !',
            typeCityName: 'আপোনাৰ চহৰৰ নাম টাইপ কৰক',
            companyName: 'কোম্পানীৰ নাম',
            taxNo: 'কৰ নং',
            billingDetailsLocationMsg: 'আপোনাৰ বিলিং ঠিকনা আপোনাৰ তথ্য অংশত দিয়াৰ দৰে একে নেকি ?',
            domainName: 'ডমেইন নাম',
            verifyBtn: 'সত্যাপন কৰা',
            uniqueCompanyName: 'ইউনিক কোম্পানী আইডি',
            uniqueURL: 'অনন্য URL',
            uniqueUserName: 'অনন্য ব্যৱহাৰকাৰী আইডি',
            firstNameRequired: 'প্ৰথম নাম প্ৰয়োজনীয়',
            firstNameSpaceValidation: 'নামৰ আৰম্ভণি বা শেষত ঠাই ব্যৱহাৰ কৰিব নোৱাৰি।',
            lastNameRequired: 'শেষ নামটো প্ৰয়োজনীয়',
            twentyFiveCharValidation: '২৫টা আখৰ বা তাতকৈ কম হ`ব লাগিব',
            firstName_lastName_RegexValidation: 'এটা নামত কেৱল বৰ্ণমালাহে ব্যৱহাৰ কৰিব পাৰি।',
            passwordRegexValidation: '৮টা আখৰ, এটা ডাঙৰ, এটা সৰু আখৰ, এটা সংখ্যা আৰু এটা বিশেষ আখৰ থাকিব লাগিব',
            confirmPasswordMatchValidation: 'পাছৱৰ্ড আৰু নিশ্চিতকৰণ পাছৱৰ্ড একে হ`ব লাগিব।',
            passwordRequired: 'পাছৱৰ্ডৰ প্ৰয়োজন',
            confirmPasswordRequired: 'পাছৱৰ্ড নিশ্চিত কৰক',
            zipcodeCharLengthValidation: '১০ নম্বৰ বা তাতকৈ কম হ`ব লাগিব',
            zipCodeValidation: 'অবৈধ জিপকোড',
            zipNumberVAlidation: 'কেৱল নম্বৰহে ব্যৱহাৰ কৰিব পাৰিব।',
            zipcodeRegexValidation: 'নূন্যতম ৪ টা নম্বৰ আৰু সৰ্বাধিক ১০ টা নম্বৰৰ অনুমতি',
            addressCharLengthValidation: '১০০ আখৰ বা তাতকৈ কম হ`ব লাগিব',
            companyNameRequired: 'কোম্পানীৰ নাম প্ৰয়োজনীয়',
            companyName_RegexValidation: 'কেৱল আলফানিউমেৰিক আখৰ আৰু বিশেষ আখৰ [-, @, #, &,!] ব্যৱহাৰ কৰিব পাৰিব।',
            orgAliasRequired: 'সংগঠন এলিয়াছৰ প্ৰয়োজন',
            userAliasRequired: 'ব্যৱহাৰকাৰী ছদ্মনাম প্ৰয়োজনীয়',
            aliasRegexValidation: 'আলফানিউমেৰিক আখৰ থাকিব লাগিব।` কোনো বিশেষ আখৰ আৰু স্থানৰ অনুমতি নাই।',
            domainNameRequired: 'অনুগ্ৰহ কৰি ডমেইন নামটো নিৰ্দিষ্ট কৰক।',
            domainNameRegexValidation: 'ডমেইনৰ নাম https://www.example.com ধৰণৰ হ`ব লাগিব',
            loadingMsgOne: 'অনুগ্ৰহ কৰি ৰ`বা, আপোনাৰ একাউণ্ট সৃষ্টি কৰা হৈছে,',
            loadingMsgTwo: 'আপোনাৰ একাউণ্ট সৃষ্টি কৰাৰ সময়ত, নথিপত্ৰসমূহ পঢ়ক আৰু জোডো প্ৰডাক্টৰ ভিডিঅ`সমূহ চাওক',
            transformsales: 'বিক্ৰীৰ ৰূপান্তৰ',
            transformsupport: 'সমৰ্থন ৰূপান্তৰ',
            transformecommerce: 'ই-কমাৰ্চ ৰূপান্তৰিত কৰক',
            emailAuthFailed: 'ইমেইল ঠিকনা প্ৰমাণীকৰণ কৰাত ব্যৰ্থ।` অনুগ্ৰহ কৰি পিছত পুনৰ চেষ্টা কৰক।',
            companyNameExistMsg: 'এই কোম্পানীটোৰ নাম ইতিমধ্যে পঞ্জীয়ন কৰা হৈছে।',
            companyAliasVerifiedMsg: 'অনন্য কোম্পানীৰ নাম পৰীক্ষিত',
            internalServerErrorMsg: 'আভ্যন্তৰীণ চাৰ্ভাৰৰ ত্ৰুটি।` অনুগ্ৰহ কৰি পিছত পুনৰ চেষ্টা কৰক',
            invalidOTPMsg: 'অবৈধ অ`টিপি',
            userAlreadyExist: 'ব্যৱহাৰকাৰী ইতিমধ্যে আছে',
            uniqueCompanyNameExist: 'ইউনিক কোম্পানীৰ নাম ইতিমধ্যে আছে !',
            uniqueCompanyNameVerified: 'কোম্পানীৰ নাম সফলভাৱে পৰীক্ষা কৰা হৈছে !',
            uniqueCompanyAliasVerified: 'অনন্য কোম্পানীৰ নাম সফলতাৰে পৰীক্ষা কৰা হৈছে ! ',
            otpSendMessage: 'ইমেইল পৰীক্ষণ',
            secondotpSendMessage: 'অ`টিপি আপোনাৰ মেইললৈ পঠিওৱা হৈছে।` অনুগ্ৰহ কৰি আপোনাৰ ইমেইল বক্স আৰু জাংক মেইল / স্পেম মেইলবক্স পৰীক্ষা কৰক',
            firstNameValidation: 'প্ৰথম নাম কেৱল বৰ্ণমালাৰে গঠিত হ`ব লাগে',
            lastNameValidation: 'শেষ নাম কেৱল বৰ্ণমালাৰে গঠিত হ`ব লাগে',
            serviceKeyNotFound: 'সেৱা চাবি পোৱা নগ`ল',
            apiKeyNotFound: 'এপিআই চাবি পোৱা নগ`ল',
            apiKeyandServiceKeyNotFound: 'সেৱা চাবি আৰু এপিআই কি` পোৱা নগ`ল',
            otpValidationRegex: 'কেৱল নম্বৰৰ অনুমতি',
            taxNo_RegexValidation: 'কেৱল আলফানিউমেৰিক আখৰৰ অনুমতি',
            needhelp: 'সহায়ৰ প্ৰয়োজন',
            companyName_RegexValidation_2: 'কোম্পানীৰ নামৰ বাবে কেৱল বিশেষ আখৰ ব্যৱহাৰ কৰিব নোৱাৰিব।',
            companyNameLengthValidation: '১৫০ আখৰ বা তাতকৈ কম হ`ব লাগিব',
            designationLengthValidation: '২৫টা আখৰ বা তাতকৈ কম হ`ব লাগিব',
            designationFieldValidation: 'টোকা:কেৱল "।" আৰু "-" বিভাজক হিচাপে অনুমতি দিয়া হৈছে।',
            addressValidation: 'অনুগ্ৰহ কৰি এটা বৈধ ঠিকনা দিয়ক।',
            imageUploadMsg: 'ইয়াত ক্লিক কৰক বা এটা ছবি টানিব',
            imageUploadMsgRemoveBtn: ' আঁতৰোৱা',
            imageUploadMsgDoneBtn: 'কৰা হ’ল',
            transformSales: 'বিক্ৰীৰ ৰূপান্তৰ',
            transformSupport: 'সমৰ্থন ৰূপান্তৰ',
            transformCommerce: 'ই-কমাৰ্চৰ ৰূপান্তৰ',
            countryFieldValidation: "দেশ প্ৰয়োজনীয়",
            stateFieldValidation: "ৰাজ্য প্ৰয়োজনীয়",
            alreadyacccreated: "আপোনাৰ ইতিমধ্যে একাউণ্ট আছে নে?"
        }

    },
    te: {
        locale: 'te',
        messages: {

            selectlanguage: 'సైన్ అప్ కోసం భాషను ఎంచుకోండి',
            signupOtpValidation: 'OTP తప్పనిసరిగా కనీసం 6 అక్షరాలు ఉండాలి.',
            selectsocialacc: 'సామాజిక ఖాతాను ఎంచుకోండి',
            zipcodeErrorMessage: 'చెల్లని జిప్ కోడ్',
            completeSubscriptionProcess: 'కంప్లీట్ సబ్‌స్క్రిప్షన్ ప్రాసెస్',
            English: 'ఆంగ్ల',
            Hindi: 'హిందీ',
            Spanish: 'స్పానిష్',
            Arabic: 'అరబిక్',
            uploadprofilepic: 'ప్రొఫైల్ చిత్రాన్ని అప్‌లోడ్ చేయి',
            uploadcompanylogo: 'కంపెనీ లోగోను అప్‌లోడ్ చేయి',
            setuplinkmsgOne: 'మీరు దాదాపు పూర్తి చేసారు',
            setupurl1: 'మీరు దాదాపు పూర్తి చేసారు.',
            setupurl2: 'మీ అనుకూలీకరించదగిన  క్రింద ఉంది',
            setupurlmesgthree: 'ఈ దశ పూర్తయిన తర్వాత, మీరు మీ என்ற మార్చలేరని దయచేసి గమనించండి. మీరు దీన్ని మార్చాలనుకుంటే, ముగించుపై క్లిక్ చేసే ముందు ఇప్పుడే చేయండి.',
            setuplinkmsgTwo: '*దయచేసి ఒకసారి నమోదు చేసుకున్న ప్రత్యేక కంపెనీ ID మరియు మీ ప్రత్యేక వినియోగదారు ID ఈ దశ పూర్తయిన తర్వాత మార్చబడదని దయచేసి గమనించండి. మీరు ఈ సమయంలో ఈ పేర్లలో దేనినైనా సవరించాలనుకుంటే, దయచేసి వెనుక కీని ఉపయోగించండి',
            or: 'లేదా',
            language: 'భాష',
            emailAddress: 'ఈమెయిల్ చిరునామా',
            enterEmail: 'మీ ఈ మెయిల్ వివరాలని నమోదు చేయండి',
            emailexist: 'మీరు ఇప్పటికే మా వద్ద నమోదు చేసుకున్నారు.',
            emailexist1: 'ఈ ఇమెయిల్ IDతో అనుబంధించబడిన చందా ఇప్పటికే ఉంది.',
            signInTojodoToobar: 'జోడో టూల్‌బార్‌కి సైన్ ఇన్ చేయండి',
            emailRegexValidation: 'చెల్లుబాటు అయ్యే ఇమెయిల్ చిరునామాను నమోదు చేయండి',
            emailRequiredValidation: 'ఈమెయిల్ అవసరం',
            emailMaxValidation: 'గరిష్టంగా 100 అక్షరాలు అనుమతించబడతాయి',
            emailMinValidation: 'కనీసం 5 అక్షరాలు అవసరం.',
            enterotp: 'దయచేసి OTPని నమోదు చేయండి',
            resendotp: 'OTP ను మళ్ళీ పంపు',
            otpRequiredValidation: 'దయచేసి OTPని నమోదు చేయండి',
            otpMaxLengthValidation: 'గరిష్టంగా 16 అక్షరాలు అనుమతించబడతాయి',
            otpMaxLength: 'గరిష్టంగా 6 అక్షరాలు అనుమతించబడతాయి',
            otpMinLength: 'కనీసం 6 అక్షరాలు అనుమతించబడతాయి',
            otpMessage: 'దయచేసి మీ మెయిల్‌కి పంపబడిన ఆరు అంకెల OTPని నమోదు చేయండి',
            next: 'తరువాత',
            signUpGoogle: 'గూగుల్ తో సైన్ అప్ చేయండి',
            signUpLinkeIn: 'లింక్డ్‌ఇన్‌తో సైన్ అప్ చేయండి',
            jodoteam: 'జోడో టీమ్',
            jodoindi: 'జోడోలింక్ ఇండివిజువల్',
            jodolink: 'జోడోలింక్',
            wordpress: 'వర్డ్ ప్రెస్',
            yourInformation: 'మీ వివరములు',
            otpverify: 'OTP వెరిఫై',
            signup: 'చేరడం',
            resendotp: 'OTP ను మళ్ళీ పంపు',
            billingDetails: 'బిల్లింగ్ వివరాలు',
            setupJodoLink: 'జోడోలింక్‌ని సెటప్ చేయండి',
            setupJodoTeam: 'జోడో టీమ్‌ని సెటప్ చేయండి',
            setupDomainName: 'ఫినిష్ ప్రాసెస్',
            username: 'పేరు',
            lastName: 'చివరి పేరు',
            setPassword: 'పాస్‌వర్డ్',
            confirmPassword: 'పాస్‌వర్డ్‌ని నిర్ధారించండి',
            designation: 'శీర్షిక/హోదా',
            country: 'దేశం',
            state: 'రాష్ట్రం',
            city: 'నగరం',
            zipcode: 'జిప్ కోడ్',
            address1: 'చిరునామా 1',
            address2: 'చిరునామా 2',
            back: 'వెనుక',
            finish: 'ముగించు',
            passwordRule1: '1) మీ పాస్‌వర్డ్ తప్పనిసరిగా 8 అక్షరాలు, ఒక పెద్ద అక్షరం, ఒక చిన్న అక్షరం, ఒక సంఖ్య మరియు ఒక ప్రత్యేక కేస్ అక్షరాన్ని కలిగి ఉండాలి',
            passwordRule2: 'పాస్‌వర్డ్ మరియు నిర్ధారణ పాస్‌వర్డ్ తప్పనిసరిగా ఒకేలా ఉండాలి.',
            passwordmatchAlert: 'పాస్‌వర్డ్ మరియు కన్ఫర్మ్ పాస్‌వర్డ్‌లు సరిపోలడం లేదు',
            passwordmatchSuccess: 'పాస్‌వర్డ్ మరియు పాస్‌వర్డ్ సరిపోలినట్లు నిర్ధారించండి!',
            typeCityName: 'మీ నగరం పేరును టైప్ చేయండి',
            companyName: 'కంపెనీ పేరు',
            taxNo: 'పన్ను నం.',
            billingDetailsLocationMsg: 'మీ సమాచార విభాగంలో అందించిన విధంగానే మీ బిల్లింగ్ చిరునామా ఉందా?',
            domainName: 'డొమైన్ పేరు',
            verifyBtn: 'ధృవీకరించు',
            uniqueCompanyName: 'ప్రత్యేకమైన కంపెనీ ID',
            uniqueURL: 'ప్రత్యేక URL',
            uniqueUserName: 'ప్రత్యేక వినియోగదారు ఐడి',
            firstNameRequired: 'మొదటి పేరు అవసరం',
            firstNameSpaceValidation: 'మీరు పేరు ప్రారంభంలో లేదా చివరిలో ఖాళీని ఉపయోగించలేరు.',
            lastNameRequired: 'చివరి పేరు అవసరం',
            twentyFiveCharValidation: 'తప్పక 25 అక్షరాలు లేదా అంతకంటే తక్కువ ఉండాలి',
            firstName_lastName_RegexValidation: 'పేరులో అక్షరాలు మాత్రమే ఉపయోగించబడతాయి.',
            passwordRegexValidation: 'తప్పక 8 అక్షరాలు, ఒక పెద్ద అక్షరం, ఒక చిన్న అక్షరం, ఒక సంఖ్య మరియు ఒక ప్రత్యేక కేస్ అక్షరం ఉండాలి',
            confirmPasswordMatchValidation: 'పాస్‌వర్డ్ మరియు నిర్ధారణ పాస్‌వర్డ్ తప్పనిసరిగా ఒకేలా ఉండాలి.',
            passwordRequired: 'పాస్‌వర్డ్ అవసరం',
            confirmPasswordRequired: 'పాస్‌వర్డ్‌ని నిర్ధారించడం అవసరం',
            zipcodeCharLengthValidation: 'తప్పక 10 సంఖ్యలు లేదా అంతకంటే తక్కువ ఉండాలి',
            zipCodeValidation: 'చెల్లని జిప్ కోడ్',
            zipNumberVAlidation: 'నంబర్ మాత్రమే ఉపయోగించవచ్చు.',
            zipcodeRegexValidation: 'కనీసం 4 సంఖ్యలు మరియు గరిష్టంగా 10 సంఖ్యలు అనుమతించబడతాయి',
            addressCharLengthValidation: 'తప్పక 100 అక్షరాలు లేదా అంతకంటే తక్కువ ఉండాలి',
            companyNameRequired: 'కంపెనీ పేరు అవసరం',
            companyName_RegexValidation: 'ఆల్ఫాన్యూమరిక్ అక్షరాలు మరియు ప్రత్యేక అక్షరాలు [-, @, #, &,!] మాత్రమే ఉపయోగించబడతాయి.',
            orgAliasRequired: 'సంస్థ అలియాస్ అవసరం',
            userAliasRequired: 'యూజర్ అలియాస్ అవసరం',
            aliasRegexValidation: 'తప్పక ఆల్ఫాన్యూమరిక్ అక్షరాలను కలిగి ఉండాలి. ప్రత్యేక అక్షరాలు మరియు స్థలం అనుమతించబడవు.',
            domainNameRequired: 'దయచేసి డొమైన్ పేరును పేర్కొనండి.',
            domainNameRegexValidation: 'డొమైన్ పేరు తప్పనిసరిగా `https://www.example.com` రకంగా ఉండాలి',
            loadingMsgOne: 'దయచేసి వేచి ఉండండి, మీ ఖాతా సృష్టించబడుతోంది,',
            loadingMsgTwo: 'మీ ఖాతా సృష్టించబడుతున్నప్పుడు, డాక్స్ చదవండి మరియు జోడో ఉత్పత్తి వీడియోలను వీక్షించండి',
            transformsales: 'ట్రాన్స్‌ఫార్మ్ సేల్స్',
            transformsupport: 'ట్రాన్స్‌ఫార్మ్ సపోర్ట్',
            transformecommerce: 'ట్రాన్స్‌ఫార్మ్ ఈ-కామర్స్',
            emailAuthFailed: 'ఇమెయిల్ చిరునామాను ప్రామాణీకరించడంలో విఫలమైంది. దయచేసి తర్వాత మళ్లీ ప్రయత్నించండి.',
            companyNameExistMsg: 'ఈ కంపెనీ పేరు ఇప్పటికే నమోదు చేయబడింది.',
            companyAliasVerifiedMsg: 'ప్రత్యేకమైన కంపెనీ పేరు ధృవీకరించబడింది',
            internalServerErrorMsg: 'అంతర్గత సర్వర్ లోపం. దయచేసి తర్వాత మళ్లీ ప్రయత్నించండి',
            invalidOTPMsg: 'చెల్లని OTP',
            userAlreadyExist: 'వినియోగదారు ఇప్పటికే ఉన్నారు',
            uniqueCompanyNameExist: 'ప్రత్యేకమైన కంపెనీ పేరు ఇప్పటికే ఉంది!',
            uniqueCompanyNameVerified: 'కంపెనీ పేరు విజయవంతంగా ధృవీకరించబడింది!',
            uniqueCompanyAliasVerified: 'ప్రత్యేకమైన కంపెనీ పేరు విజయవంతంగా ధృవీకరించబడింది! ',
            otpSendMessage: 'ఈమెయిల్ ధృవీకరణ',
            secondotpSendMessage: 'మీ మెయిల్‌కి OTP పంపబడింది. దయచేసి మీ ఇమెయిల్ బాక్స్ & జంక్ మెయిల్ / స్పామ్ మెయిల్‌బాక్స్‌ని ధృవీకరించండి',
            firstNameValidation: 'మొదటి పేరు వర్ణమాలలను మాత్రమే కలిగి ఉండాలి',
            lastNameValidation: 'చివరి పేరు వర్ణమాలలను మాత్రమే కలిగి ఉండాలి',
            serviceKeyNotFound: 'సర్వీస్ కీ కనుగొనబడలేదు',
            apiKeyNotFound: 'API కీ కనుగొనబడలేదు',
            apiKeyandServiceKeyNotFound: 'సర్వీస్ కీ మరియు API కీ కనుగొనబడలేదు',
            otpValidationRegex: 'నంబర్ మాత్రమే అనుమతించబడుతుంది',
            taxNo_RegexValidation: 'ఆల్ఫాన్యూమరిక్ అక్షరాలు మాత్రమే అనుమతించబడతాయి',
            needhelp: 'సహాయం కావాలి',
            companyName_RegexValidation_2: 'సంస్థ పేరు కోసం ప్రత్యేక అక్షరాలు మాత్రమే ఉపయోగించబడవు.',
            companyNameLengthValidation: 'తప్పక 150 అక్షరాలు లేదా అంతకంటే తక్కువ ఉండాలి',
            designationLengthValidation: 'తప్పక 25 అక్షరాలు లేదా అంతకంటే తక్కువ ఉండాలి',
            designationFieldValidation: 'గమనిక: కేవలం "." మరియు "-" సెపరేటర్‌లుగా అనుమతించబడతాయి.',
            addressValidation: 'దయచేసి చెల్లుబాటు అయ్యే చిరునామాను నమోదు చేయండి.',
            imageUploadMsg: 'ఇక్కడ క్లిక్ చేయండి లేదా చిత్రాన్ని లాగండి',
            imageUploadMsgRemoveBtn: 'తొలగించు',
            imageUploadMsgDoneBtn: 'పూర్తి',
            transformSales: 'ట్రాన్స్‌ఫార్మ్ సేల్స్',
            transformSupport: 'ట్రాన్స్‌ఫార్మ్ సపోర్ట్',
            transformCommerce: 'ట్రాన్స్‌ఫార్మ్ ఈ-కామర్స్',
            countryFieldValidation: "దేశం అవసరం",
            stateFieldValidation: "రాష్ట్రం అవసరం",
            alreadyacccreated: "మీకు ఇప్పటికే ఖాతా ఉందా?"

        }


    },
    ml: {
        locale: 'ml',
        messages: {
            selectlanguage: 'സൈൻ അപ്പ് ചെയ്യുന്നതിന് ഒരു ഭാഷ തിരഞ്ഞെടുക്കുക',
            signupOtpValidation: 'OTP കുറഞ്ഞത് 6 പ്രതീകങ്ങൾ ആയിരിക്കണം.',
            selectsocialacc: 'ഒരു സോഷ്യൽ അക്കൗണ്ട് തിരഞ്ഞെടുക്കുക',
            zipcodeErrorMessage: 'അസാധുവായ പിൻകോഡ്',
            completeSubscriptionProcess: 'സബ്‌സ്‌ക്രിപ്‌ഷൻ പ്രക്രിയ പൂർത്തിയാക്കുക',
            English: 'ഇംഗ്ലീഷ്',
            Hindi: 'ഹിന്ദി',
            Spanish: 'സ്പാനിഷ്',
            Arabic: 'അറബിക്',
            uploadprofilepic: 'പ്രൊഫൈൽ ചിത്രം അപ്‌ലോഡ് ചെയ്യുക',
            uploadcompanylogo: 'കമ്പനി ലോഗോ അപ്‌ലോഡ് ചെയ്യുക',
            setuplinkmsgOne: 'നിങ്ങൾ ഏതാണ്ട് പൂർത്തിയാക്കി',
            setupurl1: 'നിങ്ങൾ ഏതാണ്ട് പൂർത്തിയാക്കി.',
            setupurl2: 'നിങ്ങളുടെ ഇഷ്ടാനുസൃതമാക്കാവുന്ന ജോഡോ ലിങ്ക് ചുവടെയുണ്ട്',
            setupurlmesgthree: 'ഈ ഘട്ടം ചെയ്തുകഴിഞ്ഞാൽ, നിങ്ങളുടെ  മാറ്റാൻ കഴിയില്ലെന്നത് ശ്രദ്ധിക്കുക. നിങ്ങൾക്ക് ഇത് മാറ്റണമെങ്കിൽ, പൂർത്തിയാക്കുക എന്നതിൽ ക്ലിക്കുചെയ്യുന്നതിന് മുമ്പ് അത് ചെയ്യുക.',
            setuplinkmsgTwo: '*യുണീക്ക് കമ്പനി ഐഡിയും ഒരിക്കൽ രജിസ്റ്റർ ചെയ്ത നിങ്ങളുടെ യുണീക്ക് യൂസർ ഐഡിയും ഈ ഘട്ടം പൂർത്തിയാകുമ്പോൾ മാറ്റാൻ കഴിയില്ലെന്നത് ശ്രദ്ധിക്കുക. ഈ സമയത്ത് ഈ പേരുകളിൽ എന്തെങ്കിലും മാറ്റം വരുത്താൻ നിങ്ങൾ ആഗ്രഹിക്കുന്നുവെങ്കിൽ, ദയവായി ബാക്ക് കീ ഉപയോഗിക്കുക',
            or: 'അഥവാ',
            language: 'ഭാഷ',
            emailAddress: 'ഇമെയിൽ വിലാസം',
            enterEmail: 'നിങ്ങളുടെ ഇമെയിൽ വിലാസം നൽകുക',
            emailexist: 'നിങ്ങൾ ഇതിനകം ഞങ്ങളിൽ രജിസ്റ്റർ ചെയ്തിട്ടുണ്ട്.',
            emailexist1: 'ഈ ഇമെയിൽ ഐഡിയുമായി ബന്ധപ്പെട്ട് നിലവിലുള്ള ഒരു സബ്‌സ്‌ക്രിപ്‌ഷൻ ഉണ്ട്.',
            signInTojodoToobar: 'ജോഡോ ടൂൾബാറിലേക്ക് സൈൻ ഇൻ ചെയ്യുക',
            emailRegexValidation: 'സാധുവായ ഒരു ഇമെയിൽ വിലാസം നൽകുക',
            emailRequiredValidation: 'ഇമെയിൽ ആവശ്യമാണ്',
            emailMaxValidation: 'പരമാവധി 100 പ്രതീകങ്ങൾ അനുവദനീയം',
            emailMinValidation: 'കുറഞ്ഞത് 5 പ്രതീകങ്ങൾ ആവശ്യമാണ്.',
            enterotp: 'ദയവായി OTP നൽകുക',
            resendotp: 'ഒടിപി വീണ്ടും അയയ്‌ക്കുക',
            otpRequiredValidation: 'ദയവായി OTP നൽകുക',
            otpMaxLengthValidation: 'പരമാവധി 16 പ്രതീകങ്ങൾ അനുവദനീയമാണ്',
            otpMaxLength: 'പരമാവധി 6 പ്രതീകങ്ങൾ അനുവദനീയം',
            otpMinLength: 'കുറഞ്ഞത് 6 പ്രതീകങ്ങൾ അനുവദനീയമാണ്',
            otpMessage: 'നിങ്ങളുടെ മെയിലിലേക്ക് അയച്ച ആറ് അക്ക OTP ദയവായി നൽകുക',
            next: 'അടുത്തത്',
            signUpGoogle: 'ഗൂഗിൾ ഉപയോഗിച്ച് സൈൻ അപ്പ് ചെയ്യുക',
            signUpLinkeIn: 'ലിങ്ക്ഡ്ഇൻ ഉപയോഗിച്ച് സൈൻ അപ്പ് ചെയ്യുക',
            jodoteam: 'ജോഡോ ടീം',
            jodoindi: 'ജോഡോലിങ്ക് ഇൻഡിവിഡ്വൽ',
            jodolink: 'ജോഡോ ലിങ്ക്',
            wordpress: 'വേർഡ്പ്രസ്സ്',
            yourInformation: 'നിങ്ങളുടെ വിവരങ്ങൾ',
            otpverify: 'OTP പരിശോധിച്ചുറപ്പിക്കുക',
            signup: 'സൈൻ അപ്പ് ചെയ്യുക',
            resendotp: 'ഒടിപി വീണ്ടും അയയ്‌ക്കുക',
            billingDetails: 'ബില്ലിംഗ് വിശദാംശങ്ങൾ',
            setupJodoLink: 'ജോഡോ ലിങ്ക് സജ്ജീകരിക്കുക',
            setupJodoTeam: 'ജോഡോ ടീം സജ്ജീകരിക്കുക',
            setupDomainName: 'പ്രക്രിയ പൂർത്തിയാക്കുക',
            username: 'പേര്',
            lastName: 'പേരിന്റെ അവസാന ഭാഗം',
            setPassword: 'Password',
            confirmPassword: 'പാസ്വേഡ് സ്ഥിരീകരിക്കുക',
            designation: 'ശീർഷകം/പദവി',
            country: 'രാജ്യം',
            state: 'സംസ്ഥാനം',
            city: 'നഗരം',
            zipcode: 'തപാൽ കോഡ്',
            address1: 'വിലാസം 1',
            address2: 'വിലാസം 2',
            back: 'തിരിച്ചു',
            finish: 'പൂർത്തിയാക്കുക',
            passwordRule1: '1) നിങ്ങളുടെ പാസ്‌വേഡിൽ 8 പ്രതീകങ്ങൾ, ഒരു വലിയക്ഷരം, ഒരു ചെറിയക്ഷരം, ഒരു സംഖ്യ, ഒരു പ്രത്യേക അക്ഷരം എന്നിവ അടങ്ങിയിരിക്കണം',
            passwordRule2: 'പാസ്‌വേഡും സ്ഥിരീകരണ പാസ്‌വേഡും ഒന്നായിരിക്കണം.',
            passwordmatchAlert: 'പാസ്‌വേഡും സ്ഥിരീകരണ പാസ്‌വേഡുകളും പൊരുത്തപ്പെടുന്നില്ല',
            passwordmatchSuccess: 'പാസ്‌വേഡും പാസ്‌വേഡും പൊരുത്തപ്പെട്ടതായി സ്ഥിരീകരിക്കുക!',
            typeCityName: 'നിങ്ങളുടെ നഗരത്തിൻ്റെ പേര് ടൈപ്പ് ചെയ്യുക',
            companyName: 'കമ്പനി പേര്',
            taxNo: 'നികുതി നമ്പർ',
            billingDetailsLocationMsg: 'നിങ്ങളുടെ ബില്ലിംഗ് വിലാസം നിങ്ങളുടെ വിവര വിഭാഗത്തിൽ നൽകിയിരിക്കുന്നത് തന്നെയാണോ?',
            domainName: 'ഡൊമെയ്ൻ നാമം',
            verifyBtn: 'സ്ഥിരീകരിക്കുക',
            uniqueCompanyName: 'യുണീക് കമ്പനി ഐഡി',
            uniqueURL: 'അദ്വിതീയ URL',
            uniqueUserName: 'യുണീക് യൂസർ ഐഡി',
            firstNameRequired: 'ആദ്യ പേര് ആവശ്യമാണ്',
            firstNameSpaceValidation: 'ഒരു പേരിൻ്റെ തുടക്കത്തിലോ അവസാനത്തിലോ നിങ്ങൾക്ക് ഇടം ഉപയോഗിക്കാൻ കഴിയില്ല.',
            lastNameRequired: 'അവസാന നാമം ആവശ്യമാണ്',
            twentyFiveCharValidation: '25 പ്രതീകങ്ങളോ അതിൽ കുറവോ ആയിരിക്കണം',
            firstName_lastName_RegexValidation: 'ഒരു പേരിൽ അക്ഷരമാല മാത്രമേ ഉപയോഗിക്കാനാകൂ.',
            passwordRegexValidation: '8 പ്രതീകങ്ങൾ, ഒരു വലിയക്ഷരം, ഒരു ചെറിയക്ഷരം, ഒരു സംഖ്യ, ഒരു പ്രത്യേക അക്ഷരം എന്നിവ അടങ്ങിയിരിക്കണം',
            confirmPasswordMatchValidation: 'പാസ്‌വേഡും സ്ഥിരീകരണ പാസ്‌വേഡും ഒന്നായിരിക്കണം.',
            passwordRequired: 'പാസ്‌വേഡ് ആവശ്യമാണ്',
            confirmPasswordRequired: 'പാസ്‌വേഡ് സ്ഥിരീകരിക്കേണ്ടത് ആവശ്യമാണ്',
            zipcodeCharLengthValidation: '10 അക്കങ്ങളോ അതിൽ കുറവോ ആയിരിക്കണം',
            zipCodeValidation: 'അസാധുവായ പിൻകോഡ്',
            zipNumberVAlidation: 'നമ്പർ മാത്രമേ ഉപയോഗിക്കാനാകൂ.',
            zipcodeRegexValidation: 'കുറഞ്ഞത് 4 നമ്പറുകളും പരമാവധി 10 നമ്പറുകളും അനുവദനീയമാണ്',
            addressCharLengthValidation: '100 പ്രതീകങ്ങളോ അതിൽ കുറവോ ആയിരിക്കണം',
            companyNameRequired: 'കമ്പനിയുടെ പേര് ആവശ്യമാണ്',
            companyName_RegexValidation: 'ആൽഫാന്യൂമെറിക് പ്രതീകങ്ങളും പ്രത്യേക പ്രതീകങ്ങളും [-, @, #, &,!] മാത്രമേ ഉപയോഗിക്കാനാകൂ.',
            orgAliasRequired: 'ഓർഗനൈസേഷൻ അപരനാമം ആവശ്യമാണ്',
            userAliasRequired: 'ഉപയോക്താവിൻ്റെ അപരനാമം ആവശ്യമാണ്',
            aliasRegexValidation: 'ആൽഫാന്യൂമെറിക് പ്രതീകങ്ങൾ അടങ്ങിയിരിക്കണം. പ്രത്യേക പ്രതീകങ്ങളും സ്ഥലവും അനുവദനീയമല്ല.',
            domainNameRequired: 'ദയവായി ഡൊമെയ്ൻ നാമം വ്യക്തമാക്കുക.',
            domainNameRegexValidation: 'ഡൊമെയ്ൻ നാമം https://www.example.com എന്ന തരത്തിലായിരിക്കണം',
            loadingMsgOne: 'ദയവായി കാത്തിരിക്കൂ, നിങ്ങളുടെ അക്കൗണ്ട് സൃഷ്ടിക്കപ്പെടുന്നു,',
            loadingMsgTwo: 'നിങ്ങളുടെ അക്കൗണ്ട് സൃഷ്‌ടിക്കുമ്പോൾ, ഡോക്‌സ് വായിച്ച് ജോഡോ ഉൽപ്പന്ന വീഡിയോകൾ കാണുക',
            transformsales: 'ട്രാൻസ്‌ഫോം സെയിൽസ്',
            transformsupport: 'ട്രാൻസ്‌ഫോം സപ്പോർട്ട്',
            transformecommerce: 'ട്രാൻസ്‌ഫോം ഇ-കൊമേഴ്‌സ്',
            emailAuthFailed: 'ഇമെയിൽ വിലാസം പ്രാമാണീകരിക്കുന്നതിൽ പരാജയപ്പെട്ടു. ദയവായി പിന്നീട് വീണ്ടും ശ്രമിക്കുക.',
            companyNameExistMsg: 'ഈ കമ്പനിയുടെ പേര് ഇതിനകം രജിസ്റ്റർ ചെയ്തിട്ടുണ്ട്.',
            companyAliasVerifiedMsg: 'അദ്വിതീയ കമ്പനിയുടെ പേര് പരിശോധിച്ചു',
            internalServerErrorMsg: 'ഇന്റേർണൽ സെർവർ പിശക്. ദയവായി പിന്നീട് വീണ്ടും ശ്രമിക്കുക',
            invalidOTPMsg: 'അസാധുവായ OTP',
            userAlreadyExist: 'ഉപയോക്താവ് ഇതിനകം നിലവിലുണ്ട്',
            uniqueCompanyNameExist: 'അദ്വിതീയ കമ്പനി നാമം ഇതിനകം നിലവിലുണ്ട്!',
            uniqueCompanyNameVerified: 'കമ്പനിയുടെ പേര് വിജയകരമായി പരിശോധിച്ചു!',
            uniqueCompanyAliasVerified: 'അദ്വിതീയ കമ്പനിയുടെ പേര് വിജയകരമായി പരിശോധിച്ചു! ',
            otpSendMessage: 'ഇമെയിൽ പരിശോധന',
            secondotpSendMessage: 'നിങ്ങളുടെ മെയിലിലേക്ക് OTP അയച്ചിട്ടുണ്ട്. നിങ്ങളുടെ ഇമെയിൽ ബോക്സും ജങ്ക് മെയിലും / സ്പാം മെയിൽബോക്സും സ്ഥിരീകരിക്കുക',
            firstNameValidation: 'ആദ്യ നാമത്തിൽ അക്ഷരമാല മാത്രം അടങ്ങിയിരിക്കണം',
            lastNameValidation: 'അവസാന നാമത്തിൽ അക്ഷരമാലകൾ മാത്രം അടങ്ങിയിരിക്കണം',
            serviceKeyNotFound: 'സേവന കീ കണ്ടെത്തിയില്ല',
            apiKeyNotFound: 'API കീ കണ്ടെത്തിയില്ല',
            apiKeyandServiceKeyNotFound: 'സേവന കീയും API കീയും കണ്ടെത്തിയില്ല',
            otpValidationRegex: 'നമ്പർ മാത്രമേ അനുവദിക്കൂ',
            taxNo_RegexValidation: 'ആൽഫാന്യൂമെറിക് പ്രതീകങ്ങൾ മാത്രം അനുവദനീയം',
            needhelp: 'സഹായം ആവശ്യമുണ്ട്',
            companyName_RegexValidation_2: 'കമ്പനിയുടെ പേരിന് പ്രത്യേക പ്രതീകങ്ങൾ മാത്രം ഉപയോഗിക്കാൻ കഴിയില്ല.',
            companyNameLengthValidation: '150 പ്രതീകങ്ങളോ അതിൽ കുറവോ ആയിരിക്കണം',
            designationLengthValidation: '25 പ്രതീകങ്ങളോ അതിൽ കുറവോ ആയിരിക്കണം',
            designationFieldValidation: 'ശ്രദ്ധിക്കുക:" മാത്രം." "-" എന്നിവ വിഭജകങ്ങളായി അനുവദനീയമാണ്.',
            addressValidation: 'ദയവായി സാധുവായ ഒരു വിലാസം നൽകുക.',
            imageUploadMsg: 'ഇവിടെ ക്ലിക്ക് ചെയ്യുക അല്ലെങ്കിൽ ഒരു ചിത്രം വലിച്ചിടുക',
            imageUploadMsgRemoveBtn: 'നീക്കം',
            imageUploadMsgDoneBtn: 'കഴിഞ്ഞു',
            transformSales: 'ട്രാൻസ്‌ഫോം സെയിൽസ്',
            transformSupport: 'ട്രാൻസ്‌ഫോം സപ്പോർട്ട്',
            transformCommerce: 'ഇ-കൊമേഴ്‌സ് പരിവർത്തനം ചെയ്യുക',
            countryFieldValidation: "രാജ്യം ആവശ്യമാണ്",
            stateFieldValidation: "സംസ്ഥാനം ആവശ്യമാണ്",
            alreadyacccreated: "നിങ്ങൾക്ക് ഇതിനകം ഒരു അക്കൗണ്ട് ഉണ്ടോ?"


        }

    },
    kn: {
        locale: 'kn',
        messages: {
            selectlanguage: 'ಸೈನ್ ಅಪ್ ಮಾಡಲು ಭಾಷೆಯನ್ನು ಆಯ್ಕೆಮಾಡಿ',
            signupOtpValidation: 'OTP ಕನಿಷ್ಠ 6 ಅಕ್ಷರಗಳಾಗಿರಬೇಕು.',
            selectsocialacc: 'ಸಾಮಾಜಿಕ ಖಾತೆಯನ್ನು ಆಯ್ಕೆಮಾಡಿ',
            zipcodeErrorMessage: 'ಅಮಾನ್ಯವಾದ ಪಿನ್ ಕೋಡ್',
            completeSubscriptionProcess: 'ಸಂಪೂರ್ಣ ಚಂದಾದಾರಿಕೆ ಪ್ರಕ್ರಿಯೆ',
            English: 'ಆಂಗ್ಲ',
            Hindi: 'ಹಿಂದಿ',
            Spanish: 'ಸ್ಪ್ಯಾನಿಷ್',
            Arabic: 'ಅರೇಬಿಕ್',
            uploadprofilepic: 'ಪ್ರೊಫೈಲ್ ಚಿತ್ರವನ್ನು ಅಪ್‌ಲೋಡ್ ಮಾಡಿ',
            uploadcompanylogo: 'ಕಂಪನಿಯ ಲೋಗೋವನ್ನು ಅಪ್‌ಲೋಡ್ ಮಾಡಿ',
            setuplinkmsgOne: 'ನೀವು ಬಹುತೇಕ ಮುಗಿಸಿದ್ದೀರಿ',
            setupurl1: 'ನೀವು ಬಹುತೇಕ ಮುಗಿಸಿದ್ದೀರಿ.',
            setupurl2: 'ಕೆಳಗೆ ನಿಮ್ಮ ಕಸ್ಟಮೈಸ್ ಮಾಡಬಹುದಾದ ',
            setupurlmesgthree: 'ಒಮ್ಮೆ ಈ ಹಂತವನ್ನು ಪೂರ್ಣಗೊಳಿಸಿದರೆ, ನಿಮ್ಮ  ಅನ್ನು ನೀವು ಬದಲಾಯಿಸಲು ಸಾಧ್ಯವಿಲ್ಲ ಎಂಬುದನ್ನು ದಯವಿಟ್ಟು ಗಮನಿಸಿ. ನೀವು ಅದನ್ನು ಬದಲಾಯಿಸಲು ಬಯಸಿದರೆ, ಮುಕ್ತಾಯದ ಮೇಲೆ ಕ್ಲಿಕ್ ಮಾಡುವ ಮೊದಲು ಈಗಲೇ ಮಾಡಿ.',
            setuplinkmsgTwo: '*ದಯವಿಟ್ಟು ಗಮನಿಸಿ ವಿಶಿಷ್ಟ ಕಂಪನಿ ID ಮತ್ತು ಒಮ್ಮೆ ನೋಂದಾಯಿಸಿದ ನಿಮ್ಮ ವಿಶಿಷ್ಟ ಬಳಕೆದಾರ ID ಈ ಹಂತವನ್ನು ಪೂರ್ಣಗೊಳಿಸಿದ ನಂತರ ಬದಲಾಯಿಸಲಾಗುವುದಿಲ್ಲ. ಈ ಹಂತದಲ್ಲಿ ನೀವು ಈ ಹೆಸರುಗಳಲ್ಲಿ ಯಾವುದನ್ನಾದರೂ ಮಾರ್ಪಡಿಸಲು ಬಯಸಿದರೆ ದಯವಿಟ್ಟು ಹಿಂದಿನ ಕೀ ಬಳಸಿ',
            or: 'ಅಥವಾ',
            language: 'ಭಾಷೆ',
            emailAddress: 'ಇಮೇಲ್ ವಿಳಾಸ',
            enterEmail: 'ನಿಮ್ಮ ಇಮೇಲ್ ವಿಳಾಸವನ್ನು ನಮೂದಿಸಿ',
            emailexist: 'ನೀವು ಈಗಾಗಲೇ ನಮ್ಮೊಂದಿಗೆ ನೋಂದಾಯಿಸಿರುವಿರಿ.',
            emailexist1: 'ಈ ಇಮೇಲ್ ಐಡಿಯೊಂದಿಗೆ ಸಂಯೋಜಿತವಾಗಿರುವ ಪ್ರಸ್ತುತ ಚಂದಾದಾರಿಕೆ ಇದೆ.',
            signInTojodoToobar: 'ಜೋಡೋ ಟೂಲ್‌ಬಾರ್‌ಗೆ ಸೈನ್ ಇನ್ ಮಾಡಿ',
            emailRegexValidation: 'ಮಾನ್ಯ ಇಮೇಲ್ ವಿಳಾಸವನ್ನು ನಮೂದಿಸಿ',
            emailRequiredValidation: 'ಇಮೇಲ್ ಅಗತ್ಯವಿದೆ',
            emailMaxValidation: 'ಗರಿಷ್ಠ 100 ಅಕ್ಷರಗಳನ್ನು ಅನುಮತಿಸಲಾಗಿದೆ',
            emailMinValidation: 'ಕನಿಷ್ಠ 5 ಅಕ್ಷರಗಳ ಅಗತ್ಯವಿದೆ.',
            enterotp: 'ದಯವಿಟ್ಟು OTP ನಮೂದಿಸಿ',
            resendotp: 'ಒಟಿಪಿ ಮರುಕಳುಹಿಸಿ',
            otpRequiredValidation: 'ದಯವಿಟ್ಟು OTP ನಮೂದಿಸಿ',
            otpMaxLengthValidation: 'ಗರಿಷ್ಠ 16 ಅಕ್ಷರಗಳನ್ನು ಅನುಮತಿಸಲಾಗಿದೆ',
            otpMaxLength: 'ಗರಿಷ್ಠ 6 ಅಕ್ಷರಗಳನ್ನು ಅನುಮತಿಸಲಾಗಿದೆ',
            otpMinLength: 'ಕನಿಷ್ಠ 6 ಅಕ್ಷರಗಳನ್ನು ಅನುಮತಿಸಲಾಗಿದೆ',
            otpMessage: 'ದಯವಿಟ್ಟು ನಿಮ್ಮ ಮೇಲ್‌ಗೆ ಕಳುಹಿಸಲಾದ ಆರು ಅಂಕಿಗಳ OTP ಅನ್ನು ನಮೂದಿಸಿ',
            next: 'ಮುಂದೆ',
            signUpGoogle: 'ಗೂಗಲ್ ನೊಂದಿಗೆ ಸೈನ್ ಅಪ್ ಮಾಡಿ',
            signUpLinkeIn: 'ಲಿಂಕ್ಡ್‌ಇನ್‌ನೊಂದಿಗೆ ಸೈನ್ ಅಪ್ ಮಾಡಿ',
            jodoteam: 'ಜೋಡೋ ತಂಡ',
            jodoindi: 'ಜೋಡೋಲಿಂಕ್ ಇಂಡಿವಿಜುವಲ್',
            jodolink: 'ಜೋಡೋಲಿಂಕ್',
            wordpress: 'ವರ್ಡ್ಪ್ರೆಸ್',
            yourInformation: 'ನಿಮ್ಮ ಮಾಹಿತಿ',
            otpverify: 'OTP ಪರಿಶೀಲನೆ',
            signup: 'ಸೈನ್ಅಪ್',
            resendotp: 'ಒಟಿಪಿ ಮರುಕಳುಹಿಸಿ',
            billingDetails: 'ರಶೀದಿ ವಿವರಗಳು',
            setupJodoLink: 'ಜೋಡೋಲಿಂಕ್ ಅನ್ನು ಹೊಂದಿಸಿ',
            setupJodoTeam: 'ಜೋಡೋ ತಂಡವನ್ನು ಹೊಂದಿಸಿ',
            setupDomainName: 'ಪ್ರಕ್ರಿಯೆ ಮುಕ್ತಾಯ',
            username: 'ಹೆಸರು',
            lastName: 'ಕೊನೆಯ ಹೆಸರು',
            setPassword: 'ಗುಪ್ತಪದ',
            confirmPassword: 'ಪಾಸ್ವರ್ಡ್ ದೃಢೀಕರಿಸಿ',
            designation: 'ಶೀರ್ಷಿಕೆ/ಉಪನಾಮ',
            country: 'ದೇಶ',
            state: 'ರಾಜ್ಯ',
            city: 'ನಗರ',
            zipcode: 'ಪಿನ್ ಕೋಡ್',
            address1: 'ವಿಳಾಸ 1',
            address2: 'ವಿಳಾಸ 2',
            back: 'ಹಿಂದೆ',
            finish: 'ಮುಕ್ತಾಯ',
            passwordRule1: '1) ನಿಮ್ಮ ಪಾಸ್‌ವರ್ಡ್ 8 ಅಕ್ಷರಗಳನ್ನು ಹೊಂದಿರಬೇಕು, ಒಂದು ದೊಡ್ಡಕ್ಷರ, ಒಂದು ಲೋವರ್‌ಕೇಸ್, ಒಂದು ಸಂಖ್ಯೆ ಮತ್ತು ಒಂದು ವಿಶೇಷ ಕೇಸ್ ಅಕ್ಷರ',
            passwordRule2: 'ಪಾಸ್‌ವರ್ಡ್ ಮತ್ತು ದೃಢೀಕರಣ ಪಾಸ್‌ವರ್ಡ್ ಒಂದೇ ಆಗಿರಬೇಕು.',
            passwordmatchAlert: 'ಪಾಸ್‌ವರ್ಡ್ ಮತ್ತು ದೃಢೀಕರಣ ಪಾಸ್‌ವರ್ಡ್‌ಗಳು ಹೊಂದಿಕೆಯಾಗುವುದಿಲ್ಲ',
            passwordmatchSuccess: 'ಪಾಸ್‌ವರ್ಡ್ ಮತ್ತು ಪಾಸ್‌ವರ್ಡ್ ಹೊಂದಾಣಿಕೆಯಾಗಿರುವುದನ್ನು ಖಚಿತಪಡಿಸಿ!',
            typeCityName: 'ನಿಮ್ಮ ನಗರದ ಹೆಸರನ್ನು ಟೈಪ್ ಮಾಡಿ',
            companyName: 'ಸಂಸ್ಥೆಯ ಹೆಸರು',
            taxNo: 'ತೆರಿಗೆ ಸಂಖ್ಯೆ',
            billingDetailsLocationMsg: 'ನಿಮ್ಮ ಬಿಲ್ಲಿಂಗ್ ವಿಳಾಸವು ನಿಮ್ಮ ಮಾಹಿತಿ ವಿಭಾಗದಲ್ಲಿ ಒದಗಿಸಿದಂತೆಯೇ ಇದೆಯೇ?',
            domainName: 'ಕಾರ್ಯಕ್ಷೇತ್ರದ ಹೆಸರು',
            verifyBtn: 'ಪರಿಶೀಲಿಸಿ',
            uniqueCompanyName: 'ವಿಶಿಷ್ಟ ಕಂಪನಿ ಐಡಿ',
            uniqueURL: 'ವಿಶಿಷ್ಟ URL',
            uniqueUserName: 'ವಿಶಿಷ್ಟ ಬಳಕೆದಾರ ಐಡಿ',
            firstNameRequired: 'ಮೊದಲ ಹೆಸರು ಅಗತ್ಯವಿದೆ',
            firstNameSpaceValidation: 'ನೀವು ಹೆಸರಿನ ಆರಂಭದಲ್ಲಿ ಅಥವಾ ಕೊನೆಯಲ್ಲಿ ಜಾಗವನ್ನು ಬಳಸಲಾಗುವುದಿಲ್ಲ.',
            lastNameRequired: 'ಕೊನೆಯ ಹೆಸರು ಅಗತ್ಯವಿದೆ',
            twentyFiveCharValidation: '25 ಅಕ್ಷರಗಳು ಅಥವಾ ಅದಕ್ಕಿಂತ ಕಡಿಮೆ ಇರಬೇಕು',
            firstName_lastName_RegexValidation: 'ಹೆಸರಿನಲ್ಲಿ ವರ್ಣಮಾಲೆಗಳನ್ನು ಮಾತ್ರ ಬಳಸಬಹುದು.',
            passwordRegexValidation: '8 ಅಕ್ಷರಗಳನ್ನು ಹೊಂದಿರಬೇಕು, ಒಂದು ದೊಡ್ಡಕ್ಷರ, ಒಂದು ಲೋವರ್ಕೇಸ್, ಒಂದು ಸಂಖ್ಯೆ ಮತ್ತು ಒಂದು ವಿಶೇಷ ಕೇಸ್ ಅಕ್ಷರ',
            confirmPasswordMatchValidation: 'ಪಾಸ್‌ವರ್ಡ್ ಮತ್ತು ದೃಢೀಕರಣ ಪಾಸ್‌ವರ್ಡ್ ಒಂದೇ ಆಗಿರಬೇಕು.',
            passwordRequired: 'ಗುಪ್ತಪದದ ಅಗತ್ಯವಿದೆ',
            confirmPasswordRequired: 'ಪಾಸ್ವರ್ಡ್ ದೃಢೀಕರಿಸುವ ಅಗತ್ಯವಿದೆ',
            zipcodeCharLengthValidation: '10 ಸಂಖ್ಯೆಗಳು ಅಥವಾ ಅದಕ್ಕಿಂತ ಕಡಿಮೆ ಇರಬೇಕು',
            zipCodeValidation: 'ಅಮಾನ್ಯವಾದ ಪಿನ್ ಕೋಡ್',
            zipNumberVAlidation: 'ಸಂಖ್ಯೆಯನ್ನು ಮಾತ್ರ ಬಳಸಬಹುದು.',
            zipcodeRegexValidation: 'ಕನಿಷ್ಠ 4 ಸಂಖ್ಯೆಗಳು ಮತ್ತು ಗರಿಷ್ಠ 10 ಸಂಖ್ಯೆಗಳನ್ನು ಅನುಮತಿಸಲಾಗಿದೆ',
            addressCharLengthValidation: '100 ಅಕ್ಷರಗಳು ಅಥವಾ ಅದಕ್ಕಿಂತ ಕಡಿಮೆ ಇರಬೇಕು',
            companyNameRequired: 'ಕಂಪೆನಿ ಹೆಸರು ಅಗತ್ಯವಿದೆ',
            companyName_RegexValidation: 'ಆಲ್ಫಾನ್ಯೂಮರಿಕ್ ಅಕ್ಷರಗಳು ಮತ್ತು ವಿಶೇಷ ಅಕ್ಷರಗಳನ್ನು [-, @, #, &,!] ಮಾತ್ರ ಬಳಸಬಹುದು.',
            orgAliasRequired: 'ಸಂಘಟನೆ ಅಲಿಯಾಸ್ ಅಗತ್ಯವಿದೆ',
            userAliasRequired: 'ಬಳಕೆದಾರ ಅಲಿಯಾಸ್ ಅಗತ್ಯವಿದೆ',
            aliasRegexValidation: 'ಆಲ್ಫಾನ್ಯೂಮರಿಕ್ ಅಕ್ಷರಗಳನ್ನು ಹೊಂದಿರಬೇಕು. ಯಾವುದೇ ವಿಶೇಷ ಅಕ್ಷರಗಳು ಮತ್ತು ಜಾಗವನ್ನು ಅನುಮತಿಸಲಾಗುವುದಿಲ್ಲ.',
            domainNameRequired: 'ದಯವಿಟ್ಟು ಡೊಮೇನ್ ಹೆಸರನ್ನು ಸೂಚಿಸಿ.',
            domainNameRegexValidation: 'ಡೊಮೇನ್ ಹೆಸರು https://www.example.com` ಪ್ರಕಾರವಾಗಿರಬೇಕು',
            loadingMsgOne: 'ದಯವಿಟ್ಟು ನಿರೀಕ್ಷಿಸಿ, ನಿಮ್ಮ ಖಾತೆಯನ್ನು ರಚಿಸಲಾಗುತ್ತಿದೆ,',
            loadingMsgTwo: 'ನಿಮ್ಮ ಖಾತೆಯನ್ನು ರಚಿಸುತ್ತಿರುವಾಗ, ಡಾಕ್ಸ್ ಅನ್ನು ಓದಿ ಮತ್ತು ಜೋಡೋ ಉತ್ಪನ್ನ ವೀಡಿಯೊಗಳನ್ನು ವೀಕ್ಷಿಸಿ',
            transformsales: 'ಮಾರಾಟ ಮಾರಾಟ',
            transformsupport: 'ಪರಿವರ್ತನೆ ಬೆಂಬಲ',
            transformecommerce: 'ಟ್ರಾನ್ಸ್‌ಫಾರ್ಮ್ ಇ-ಕಾಮರ್ಸ್',
            emailAuthFailed: 'ಇಮೇಲ್ ವಿಳಾಸವನ್ನು ದೃಢೀಕರಿಸಲು ವಿಫಲವಾಗಿದೆ. ದಯವಿಟ್ಟು ನಂತರ ಮತ್ತೆ ಪ್ರಯತ್ನಿಸಿ.',
            companyNameExistMsg: 'ಈ ಕಂಪನಿಯ ಹೆಸರನ್ನು ಈಗಾಗಲೇ ನೋಂದಾಯಿಸಲಾಗಿದೆ.',
            companyAliasVerifiedMsg: 'ವಿಶಿಷ್ಟ ಕಂಪನಿಯ ಹೆಸರನ್ನು ಪರಿಶೀಲಿಸಲಾಗಿದೆ',
            internalServerErrorMsg: 'ಆಂತರಿಕ ಸರ್ವರ್ ದೋಷ. ದಯವಿಟ್ಟು ನಂತರ ಮತ್ತೆ ಪ್ರಯತ್ನಿಸಿ',
            invalidOTPMsg: 'ಅಮಾನ್ಯ OTP',
            userAlreadyExist: 'ಬಳಕೆದಾರರು ಈಗಾಗಲೇ ಅಸ್ತಿತ್ವದಲ್ಲಿದ್ದಾರೆ',
            uniqueCompanyNameExist: 'ವಿಶಿಷ್ಟ ಕಂಪನಿ ಹೆಸರು ಈಗಾಗಲೇ ಅಸ್ತಿತ್ವದಲ್ಲಿದೆ!',
            uniqueCompanyNameVerified: 'ಕಂಪೆನಿಯ ಹೆಸರನ್ನು ಯಶಸ್ವಿಯಾಗಿ ಪರಿಶೀಲಿಸಲಾಗಿದೆ!',
            uniqueCompanyAliasVerified: 'ವಿಶಿಷ್ಟ ಕಂಪನಿಯ ಹೆಸರನ್ನು ಯಶಸ್ವಿಯಾಗಿ ಪರಿಶೀಲಿಸಲಾಗಿದೆ! ',
            otpSendMessage: 'ಇಮೇಲ್ ಪರಿಶೀಲನೆ',
            secondotpSendMessage: 'ನಿಮ್ಮ ಮೇಲ್‌ಗೆ OTP ಕಳುಹಿಸಲಾಗಿದೆ. ದಯವಿಟ್ಟು ನಿಮ್ಮ ಇಮೇಲ್ ಬಾಕ್ಸ್ ಮತ್ತು ಜಂಕ್ ಮೇಲ್ / ಸ್ಪ್ಯಾಮ್ ಮೇಲ್‌ಬಾಕ್ಸ್ ಅನ್ನು ಪರಿಶೀಲಿಸಿ',
            firstNameValidation: 'ಮೊದಲ ಹೆಸರು ಅಕ್ಷರಮಾಲೆಗಳನ್ನು ಮಾತ್ರ ಒಳಗೊಂಡಿರಬೇಕು',
            lastNameValidation: 'ಕೊನೆಯ ಹೆಸರು ಕೇವಲ ವರ್ಣಮಾಲೆಗಳನ್ನು ಮಾತ್ರ ಒಳಗೊಂಡಿರಬೇಕು',
            serviceKeyNotFound: 'ಸೇವಾ ಕೀ ಕಂಡುಬಂದಿಲ್ಲ',
            apiKeyNotFound: 'API ಕೀ ಕಂಡುಬಂದಿಲ್ಲ',
            apiKeyandServiceKeyNotFound: 'ಸೇವಾ ಕೀ ಮತ್ತು API ಕೀ ಕಂಡುಬಂದಿಲ್ಲ',
            otpValidationRegex: 'ಸಂಖ್ಯೆಯನ್ನು ಮಾತ್ರ ಅನುಮತಿಸಲಾಗಿದೆ',
            taxNo_RegexValidation: 'ಆಲ್ಫಾನ್ಯೂಮರಿಕ್ ಅಕ್ಷರಗಳನ್ನು ಮಾತ್ರ ಅನುಮತಿಸಲಾಗಿದೆ',
            needhelp: 'ಸಹಾಯ ಬೇಕು',
            companyName_RegexValidation_2: 'ಕಂಪನಿಯ ಹೆಸರಿಗೆ ವಿಶೇಷ ಅಕ್ಷರಗಳನ್ನು ಮಾತ್ರ ಬಳಸಲಾಗುವುದಿಲ್ಲ.',
            companyNameLengthValidation: '150 ಅಕ್ಷರಗಳು ಅಥವಾ ಅದಕ್ಕಿಂತ ಕಡಿಮೆ ಇರಬೇಕು',
            designationLengthValidation: '25 ಅಕ್ಷರಗಳು ಅಥವಾ ಅದಕ್ಕಿಂತ ಕಡಿಮೆ ಇರಬೇಕು',
            designationFieldValidation: 'ಗಮನಿಸಿ: ಕೇವಲ "." ಮತ್ತು "-" ಅನ್ನು ವಿಭಜಕಗಳಾಗಿ ಅನುಮತಿಸಲಾಗಿದೆ.',
            addressValidation: 'ದಯವಿಟ್ಟು ಮಾನ್ಯವಾದ ವಿಳಾಸವನ್ನು ನಮೂದಿಸಿ.',
            imageUploadMsg: 'ಇಲ್ಲಿ ಕ್ಲಿಕ್ ಮಾಡಿ ಅಥವಾ ಚಿತ್ರವನ್ನು ಎಳೆಯಿರಿ',
            imageUploadMsgRemoveBtn: 'ತೆಗೆದುಹಾಕು',
            imageUploadMsgDoneBtn: 'ಮುಗಿದಿದೆ',
            transformSales: 'ಮಾರಾಟ ಮಾರಾಟ',
            transformSupport: 'ಪರಿವರ್ತನೆ ಬೆಂಬಲ',
            transformCommerce: 'ಟ್ರಾನ್ಸ್‌ಫಾರ್ಮ್ ಇ-ಕಾಮರ್ಸ್',
            countryFieldValidation: "ದೇಶ ಅಗತ್ಯವಿದೆ",
            stateFieldValidation: "ರಾಜ್ಯ ಅಗತ್ಯವಿದೆ",
            alreadyacccreated: "ನೀವು ಈಗಾಗಲೇ ಖಾತೆ ಹೊಂದಿದ್ದೀರಾ?"
        }


    },
    pa: {
        locale: 'pa',
        messages: {
            selectlanguage: 'ਸਾਈਨ ਅੱਪ ਲਈ ਇੱਕ ਭਾਸ਼ਾ ਚੁਣੋ',
            signupOtpValidation: 'OTP ਘੱਟੋ-ਘੱਟ 6 ਅੱਖਰਾਂ ਦਾ ਹੋਣਾ ਚਾਹੀਦਾ ਹੈ।',
            selectsocialacc: 'ਇੱਕ ਸਮਾਜਿਕ ਖਾਤਾ ਚੁਣੋ',
            zipcodeErrorMessage: 'ਅਵੈਧ ਜ਼ਿਪਕੋਡ',
            completeSubscriptionProcess: 'ਪੂਰੀ ਗਾਹਕੀ ਪ੍ਰਕਿਰਿਆ',
            English: 'ਅੰਗਰੇਜ਼ੀ',
            Hindi: 'ਹਿੰਦੀ',
            Spanish: 'ਸਪੈਨਿਸ਼',
            Arabic: 'ਅਰਬੀ',
            uploadprofilepic: 'ਪ੍ਰੋਫਾਈਲ ਤਸਵੀਰ ਅੱਪਲੋਡ ਕਰੋ',
            uploadcompanylogo: 'ਅੱਪਲੋਡ ਕੰਪਨੀ ਲੋਗੋ',
            setuplinkmsgOne: 'ਤੁਸੀਂ ਲਗਭਗ ਹੋ ਚੁੱਕੇ ਹੋ',
            setupurl1: 'ਤੁਸੀਂ ਲਗਭਗ ਪੂਰਾ ਕਰ ਲਿਆ ਹੈ।',
            setupurl2: 'ਹੇਠਾਂ ਤੁਹਾਡਾ ਅਨੁਕੂਲਿਤ ਜੋਡੋਲਿੰਕ ਹੈ',
            setupurlmesgthree: 'ਕਿਰਪਾ ਕਰਕੇ ਨੋਟ ਕਰੋ ਕਿ ਇੱਕ ਵਾਰ ਇਹ ਕਦਮ ਪੂਰਾ ਹੋ ਜਾਣ ਤੋਂ ਬਾਅਦ, ਤੁਸੀਂ ਆਪਣੇ  ਨੂੰ ਨਹੀਂ ਬਦਲ ਸਕਦੇ। ਜੇਕਰ ਤੁਸੀਂ ਇਸਨੂੰ ਬਦਲਣਾ ਚਾਹੁੰਦੇ ਹੋ, ਤਾਂ Finish `ਤੇ ਕਲਿੱਕ ਕਰਨ ਤੋਂ ਪਹਿਲਾਂ ਅਜਿਹਾ ਕਰੋ।',
            setuplinkmsgTwo: '*ਕਿਰਪਾ ਕਰਕੇ ਨੋਟ ਕਰੋ ਕਿ ਇਹ ਪੜਾਅ ਪੂਰਾ ਹੋਣ ਤੋਂ ਬਾਅਦ ਯੂਨੀਕ ਕੰਪਨੀ ਆਈਡੀ ਅਤੇ ਤੁਹਾਡੀ ਯੂਨੀਕ ਯੂਜ਼ਰ ਆਈਡੀ ਨੂੰ ਰਜਿਸਟਰਡ ਹੋਣ ਤੋਂ ਬਾਅਦ ਬਦਲਿਆ ਨਹੀਂ ਜਾ ਸਕਦਾ। ਜੇਕਰ ਤੁਸੀਂ ਇਸ ਸਮੇਂ ਇਹਨਾਂ ਵਿੱਚੋਂ ਕਿਸੇ ਵੀ ਨਾਮ ਨੂੰ ਸੋਧਣਾ ਚਾਹੁੰਦੇ ਹੋ ਤਾਂ ਕਿਰਪਾ ਕਰਕੇ ਪਿਛਲੀ ਕੁੰਜੀ ਦੀ ਵਰਤੋਂ ਕਰੋ',
            or: 'ਜਾਂ',
            language: 'ਭਾਸ਼ਾ',
            emailAddress: 'ਈਮੇਲ ਪਤਾ',
            enterEmail: 'ਆਪਣਾ ਈਮੇਲ ਪਤਾ ਦਰਜ ਕਰੋ',
            emailexist: 'ਤੁਸੀਂ ਸਾਡੇ ਨਾਲ ਪਹਿਲਾਂ ਹੀ ਰਜਿਸਟਰਡ ਹੋ।',
            emailexist1: 'ਇਸ ਈਮੇਲ ਆਈਡੀ ਨਾਲ ਜੁੜੀ ਇੱਕ ਮੌਜੂਦਾ ਗਾਹਕੀ ਹੈ।',
            signInTojodoToobar: 'ਜੋਡੋ ਟੂਲਬਾਰ `ਤੇ ਸਾਈਨ ਇਨ ਕਰੋ',
            emailRegexValidation: 'ਇੱਕ ਵੈਧ ਈਮੇਲ ਪਤਾ ਦਰਜ ਕਰੋ',
            emailRequiredValidation: 'ਈਮੇਲ ਦੀ ਲੋੜ ਹੈ',
            emailMaxValidation: 'ਵੱਧ ਤੋਂ ਵੱਧ 100 ਅੱਖਰਾਂ ਦੀ ਇਜਾਜ਼ਤ ਹੈ',
            emailMinValidation: 'ਘੱਟੋ-ਘੱਟ 5 ਅੱਖਰ ਲੋੜੀਂਦੇ ਹਨ।',
            enterotp: 'ਕਿਰਪਾ ਕਰਕੇ OTP ਦਾਖਲ ਕਰੋ',
            resendotp: 'ਓਟੀਪੀ ਮੁੜ ਭੇਜੋ',
            otpRequiredValidation: 'ਕਿਰਪਾ ਕਰਕੇ OTP ਦਾਖਲ ਕਰੋ',
            otpMaxLengthValidation: 'ਵੱਧ ਤੋਂ ਵੱਧ 16 ਅੱਖਰਾਂ ਦੀ ਇਜਾਜ਼ਤ ਹੈ',
            otpMaxLength: 'ਵੱਧ ਤੋਂ ਵੱਧ 6 ਅੱਖਰਾਂ ਦੀ ਇਜਾਜ਼ਤ ਹੈ',
            otpMinLength: 'ਘੱਟੋ-ਘੱਟ 6 ਅੱਖਰਾਂ ਦੀ ਇਜਾਜ਼ਤ',
            otpMessage: 'ਕਿਰਪਾ ਕਰਕੇ ਛੇ ਅੰਕਾਂ ਦਾ OTP ਦਾਖਲ ਕਰੋ ਜੋ ਤੁਹਾਡੀ ਮੇਲ `ਤੇ ਭੇਜਿਆ ਗਿਆ ਹੈ',
            next: 'ਅਗਲਾ',
            signUpGoogle: 'ਗੂਗਲ ਨਾਲ ਸਾਈਨ ਅੱਪ ਕਰੋ',
            signUpLinkeIn: 'ਲਿੰਕਡਇਨ ਨਾਲ ਸਾਈਨ ਅੱਪ ਕਰੋ',
            jodoteam: 'ਜੋਡੋ ਟੀਮ',
            jodoindi: 'ਜੋਡੋਲਿੰਕ ਵਿਅਕਤੀਗਤ',
            jodolink: 'ਜੋਡੋਲਿੰਕ',
            wordpress: 'ਵਰਡਪ੍ਰੈਸ',
            yourInformation: 'ਤੁਹਾਡੀ ਜਾਣਕਾਰੀ',
            otpverify: 'OTP ਵੈਰੀਫਾਈ',
            signup: 'ਸਾਇਨ ਅਪ',
            resendotp: 'ਓਟੀਪੀ ਮੁੜ ਭੇਜੋ',
            billingDetails: 'ਬਿਲਿੰਗ ਵੇਰਵੇ',
            setupJodoLink: 'ਜੋਡੋਲਿੰਕ ਸੈੱਟਅੱਪ ਕਰੋ',
            setupJodoTeam: 'ਸੈਟਅੱਪ ਜੋਡੋ ਟੀਮ',
            setupDomainName: 'ਪ੍ਰਕਿਰਿਆ ਨੂੰ ਪੂਰਾ ਕਰੋ',
            username: 'ਨਾਮ',
            lastName: 'ਆਖਰੀ ਨਾਂਮ',
            setPassword: 'ਪਾਸਵਰਡ',
            confirmPassword: 'ਪਾਸਵਰਡ ਪੱਕਾ ਕਰੋ',
            designation: 'ਸਿਰਲੇਖ/ਅਹੁਦਾ',
            country: 'ਦੇਸ਼',
            state: 'ਰਾਜ',
            city: 'ਸ਼ਹਿਰ',
            zipcode: 'ਜ਼ਿਪ ਕੋਡ',
            address1: 'ਪਤਾ 1',
            address2: 'ਪਤਾ 2',
            back: 'ਵਾਪਸ',
            finish: 'ਮੁਕੰਮਲ',
            passwordRule1: '1) ਤੁਹਾਡੇ ਪਾਸਵਰਡ ਵਿੱਚ 8 ਅੱਖਰ, ਇੱਕ ਅੱਪਰਕੇਸ, ਇੱਕ ਲੋਅਰਕੇਸ, ਇੱਕ ਨੰਬਰ ਅਤੇ ਇੱਕ ਖਾਸ ਕੇਸ ਅੱਖਰ ਹੋਣਾ ਚਾਹੀਦਾ ਹੈ',
            passwordRule2: 'ਪਾਸਵਰਡ ਅਤੇ ਪੁਸ਼ਟੀਕਰਨ ਪਾਸਵਰਡ ਇੱਕੋ ਜਿਹਾ ਹੋਣਾ ਚਾਹੀਦਾ ਹੈ।',
            passwordmatchAlert: 'ਪਾਸਵਰਡ ਅਤੇ ਪੁਸ਼ਟੀ ਪਾਸਵਰਡ ਮੇਲ ਨਹੀਂ ਖਾਂਦੇ',
            passwordmatchSuccess: 'ਪਾਸਵਰਡ ਅਤੇ ਪੁਸ਼ਟੀ ਪਾਸਵਰਡ ਮੇਲ ਖਾਂਦਾ ਹੈ!',
            typeCityName: 'ਆਪਣੇ ਸ਼ਹਿਰ ਦਾ ਨਾਮ ਟਾਈਪ ਕਰੋ',
            companyName: 'ਕੰਪਨੀ ਦਾ ਨਾਂ',
            taxNo: 'ਟੈਕਸ ਨੰਬਰ',
            billingDetailsLocationMsg: 'ਕੀ ਤੁਹਾਡਾ ਬਿਲਿੰਗ ਪਤਾ ਉਹੀ ਹੈ ਜੋ ਤੁਹਾਡੇ ਜਾਣਕਾਰੀ ਸੈਕਸ਼ਨ ਵਿੱਚ ਦਿੱਤਾ ਗਿਆ ਹੈ?',
            domainName: 'ਡੋਮੇਨ ਨਾਮ',
            verifyBtn: 'ਪੁਸ਼ਟੀ ਕਰੋ',
            uniqueCompanyName: 'ਯੂਨੀਕ ਕੰਪਨੀ ਆਈਡੀ',
            uniqueURL: 'ਵਿਲੱਖਣ URL',
            uniqueUserName: 'ਯੂਨੀਕ ਯੂਜ਼ਰ ਆਈਡੀ',
            firstNameRequired: 'ਪਹਿਲਾ ਨਾਮ ਲੋੜੀਂਦਾ ਹੈ',
            firstNameSpaceValidation: 'ਤੁਸੀਂ ਕਿਸੇ ਨਾਮ ਦੇ ਸ਼ੁਰੂ ਜਾਂ ਅੰਤ ਵਿੱਚ ਸਪੇਸ ਦੀ ਵਰਤੋਂ ਨਹੀਂ ਕਰ ਸਕਦੇ।',
            lastNameRequired: 'ਆਖਰੀ ਨਾਮ ਦੀ ਲੋੜ ਹੈ',
            twentyFiveCharValidation: '25 ਅੱਖਰ ਜਾਂ ਘੱਟ ਹੋਣੇ ਚਾਹੀਦੇ ਹਨ',
            firstName_lastName_RegexValidation: 'ਨਾਮ ਵਿੱਚ ਸਿਰਫ਼ ਅੱਖਰਾਂ ਦੀ ਵਰਤੋਂ ਕੀਤੀ ਜਾ ਸਕਦੀ ਹੈ।',
            passwordRegexValidation: '8 ਅੱਖਰ, ਇੱਕ ਵੱਡੇ, ਇੱਕ ਛੋਟੇ ਅੱਖਰ, ਇੱਕ ਨੰਬਰ ਅਤੇ ਇੱਕ ਵਿਸ਼ੇਸ਼ ਕੇਸ ਅੱਖਰ ਹੋਣੇ ਚਾਹੀਦੇ ਹਨ',
            confirmPasswordMatchValidation: 'ਪਾਸਵਰਡ ਅਤੇ ਪੁਸ਼ਟੀਕਰਨ ਪਾਸਵਰਡ ਇੱਕੋ ਜਿਹਾ ਹੋਣਾ ਚਾਹੀਦਾ ਹੈ।',
            passwordRequired: 'ਪਾਸਵਰਡ ਦੀ ਲੋੜ ਹੈ',
            confirmPasswordRequired: 'ਪੁਸ਼ਟੀ ਕਰੋ ਪਾਸਵਰਡ ਲੋੜੀਂਦਾ ਹੈ',
            zipcodeCharLengthValidation: '10 ਨੰਬਰ ਜਾਂ ਘੱਟ ਹੋਣੇ ਚਾਹੀਦੇ ਹਨ',
            zipCodeValidation: 'ਅਵੈਧ ਜ਼ਿਪਕੋਡ',
            zipNumberVAlidation: 'ਸਿਰਫ ਨੰਬਰ ਦੀ ਵਰਤੋਂ ਕੀਤੀ ਜਾ ਸਕਦੀ ਹੈ।',
            zipcodeRegexValidation: 'ਘੱਟੋ-ਘੱਟ 4 ਨੰਬਰ ਅਤੇ ਵੱਧ ਤੋਂ ਵੱਧ 10 ਨੰਬਰਾਂ ਦੀ ਇਜਾਜ਼ਤ',
            addressCharLengthValidation: '100 ਅੱਖਰ ਜਾਂ ਘੱਟ ਹੋਣੇ ਚਾਹੀਦੇ ਹਨ',
            companyNameRequired: 'ਕੰਪਨੀ ਦਾ ਨਾਮ ਲੋੜੀਂਦਾ ਹੈ',
            companyName_RegexValidation: 'ਸਿਰਫ਼ ਅੱਖਰ ਅੰਕੀ ਅੱਖਰ ਅਤੇ ਵਿਸ਼ੇਸ਼ ਅੱਖਰ [-, @, #, &,!] ਵਰਤੇ ਜਾ ਸਕਦੇ ਹਨ।',
            orgAliasRequired: 'ਸੰਗਠਨ ਉਪਨਾਮ ਦੀ ਲੋੜ ਹੈ',
            userAliasRequired: 'ਉਪਭੋਗਤਾ ਉਪਨਾਮ ਦੀ ਲੋੜ ਹੈ',
            aliasRegexValidation: 'ਅੱਖਰ ਅੰਕੀ ਅੱਖਰ ਸ਼ਾਮਲ ਹੋਣੇ ਚਾਹੀਦੇ ਹਨ। ਕਿਸੇ ਵਿਸ਼ੇਸ਼ ਅੱਖਰ ਅਤੇ ਥਾਂ ਦੀ ਇਜਾਜ਼ਤ ਨਹੀਂ ਹੈ।',
            domainNameRequired: 'ਕਿਰਪਾ ਕਰਕੇ ਡੋਮੇਨ ਨਾਮ ਦਿਓ।',
            domainNameRegexValidation: 'ਡੋਮੇਨ ਨਾਮ https://www.example.com` ਕਿਸਮ ਦਾ ਹੋਣਾ ਚਾਹੀਦਾ ਹੈ',
            loadingMsgOne: 'ਕਿਰਪਾ ਕਰਕੇ ਉਡੀਕ ਕਰੋ, ਤੁਹਾਡਾ ਖਾਤਾ ਬਣਾਇਆ ਜਾ ਰਿਹਾ ਹੈ,',
            loadingMsgTwo: 'ਜਦੋਂ ਤੁਹਾਡਾ ਖਾਤਾ ਬਣਾਇਆ ਜਾ ਰਿਹਾ ਹੈ, ਦਸਤਾਵੇਜ਼ਾਂ ਨੂੰ ਪੜ੍ਹੋ ਅਤੇ ਜੋਡੋ ਉਤਪਾਦ ਵੀਡੀਓਜ਼ ਦੇਖੋ',
            transformsales: 'ਟਰਾਂਸਫਾਰਮ ਸੇਲਜ਼',
            transformsupport: 'ਟਰਾਂਸਫਾਰਮ ਸਪੋਰਟ',
            transformecommerce: 'ਟ੍ਰਾਂਸਫਾਰਮ ਈ-ਕਾਮਰਸ',
            emailAuthFailed: 'ਈਮੇਲ ਪਤੇ ਨੂੰ ਪ੍ਰਮਾਣਿਤ ਕਰਨ ਵਿੱਚ ਅਸਫਲ। ਬਾਅਦ ਵਿੱਚ ਦੁਬਾਰਾ ਕੋਸ਼ਿਸ਼ ਕਰੋ ਜੀ.',
            companyNameExistMsg: 'ਇਹ ਕੰਪਨੀ ਦਾ ਨਾਮ ਪਹਿਲਾਂ ਹੀ ਰਜਿਸਟਰਡ ਹੈ।',
            companyAliasVerifiedMsg: 'ਵਿਲੱਖਣ ਕੰਪਨੀ ਦਾ ਨਾਮ ਪ੍ਰਮਾਣਿਤ',
            internalServerErrorMsg: 'ਅੰਦਰੂਨੀ ਸਰਵਰ ਗਲਤੀ। ਬਾਅਦ ਵਿੱਚ ਦੁਬਾਰਾ ਕੋਸ਼ਿਸ਼ ਕਰੋ ਜੀ',
            invalidOTPMsg: 'ਅਵੈਧ OTP',
            userAlreadyExist: 'ਉਪਭੋਗਤਾ ਪਹਿਲਾਂ ਹੀ ਮੌਜੂਦ ਹੈ',
            uniqueCompanyNameExist: 'ਵਿਲੱਖਣ ਕੰਪਨੀ ਦਾ ਨਾਮ ਪਹਿਲਾਂ ਹੀ ਮੌਜੂਦ ਹੈ!',
            uniqueCompanyNameVerified: 'ਕੰਪਨੀ ਦਾ ਨਾਮ ਸਫਲਤਾਪੂਰਵਕ ਤਸਦੀਕ ਕੀਤਾ ਗਿਆ!',
            uniqueCompanyAliasVerified: 'ਵਿਲੱਖਣ ਕੰਪਨੀ ਦੇ ਨਾਮ ਦੀ ਸਫਲਤਾਪੂਰਵਕ ਪੁਸ਼ਟੀ ਹੋਈ! ',
            otpSendMessage: 'ਈਮੇਲ ਵੈਰੀਫਿਕੇਸ਼ਨ',
            secondotpSendMessage: 'ਤੁਹਾਡੀ ਮੇਲ `ਤੇ OTP ਭੇਜ ਦਿੱਤਾ ਗਿਆ ਹੈ। ਕਿਰਪਾ ਕਰਕੇ ਆਪਣੇ ਈਮੇਲ ਬਾਕਸ ਅਤੇ ਜੰਕ ਮੇਲ / ਸਪੈਮ ਮੇਲਬਾਕਸ ਦੀ ਪੁਸ਼ਟੀ ਕਰੋ',
            firstNameValidation: 'ਪਹਿਲੇ ਨਾਮ ਵਿੱਚ ਸਿਰਫ਼ ਅੱਖਰ ਹੀ ਹੋਣੇ ਚਾਹੀਦੇ ਹਨ',
            lastNameValidation: 'ਆਖਰੀ ਨਾਮ ਸਿਰਫ਼ ਅੱਖਰਾਂ ਦੇ ਹੋਣੇ ਚਾਹੀਦੇ ਹਨ',
            serviceKeyNotFound: 'ਸੇਵਾ ਕੁੰਜੀ ਨਹੀਂ ਮਿਲੀ',
            apiKeyNotFound: 'API ਕੁੰਜੀ ਨਹੀਂ ਮਿਲੀ',
            apiKeyandServiceKeyNotFound: 'ਸੇਵਾ ਕੁੰਜੀ ਅਤੇ API ਕੁੰਜੀ ਨਹੀਂ ਮਿਲੀ',
            otpValidationRegex: 'ਸਿਰਫ ਨੰਬਰ ਦੀ ਇਜਾਜ਼ਤ ਹੈ',
            taxNo_RegexValidation: 'ਸਿਰਫ਼ ਅੱਖਰ ਅੰਕੀ ਅੱਖਰਾਂ ਦੀ ਇਜਾਜ਼ਤ ਹੈ',
            needhelp: 'ਮਦਦ ਦੀ ਲੋੜ ਹੈ',
            companyName_RegexValidation_2: 'ਕੰਪਨੀ ਦੇ ਨਾਮ ਲਈ ਸਿਰਫ਼ ਵਿਸ਼ੇਸ਼ ਅੱਖਰ ਨਹੀਂ ਵਰਤੇ ਜਾ ਸਕਦੇ।',
            companyNameLengthValidation: '150 ਅੱਖਰ ਜਾਂ ਘੱਟ ਹੋਣੇ ਚਾਹੀਦੇ ਹਨ',
            designationLengthValidation: '25 ਅੱਖਰ ਜਾਂ ਘੱਟ ਹੋਣੇ ਚਾਹੀਦੇ ਹਨ',
            designationFieldValidation: 'ਨੋਟ: ਸਿਰਫ਼ "." ਅਤੇ "-" ਨੂੰ ਵਿਭਾਜਕ ਵਜੋਂ ਇਜਾਜ਼ਤ ਦਿੱਤੀ ਜਾਂਦੀ ਹੈ।',
            addressValidation: 'ਕਿਰਪਾ ਕਰਕੇ ਇੱਕ ਵੈਧ ਪਤਾ ਦਰਜ ਕਰੋ।',
            imageUploadMsg: 'ਇੱਥੇ ਕਲਿੱਕ ਕਰੋ ਜਾਂ ਚਿੱਤਰ ਨੂੰ ਖਿੱਚੋ',
            imageUploadMsgRemoveBtn: 'ਹਟਾਓ',
            imageUploadMsgDoneBtn: 'ਹੋ ਗਿਆ',
            transformSales: 'ਟਰਾਂਸਫਾਰਮ ਸੇਲਜ਼',
            transformSupport: 'ਟਰਾਂਸਫਾਰਮ ਸਪੋਰਟ',
            transformCommerce: 'ਟ੍ਰਾਂਸਫਾਰਮ ਈ-ਕਾਮਰਸ',
            countryFieldValidation: "ਦੇਸ਼ ਲਾਜ਼ਮੀ ਹੈ",
            stateFieldValidation: "ਰਾਜ ਲਾਜ਼ਮੀ ਹੈ",
            alreadyacccreated: "ਕੀ ਤੁਹਾਡੇ ਕੋਲ ਪਹਿਲਾਂ ਹੀ ਖਾਤਾ ਹੈ?"

        }

    },
    ta: {
        locale: 'ta',
        messages: {
            selectlanguage: 'பதிவு செய்வதற்கு ஒரு மொழியைத் தேர்ந்தெடு',
            signupOtpValidation: 'OTP குறைந்தது 6 எழுத்துகள் இருக்க வேண்டும்.',
            selectsocialacc: 'சமூக கணக்கைத் தேர்ந்தெடு',
            zipcodeErrorMessage: 'தவறான ஜிப்கோடு',
            completeSubscriptionProcess: 'முழு சந்தா செயல்முறை',
            English: 'ஆங்கிலம்',
            Hindi: 'ஹிந்தி',
            Spanish: 'ஸ்பானிஷ்',
            Arabic: 'அரபு',
            uploadprofilepic: 'சுயவிவரப் படத்தைப் பதிவேற்று',
            uploadcompanylogo: 'நிறுவன லோகோவைப் பதிவேற்று',
            setuplinkmsgOne: 'நீங்கள் கிட்டத்தட்ட முடித்துவிட்டீர்கள்',
            setupurl1: 'நீங்கள் கிட்டத்தட்ட முடித்துவிட்டீர்கள்.',
            setupurl2: 'உங்கள் தனிப்பயனாக்கக்கூடிய  கீழே உள்ளது',
            setupurlmesgthree: 'இந்தப் படி முடிந்ததும், உங்களால்  ஐ மாற்ற முடியாது என்பதை நினைவில் கொள்ளவும். நீங்கள் அதை மாற்ற விரும்பினால், பினிஷ் என்பதைக் கிளிக் செய்வதற்கு முன் இப்போதே செய்யுங்கள்.',
            setuplinkmsgTwo: '*இந்தப் படி முடிந்ததும் தனித்த நிறுவன ஐடி மற்றும் உங்கள் தனிப்பட்ட பயனர் ஐடி பதிவு செய்தவுடன் மாற்ற முடியாது என்பதை நினைவில் கொள்ளவும். இந்த இடத்தில் இந்தப் பெயர்களில் ஏதேனும் ஒன்றை நீங்கள் மாற்ற விரும்பினால், பின் விசையைப் பயன்படுத்தவும்',
            or: 'அல்லது',
            language: 'மொழி',
            emailAddress: 'மின்னஞ்சல் முகவரி',
            enterEmail: 'உங்கள் மின்னஞ்சல் முகவரியை உள்ளிடவும்',
            emailexist: 'நீங்கள் ஏற்கனவே எங்களிடம் பதிவு செய்துள்ளீர்கள்.',
            emailexist1: 'இந்த மின்னஞ்சல் ஐடியுடன் தொடர்புடைய சந்தா ஏற்கனவே உள்ளது.',
            signInTojodoToobar: 'ஜோடோ கருவிப்பட்டியில் உள்நுழைக',
            emailRegexValidation: 'சரியான மின்னஞ்சல் முகவரியை உள்ளிடவும்',
            emailRequiredValidation: 'மின்னஞ்சல் தேவை',
            emailMaxValidation: 'அதிகபட்சம் 100 எழுத்துகள் அனுமதிக்கப்படும்',
            emailMinValidation: 'குறைந்தபட்சம் 5 எழுத்துகள் தேவை.',
            enterotp: 'தயவுசெய்து OTP ஐ உள்ளிடவும்',
            resendotp: 'ஓடிபியை மீண்டும் அனுப்பு',
            otpRequiredValidation: 'ஓடிபியை உள்ளிடவும்',
            otpMaxLengthValidation: 'அதிகபட்சம் 16 எழுத்துகள் அனுமதிக்கப்படும்',
            otpMaxLength: 'அதிகபட்சம் 6 எழுத்துகள் அனுமதிக்கப்படும்',
            otpMinLength: 'குறைந்தபட்சம் 6 எழுத்துகள் அனுமதிக்கப்படும்',
            otpMessage: 'உங்கள் மின்னஞ்சலுக்கு அனுப்பப்பட்ட ஆறு இலக்க OTP ஐ உள்ளிடவும்',
            next: 'அடுத்தது',
            signUpGoogle: 'கூகுள் மூலம் பதிவுபெறுக',
            signUpLinkeIn: 'லிங்க்ட்இன் மூலம் பதிவுபெறுக',
            jodoteam: 'ஜோடோ டீம்',
            jodoindi: 'ஜோடோலிங்க் தனிநபர்',
            jodolink: 'ஜோடோலிங்க்',
            wordpress: 'வேர்ட்பிரஸ்',
            yourInformation: 'உங்களுடைய தகவல்',
            otpverify: 'OTP சரிபார்',
            signup: 'பதிவு',
            resendotp: 'ஓடிபியை மீண்டும் அனுப்பு',
            billingDetails: 'பில்லிங் விவரங்கள்',
            setupJodoLink: 'ஜோடோலிங்கை அமைக்கவும்',
            setupJodoTeam: 'ஜோடோ குழுவை அமைக்கவும்',
            setupDomainName: 'செயல்முறையை முடிக்க',
            username: 'பெயர்',
            lastName: 'இறுதி பெயர்',
            setPassword: 'கடவுச்சொல்',
            confirmPassword: 'கடவுச்சொல்லை உறுதிப்படுத்து',
            designation: 'தலைப்பு/பதவி',
            country: 'நாடு',
            state: 'நிலை',
            city: 'நகரம்',
            zipcode: 'ஜிப் குறியீடு',
            address1: 'முகவரி 1',
            address2: 'முகவரி 2',
            back: 'மீண்டும்',
            finish: 'பினிஷ்',
            passwordRule1: '1) உங்கள் கடவுச்சொல்லில் 8 எழுத்துகள், ஒரு பெரிய எழுத்து, ஒரு சிறிய எழுத்து, ஒரு எண் மற்றும் ஒரு சிறப்பு எழுத்து எழுத்து இருக்க வேண்டும்',
            passwordRule2: 'கடவுச்சொல் மற்றும் உறுதிப்படுத்தல் கடவுச்சொல் ஒரே மாதிரியாக இருக்க வேண்டும்.',
            passwordmatchAlert: 'கடவுச்சொல் மற்றும் உறுதிப்படுத்தல் கடவுச்சொற்கள் பொருந்தவில்லை',
            passwordmatchSuccess: 'கடவுச்சொல் மற்றும் கடவுச்சொல் பொருந்தியதை உறுதிப்படுத்தவும்!',
            typeCityName: 'உங்கள் நகரத்தின் பெயரை உள்ளிடவும்',
            companyName: 'நிறுவனத்தின் பெயர்',
            taxNo: 'வரி எண்.',
            billingDetailsLocationMsg: 'உங்கள் பில்லிங் முகவரி உங்கள் தகவல் பிரிவில் வழங்கப்பட்டுள்ளதா?',
            domainName: 'டொமைன் பெயர்',
            verifyBtn: 'சரிபார்',
            uniqueCompanyName: 'தனித்துவ நிறுவன ஐடி',
            uniqueURL: 'தனித்துவ URL',
            uniqueUserName: 'தனிப்பட்ட பயனர் ஐடி',
            firstNameRequired: 'முதல் பெயர் தேவை',
            firstNameSpaceValidation: 'பெயரின் தொடக்கத்திலோ முடிவிலோ இடத்தைப் பயன்படுத்த முடியாது.',
            lastNameRequired: 'இயற்பெயர் தேவை',
            twentyFiveCharValidation: '25 எழுத்துகள் அல்லது அதற்கும குறைவாக இருக்க வேண்டும்',
            firstName_lastName_RegexValidation: 'பெயரில் எழுத்துக்களை மட்டுமே பயன்படுத்த முடியும்.',
            passwordRegexValidation: '8 எழுத்துகள், ஒரு பெரிய எழுத்து, ஒரு சிறிய எழுத்து, ஒரு எண் மற்றும் ஒரு சிறப்பு எழுத்து எழுத்துகள் இருக்க வேண்டும்',
            confirmPasswordMatchValidation: 'கடவுச்சொல் மற்றும் உறுதிப்படுத்தல் கடவுச்சொல் ஒரே மாதிரியாக இருக்க வேண்டும்.',
            passwordRequired: 'கடவுச்சொல் தேவை',
            confirmPasswordRequired: 'கடவுச்சொல்லை உறுதிப்படுத்துவது அவசியம்',
            zipcodeCharLengthValidation: '10 எண்கள் அல்லது அதற்கும் குறைவாக இருக்க வேண்டும்',
            zipCodeValidation: 'தவறான ஜிப்கோடு',
            zipNumberVAlidation: 'எண் மட்டுமே பயன்படுத்த முடியும்.',
            zipcodeRegexValidation: 'குறைந்தபட்சம் 4 எண்கள் மற்றும் அதிகபட்சம் 10 எண்கள் அனுமதிக்கப்படும்',
            addressCharLengthValidation: '100 எழுத்துகள் அல்லது அதற்கும் குறைவாக இருக்க வேண்டும்',
            companyNameRequired: 'நிறுவனத்தின் பெயர் தேவை',
            companyName_RegexValidation: 'எண்ணெழுத்து எழுத்துக்கள் மற்றும் சிறப்பு எழுத்துக்கள் [-, @, #, &,!] மட்டுமே பயன்படுத்த முடியும்.',
            orgAliasRequired: 'அமைப்பு மாற்றுப்பெயர் தேவை',
            userAliasRequired: 'பயனர் மாற்றுப்பெயர் தேவை',
            aliasRegexValidation: 'எண்ணெழுத்து எழுத்துக்களைக் கொண்டிருக்க வேண்டும். சிறப்பு எழுத்துகள் மற்றும் இடம் அனுமதிக்கப்படவில்லை.',
            domainNameRequired: 'தயவுசெய்து டொமைன் பெயரைக் குறிப்பிடவும்.',
            domainNameRegexValidation: 'டொமைன் பெயர் `https://www.example.com` வகையாக இருக்க வேண்டும்',
            loadingMsgOne: 'தயவுசெய்து காத்திருக்கவும், உங்கள் கணக்கு உருவாக்கப்படுகிறது,',
            loadingMsgTwo: 'உங்கள் கணக்கு உருவாக்கப்படும்போது, டாக்ஸைப் படித்து, ஜோடோ தயாரிப்பு வீடியோக்களைப் பார்க்கவும்',
            transformsales: 'விற்பனையை மாற்றுதல்',
            transformsupport: 'மாற்ற ஆதரவு',
            transformecommerce: 'ஈ-காமர்ஸை மாற்றவும்',
            emailAuthFailed: 'மின்னஞ்சல் முகவரியை அங்கீகரிப்பதில் தோல்வி. பிறகு முயற்சிக்கவும்.',
            companyNameExistMsg: 'இந்த நிறுவனத்தின் பெயர் ஏற்கனவே பதிவு செய்யப்பட்டுள்ளது.',
            companyAliasVerifiedMsg: 'தனிப்பட்ட நிறுவனத்தின் பெயர் சரிபார்க்கப்பட்டது',
            internalServerErrorMsg: 'உள் சர்வர் பிழை. தயவுசெய்து பின்னர் மீண்டும் முயற்சிக்கவும்',
            invalidOTPMsg: 'தவறான OTP',
            userAlreadyExist: 'பயனர் ஏற்கனவே உள்ளார்',
            uniqueCompanyNameExist: 'தனிப்பட்ட நிறுவனத்தின் பெயர் ஏற்கனவே உள்ளது!',
            uniqueCompanyNameVerified: 'நிறுவனத்தின் பெயர் வெற்றிகரமாக சரிபார்க்கப்பட்டது!',
            uniqueCompanyAliasVerified: 'தனிப்பட்ட நிறுவனத்தின் பெயர் வெற்றிகரமாக சரிபார்க்கப்பட்டது! ',
            otpSendMessage: 'மின்னஞ்சல் சரிபார்ப்பு',
            secondotpSendMessage: 'உங்கள் மின்னஞ்சலுக்கு அனுப்பப்பட்டுள்ளது. உங்கள் மின்னஞ்சல் பெட்டி & குப்பை அஞ்சல் / ஸ்பேம் அஞ்சல் பெட்டி',
            firstNameValidation: 'முதல் பெயர் எழுத்துக்களை மட்டுமே கொண்டிருக்க வேண்டும்',
            lastNameValidation: 'கடைசிப்பெயர் எழுத்துக்களை மட்டுமே கொண்டிருக்க வேண்டும்',
            serviceKeyNotFound: 'சேவை விசை கிடைக்கவில்லை',
            apiKeyNotFound: 'API விசை கிடைக்கவில்லை',
            apiKeyandServiceKeyNotFound: 'சேவை விசை மற்றும்  விசை கிடைக்கவில்லை',
            otpValidationRegex: 'எண் மட்டுமே அனுமதிக்கப்படும்',
            taxNo_RegexValidation: 'எண்ணெழுத்து எழுத்துக்கள் மட்டுமே அனுமதிக்கப்படும்',
            needhelp: 'உதவி தேவை',
            companyName_RegexValidation_2: 'நிறுவனத்தின் பெயருக்கு சிறப்பு எழுத்துக்களை மட்டும் பயன்படுத்த முடியாது.',
            companyNameLengthValidation: '150 எழுத்துகள் அல்லது அதற்கும் குறைவாக இருக்க வேண்டும்',
            designationLengthValidation: '25 எழுத்துகள் அல்லது அதற்கும் குறைவாக இருக்க வேண்டும்',
            designationFieldValidation: 'குறிப்பு: "மட்டுமே." மற்றும் "-" பிரிப்பான்களாக அனுமதிக்கப்படுகின்றன.',
            addressValidation: 'சரியான முகவரியை உள்ளிடவும்.',
            imageUploadMsg: 'இங்கே கிளிக் செய்யவும் அல்லது ஒரு படத்தை இழுக்கவும்',
            imageUploadMsgRemoveBtn: 'நீக்கு',
            imageUploadMsgDoneBtn: 'முடிந்தது',
            transformSales: 'விற்பனையை மாற்றுதல்',
            transformSupport: 'மாற்ற ஆதரவு',
            transformCommerce: 'ஈ-காமர்ஸை மாற்றவும்',
            countryFieldValidation: "நாடு தேவை",
            stateFieldValidation: "மாநிலம் தேவை",
            alreadyacccreated: "ஏற்கனவே ஒரு கணக்கு உள்ளதா?"
        }
    }

}

export default translations;